// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Conversation, Message, Resource } from '@the-real-insight/tri-model';
import ScrollToBottomButton from './ScrollToBottomButton';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChatConversation } from './ChatConversation';
import { ChecklistRunner, resolveChecklistFields } from './ChecklistRunner';
import { ProcessHistoryModal } from './ProcessHistoryModal';
import { Suggestion, Suggestions } from './Suggestions';
import { authenticationAtom } from '../State';
import { useModalContext } from './ModalProvider';
import { useAtom } from 'jotai';
import { MessageType } from '@the-real-insight/tri-model';




import { useTranslation } from 'react-i18next';
import { userAPI, type TaskForm, type TaskSelectOption } from '../UserAPI';
import { abortableSleep, waitForRunToFinish } from '../followConversationRun';
import { FileTooLargeError, TaskCompletionInterruptedError } from '../general/Errors';
import {
    allowedMimeTypes,
    contextUploadAccept,
    formatMegabytes,
    isValidContextFile,
} from './contextFileTypes';
import { describeStorageAttachSkips, readSkippedDetails } from './storageAttachSkips';
import { useSpeech } from '../Speech';

import i18next from 'i18next';


import tinycolor from 'tinycolor2';
import { useCustomerTheme } from '../Theme';
import { configuration } from '../Configuration';
import { isSourceResource } from '../utils/sourceResource';
import { groupPayloadResources } from './chat/payloadResources';
import { guideLocale } from '../guide/guideBlocks';
import { planGuideRelease, rememberGuideBlocks, type PendingGuideBlocks } from './chat/guideRelease';
import { requestAutoNavigate, useAutoNavigateRunner } from '../guide/autoNavigate';
import { useChatSendRunner } from '../guide/chatSend';
import { requestSpotlight } from '../guide/spotlight';
import { collapseRunawayCharRuns } from '../utils/collapseRunawayCharRuns';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { LLMSelector } from './LLMSelector';
import { ToolSelector, CustomerToolOption } from './ToolSelector';
import { ToolMentionChips, ToolMentionMenu, useToolMentions } from './ToolMentions';
import { findMentionedTools } from './toolMentionText';
import StorageFilePickerDialog, { StoragePickResult } from './StorageFilePickerDialog';
import { LLM } from '../enums/LLM';

import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { DataTable } from '@/components/ui/data-table';
import type { Column, ColumnDef } from '@tanstack/react-table';
import { DataPoolCopyableCell } from './DataPoolCopyableCell';
import { authenticatedFetch } from '../JWTAuthService';
import { getClientBotConfig, submitClientBotTask, sendBrowserBotApproval } from '../clientBot';
import {
    ChatRun,
    ChatRunMap,
    ensureChatRun,
    finishChatRun,
    getChatRun,
    isChatRunPending,
    isDisplayedConversation,
    runningConversationIds,
    sameConversationIds,
    shouldShowProcessCompletionDialog,
} from '../chatRuns';
import io from 'socket.io-client';
import { useGeolocation } from '../hooks/useGeolocation';
import { isSystemAdminUser } from '../hooks/useRoleAccess';
import {
    ArrowDown,
    ArrowUp,
    ArrowUpDown,
    Check,
    ChevronDown,
    ChevronRight,
    ChevronUp,
    CircleAlert,
    CircleStop,
    CloudUpload,
    Database,
    FileText,
    Folder,
    History,
    Loader2,
    Mic,
    Paperclip,
    RefreshCw,
    Rocket,
    Send,
    Square,
    Trash2,
    Undo2,
    X,
    XCircle,
} from "lucide-react";
import { AnimatePresence, motion, useReducedMotion } from "motion/react";
import { toast } from "sonner";
import { BACKGROUND_JOB_FINISHED_EVENT } from "../BackgroundJobsAPI";
import { Button } from "@/components/ui/button";
import { TaskSelectAnswer } from "./TaskSelectAnswer";
import { TaskFormAnswer } from "./TaskFormAnswer";
import { Button as MotionButton } from "@/components/motion/button";
import { ChatPromptField } from "./ChatPromptField";
import { composerWidthClass } from "./chat/composerWidth";
import { EASE_OUT, SPRING_SWAP } from "@/lib/ease";
import { Alert, AlertDescription } from "@/components/ui/alert";
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { Popover, PopoverAnchor, PopoverContent } from "@/components/ui/popover";
import { ConversationDocumentsContext } from "@/documentViewer/DocumentViewerContext";
import type { ConversationDocument } from "@/documentViewer/documentMentions";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
// Shadow resources handle uploads automatically

/** Ersatz für den Fluent-`TooltipHost`: gleiches Aufrufmuster (content + Kinder). */
function TooltipHost({ content, children }: { content: React.ReactNode; children: React.ReactNode }) {
    return (
        <TooltipProvider delayDuration={300}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <span className="inline-flex">{children}</span>
                </TooltipTrigger>
                <TooltipContent>{content}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}

/**
 * Klickbarer Spaltenkopf — `ui/data-table` zeichnet selbst keine Sortierköpfe,
 * die abgelöste Tabelle tat es. Gleiche Semantik: erster Klick aufsteigend,
 * zweiter absteigend.
 */
function SortableHeader({ column, children }: { column: Column<any, unknown>; children: React.ReactNode }) {
    const sorted = column.getIsSorted();

    return (
        <Button
            variant="ghost"
            size="sm"
            type="button"
            className="-mx-4 h-8 max-w-full gap-1 px-4 font-medium"
            onClick={() => column.toggleSorting(sorted === 'asc')}
        >
            <span className="min-w-0 overflow-hidden text-ellipsis whitespace-nowrap">{children}</span>
            {sorted === 'asc' ? (
                <ArrowUp aria-hidden className="h-3.5 w-3.5 shrink-0" />
            ) : sorted === 'desc' ? (
                <ArrowDown aria-hidden className="h-3.5 w-3.5 shrink-0" />
            ) : (
                <ArrowUpDown aria-hidden className="h-3.5 w-3.5 shrink-0 opacity-50" />
            )}
        </Button>
    );
}

// Add CSS for animations - prevent duplicate injection
const animationStyles = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}
`;

// Inject the CSS into the document head only if not already present
if (typeof document !== 'undefined') {
  const existingStyle = document.querySelector('style[data-animation-styles]');
  if (!existingStyle) {
    const styleElement = document.createElement('style');
    styleElement.setAttribute('data-animation-styles', 'true');
    styleElement.textContent = animationStyles;
    document.head.appendChild(styleElement);
  }
}

const _userContext = { firstName: 'Marc', lastName: 'Gille-Sepehri', email: 'marc@thing-it.com', mesh: '65093dfececde3b84a486809' }

// Helper function to clone conversation object since Conversation class doesn't have clone method
const cloneConversation = (conversation: any) => {
    if (!conversation) return conversation;
    
    // Create a new Conversation instance with cloned data
    const cloned = new Conversation(conversation);
    
    // Copy messages array (shallow copy)
    if (conversation.messages) {
        cloned.messages = [...conversation.messages];
    }
    
    if (conversation.contextDocuments) {
        cloned.contextDocuments = [...conversation.contextDocuments];
    }
    
    return cloned;
};

const getContextDocumentKey = (doc: any) => {
    if (!doc) {
        return null;
    }
    
    if (typeof doc.filename === 'string' && doc.filename.trim().length > 0) {
        return doc.filename.toLowerCase();
    }
    
    if (doc._id) {
        return String(doc._id);
    }
    
    return null;
};

const shouldCollapseContextDocuments = (conversation: any) => {
    const contextDocumentCount = conversation?.contextDocuments?.length ?? 0;
    const messageCount = conversation?.messages?.length ?? 0;

    return contextDocumentCount > 1 && messageCount > 0;
};

const USER_ABORT_REASON = 'user-stop';
const TIMEOUT_ABORT_REASON = 'request-timeout';
const STREAM_STALL_RECONNECT_REASON = 'stream-stall-reconnect';
const MANUAL_RECONNECT_REASON = 'manual-reconnect';
const STREAM_STALL_RECONNECT_AFTER_MS = 60_000;
const STREAM_STALL_CHECK_INTERVAL_MS = 5_000;
type RequestAbortReason =
    | typeof USER_ABORT_REASON
    | typeof TIMEOUT_ABORT_REASON
    | typeof STREAM_STALL_RECONNECT_REASON
    | typeof MANUAL_RECONNECT_REASON;

const getRequestAbortReason = (value: unknown): RequestAbortReason | null => {
    if (
        value === USER_ABORT_REASON ||
        value === TIMEOUT_ABORT_REASON ||
        value === STREAM_STALL_RECONNECT_REASON ||
        value === MANUAL_RECONNECT_REASON
    ) {
        return value;
    }

    if (value instanceof Error) {
        return getRequestAbortReason(value.message);
    }

    return null;
};

const isAbortError = (error: unknown): error is Error =>
    error instanceof Error && (
        error.name === 'AbortError' ||
        error.message?.includes('aborted') ||
        error.message?.includes('cancelled')
    );

const isReconnectableStreamError = (error: unknown): boolean => {
    const normalizedError = typeof error === 'string'
        ? error.toLowerCase()
        : error instanceof Error
            ? `${error.name} ${error.message}`.toLowerCase()
            : typeof (error as { message?: unknown } | null)?.message === 'string'
                ? String((error as { message: string }).message).toLowerCase()
                : '';
    const errorName = error instanceof Error
        ? error.name.toLowerCase()
        : typeof (error as { name?: unknown } | null)?.name === 'string'
            ? String((error as { name: string }).name).toLowerCase()
            : '';
    const isGenericTypeError = errorName === 'typeerror';

    return normalizedError.includes('timed out') ||
        normalizedError.includes('err_incomplete_chunked_encoding') ||
        normalizedError.includes('incomplete chunked encoding') ||
        normalizedError.includes('failed to fetch') ||
        normalizedError.includes('networkerror when attempting to fetch resource') ||
        normalizedError.includes('network request failed') ||
        normalizedError.includes('load failed') ||
        normalizedError.includes('terminated') ||
        (isGenericTypeError && normalizedError.trim() === 'typeerror');
};

const createLinkedAbortSignal = (...signals: AbortSignal[]) => {
    const controller = new AbortController();

    const abortFromSignal = (signal: AbortSignal) => {
        if (!controller.signal.aborted) {
            controller.abort(signal.reason);
        }
        cleanup();
    };

    const onAbort = (event: Event) => {
        abortFromSignal(event.target as AbortSignal);
    };

    const cleanup = () => {
        signals.forEach((signal) => signal.removeEventListener('abort', onAbort));
    };

    for (const signal of signals) {
        if (signal.aborted) {
            abortFromSignal(signal);
            return { signal: controller.signal, cleanup };
        }

        signal.addEventListener('abort', onAbort, { once: true });
    }

    return { signal: controller.signal, cleanup };
};

// Simplified architecture - no global state tracking needed

interface Properties {
    conversation: Conversation;
    showSuggestions: boolean;
    showLogo: boolean;
    height?: string;
    fullWidth?: boolean;
    resourceSelected?: (resource: any) => void;
    updateConversation?: (conversation: Conversation) => void;
    createConversation?: () => void;
    onCompleteTaskClosed?: () => Promise<void>;
    /** Called when the stream completes (endOfMessage). Use to refresh conversations list so processInstance/worklist are picked up. */
    onStreamComplete?: () => void;
    /**
     * Ids of the conversations being worked on right now — an LLM run, or files
     * uploading/being processed — several at the same time. The sidebar marks
     * them, since the in-conversation progress is only drawn inside its own
     * conversation.
     */
    onRunningConversationsChange?: (conversationIds: string[]) => void;
    /**
     * Reloads a conversation the way opening it does (worklist → active task). Used when a turn
     * that ran on the server without this tab's stream has finished (see followConversationRun).
     */
    reloadConversation?: (conversationId: string) => Promise<unknown>;
    sampleRequests?: string[];
    toolsFilter?: any;
    /** When this value changes, the chat input will be focused (e.g. after selecting a worklist task). */
    inputFocusTrigger?: number;
    /** When this value changes, scroll to end (e.g. after task activation message is added). */
    scrollToEndTrigger?: number;
    /** Called when user selects a task from the worklist popup (when multiple tasks exist). */
    onWorklistTaskSelect?: (task: any) => void;
    customerTools?: CustomerToolOption[];
    customerToolsLoading?: boolean;
    selectedToolId?: string;
    onToolChange?: (toolId: string) => void;
    /**
     * Read-only: show the conversation, refuse to write into it.
     *
     * Set where a conversation may be *read* but not *acted on* — the tender board embeds this
     * component for every process conversation the user is allowed to see, and in a process
     * conversation writing IS answering the open task. Whoever holds no open task here would
     * otherwise be able to push the process forward from a row they were only meant to look at.
     * The caller decides with the server's own worklist (`isTaskForUser`), so this mirrors exactly
     * what the chat's "Prozesse" list would show.
     */
    readOnly?: boolean;
    /** Shown instead of the input when `readOnly`. */
    readOnlyHint?: string;
    /**
     * Hide the per-message action bar (sources toggle, feedback, copy).
     *
     * For embedded use: in the tender board the conversation sits inside a row that already has
     * the tender's own controls, and a second set per message competes with them.
     */
    hideMessageActions?: boolean;
}

/**
 * End-user-friendly description for a pending bot approval. Translates
 * raw tool calls (`browser_type_by_role(role=textbox, name=Email, …)`)
 * into prose the modeler will recognize as the demonstrated step.
 *
 * Falls back to "Run <tool>" with a minimal arg summary when the tool
 * isn't one we recognise — keeps unknown tools approvable without dumping
 * raw JSON into the chat.
 */
function renderApprovalSummary(
    toolName: string,
    rawInput: unknown,
    // i18next's TFunction has a complex overloaded type; for our purposes
    // the (key, fallback) signature is what matters at runtime.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    t: any,
): React.ReactNode {
    const inp = (rawInput && typeof rawInput === 'object') ? rawInput as Record<string, any> : {};
    const role = humanizeRole(String(inp.role ?? ''), t);
    const Quoted = ({ children }: { children: React.ReactNode }) => (
        <strong className="text-foreground">{children}</strong>
    );

    switch (toolName) {
        case 'browser_navigate':
            return (
                <span>
                    {t('chatBotPage.botApproval.navigate', 'Open the page')}{' '}
                    <Quoted>{String(inp.url ?? '')}</Quoted>
                </span>
            );
        case 'browser_click_by_role':
        case 'browser_click':
            if (toolName === 'browser_click_by_role') {
                return (
                    <span>
                        {t('chatBotPage.botApproval.click', 'Click on')}{' '}
                        <Quoted>{String(inp.name ?? '')}</Quoted>
                        {role ? <span className="text-muted-foreground"> ({role})</span> : null}
                    </span>
                );
            }
            return (
                <span>
                    {t('chatBotPage.botApproval.clickElement', 'Click an element')}{' '}
                    <code className="text-xs text-muted-foreground">{String(inp.selector ?? '')}</code>
                </span>
            );
        case 'browser_type_by_role':
        case 'browser_type': {
            const value = String(inp.value ?? '');
            const truncated = value.length > 80 ? value.slice(0, 77) + '…' : value;
            if (toolName === 'browser_type_by_role') {
                return (
                    <span>
                        {t('chatBotPage.botApproval.fill', 'Fill')}{' '}
                        <Quoted>{String(inp.name ?? '')}</Quoted>
                        {role ? <span className="text-muted-foreground"> ({role})</span> : null}{' '}
                        {t('chatBotPage.botApproval.with', 'with')}{' '}
                        <Quoted>{truncated}</Quoted>
                    </span>
                );
            }
            return (
                <span>
                    {t('chatBotPage.botApproval.fillField', 'Fill the field')}{' '}
                    <code className="text-xs text-muted-foreground">{String(inp.selector ?? '')}</code>{' '}
                    {t('chatBotPage.botApproval.with', 'with')}{' '}
                    <Quoted>{truncated}</Quoted>
                </span>
            );
        }
        case 'browser_select_by_role':
            return (
                <span>
                    {t('chatBotPage.botApproval.choose', 'Choose')}{' '}
                    <Quoted>{String(inp.optionLabel ?? '')}</Quoted>{' '}
                    {t('chatBotPage.botApproval.in', 'in')}{' '}
                    <Quoted>{String(inp.name ?? '')}</Quoted>
                    {role ? <span className="text-muted-foreground"> ({role})</span> : null}
                </span>
            );
        case 'browser_submit_form':
            return inp.formLabel ? (
                <span>
                    {t('chatBotPage.botApproval.submitForm', 'Submit the form')}{' '}
                    <Quoted>{String(inp.formLabel)}</Quoted>
                </span>
            ) : (
                <span>{t('chatBotPage.botApproval.submitFormNoLabel', 'Submit the form')}</span>
            );
        case 'browser_screenshot':
            return <span>{t('chatBotPage.botApproval.screenshot', 'Take a screenshot of the page')}</span>;
        case 'browser_read_page':
            return <span>{t('chatBotPage.botApproval.readPage', 'Read the page contents')}</span>;
        case 'browser_wait_for': {
            if (inp.urlIncludes) {
                return (
                    <span>
                        {t('chatBotPage.botApproval.waitForUrl', 'Wait until the URL contains')}{' '}
                        <Quoted>{String(inp.urlIncludes)}</Quoted>
                    </span>
                );
            }
            if (inp.selector) {
                return (
                    <span>
                        {t('chatBotPage.botApproval.waitForElement', 'Wait for an element')}{' '}
                        <code className="text-xs text-muted-foreground">{String(inp.selector)}</code>
                    </span>
                );
            }
            return <span>{t('chatBotPage.botApproval.wait', 'Wait')}</span>;
        }
        case 'read_process_variable':
            return (
                <span>
                    {t('chatBotPage.botApproval.readVar', 'Look up')}{' '}
                    <Quoted>{String(inp.path ?? '')}</Quoted>{' '}
                    {t('chatBotPage.botApproval.fromData', 'from the process data')}
                </span>
            );
        case 'report_walkthrough_deviation':
            return (
                <span>
                    {t('chatBotPage.botApproval.reportDeviation', 'Report a deviation from the walkthrough at step')}{' '}
                    <Quoted>{String(inp.stepNumber ?? '?')}</Quoted>
                </span>
            );
        default: {
            // Unknown tool — render the name humanly and a compact arg summary.
            const args = Object.entries(inp)
                .filter(([k]) => k !== '__proto__')
                .slice(0, 3)
                .map(([k, v]) => `${k}: ${shortArg(v)}`)
                .join(', ');
            return (
                <span>
                    {t('chatBotPage.botApproval.run', 'Run')}{' '}
                    <Quoted>{toolName}</Quoted>
                    {args ? <span className="text-muted-foreground"> ({args})</span> : null}
                </span>
            );
        }
    }
}

/**
 * Plain-text variant of renderApprovalSummary for the streaming progress
 * lines (which are HTML-escaped and can't carry React nodes). Same i18n
 * keys, same prose, no markup.
 */
function toolCallToText(toolName: string, rawInput: unknown, t: any): string {
    const inp = (rawInput && typeof rawInput === 'object') ? rawInput as Record<string, any> : {};
    const role = humanizeRole(String(inp.role ?? ''), t);
    const trunc = (s: string, n = 80) => s.length > n ? s.slice(0, n - 1) + '…' : s;
    const named = role ? `${inp.name ?? ''} (${role})` : `${inp.name ?? ''}`;
    switch (toolName) {
        case 'browser_navigate':
            return `${t('chatBotPage.botApproval.navigate', 'Open the page')} ${inp.url ?? ''}`;
        case 'browser_click_by_role':
            return `${t('chatBotPage.botApproval.click', 'Click on')} ${named}`;
        case 'browser_click':
            return `${t('chatBotPage.botApproval.clickElement', 'Click an element')} ${inp.selector ?? ''}`;
        case 'browser_type_by_role':
            return `${t('chatBotPage.botApproval.fill', 'Fill')} ${named} ${t('chatBotPage.botApproval.with', 'with')} ${trunc(String(inp.value ?? ''))}`;
        case 'browser_type':
            return `${t('chatBotPage.botApproval.fillField', 'Fill the field')} ${inp.selector ?? ''} ${t('chatBotPage.botApproval.with', 'with')} ${trunc(String(inp.value ?? ''))}`;
        case 'browser_select_by_role':
            return `${t('chatBotPage.botApproval.choose', 'Choose')} ${inp.optionLabel ?? ''} ${t('chatBotPage.botApproval.in', 'in')} ${named}`;
        case 'browser_submit_form':
            return inp.formLabel
                ? `${t('chatBotPage.botApproval.submitForm', 'Submit the form')} ${inp.formLabel}`
                : t('chatBotPage.botApproval.submitFormNoLabel', 'Submit the form');
        case 'browser_screenshot':
            return t('chatBotPage.botApproval.screenshot', 'Take a screenshot of the page');
        case 'browser_read_page':
            return t('chatBotPage.botApproval.readPage', 'Read the page contents');
        case 'browser_wait_for':
            if (inp.urlIncludes) return `${t('chatBotPage.botApproval.waitForUrl', 'Wait until the URL contains')} ${inp.urlIncludes}`;
            if (inp.selector) return `${t('chatBotPage.botApproval.waitForElement', 'Wait for an element')} ${inp.selector}`;
            return t('chatBotPage.botApproval.wait', 'Wait');
        case 'read_process_variable':
            return `${t('chatBotPage.botApproval.readVar', 'Look up')} ${inp.path ?? ''} ${t('chatBotPage.botApproval.fromData', 'from the process data')}`;
        case 'report_walkthrough_deviation':
            return `${t('chatBotPage.botApproval.reportDeviation', 'Report a deviation from the walkthrough at step')} ${inp.stepNumber ?? '?'}`;
        default:
            return `${t('chatBotPage.botApproval.run', 'Run')} ${toolName}`;
    }
}

const APPROVAL_CANONICAL_ROLES = [
    'button',
    'link',
    'tab',
    'menuitem',
    'checkbox',
    'radio',
    'switch',
    'option',
    'textbox',
    'searchbox',
    'combobox',
    'listbox',
    'spinbutton',
    'region',
    'main',
    'dialog',
    'navigation',
    'form',
] as const;

const APPROVAL_CANONICAL_ROLE_SET = new Set<string>(APPROVAL_CANONICAL_ROLES);

const APPROVAL_ROLE_SYNONYMS: Record<string, string> = {
    // Canonical WAI-ARIA role aliases (spacing variants from captured logs).
    'menu item': 'menuitem',
    'text box': 'textbox',
    'search box': 'searchbox',
    'combo box': 'combobox',
    'spin button': 'spinbutton',
    // Legacy localized role labels from recorded walkthrough payloads.
    'menupunkt': 'menuitem',
    'textfeld': 'textbox',
    'suchfeld': 'searchbox',
    'dropdown': 'combobox',
    'liste': 'listbox',
    'zahler': 'spinbutton',
    'bereich': 'region',
    'hauptbereich': 'main',
    'formular': 'form',
    // Legacy English display labels (historically persisted in some payloads).
    'text field': 'textbox',
    'search field': 'searchbox',
    'main area': 'main',
};

function normalizeRoleToken(value: string): string {
    return value
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ');
}

function getApprovalRoleAliases(): Record<string, string> {
    const aliases: Record<string, string> = { ...APPROVAL_ROLE_SYNONYMS };
    for (const role of APPROVAL_CANONICAL_ROLES) {
        aliases[normalizeRoleToken(role)] = role;
    }

    const resources = i18next.options.resources as Record<string, any> | undefined;
    if (resources) {
        for (const localeResource of Object.values(resources)) {
            const localizedRoles = localeResource?.translation?.chatBotPage?.browserBot?.roles;
            if (!localizedRoles || typeof localizedRoles !== 'object') {
                continue;
            }

            for (const [canonicalRole, localizedLabel] of Object.entries(localizedRoles)) {
                if (!APPROVAL_CANONICAL_ROLE_SET.has(canonicalRole) || typeof localizedLabel !== 'string') {
                    continue;
                }

                const normalizedLabel = normalizeRoleToken(localizedLabel);
                if (normalizedLabel) {
                    aliases[normalizedLabel] = canonicalRole;
                }
            }
        }
    }

    return aliases;
}

function roleFallbackFromName(roleName: string): string {
    return roleName
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim()
        .replace(/\b[a-z]/g, (match) => match.toUpperCase());
}

// i18next's TFunction has overloaded return types; for these call sites the
// string-returning (key, fallback) signature is sufficient.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function humanizeRole(role: string, t: any): string {
    const normalizedRole = normalizeRoleToken(role);
    if (!normalizedRole) return '';

    const resolvedRole = getApprovalRoleAliases()[normalizedRole] ?? normalizedRole;
    const roleFallback = roleFallbackFromName(resolvedRole);

    return t(`chatBotPage.browserBot.roles.${resolvedRole}`, roleFallback);
}

function shortArg(value: unknown): string {
    if (typeof value === 'string') {
        return value.length > 30 ? `"${value.slice(0, 27)}…"` : `"${value}"`;
    }
    try {
        const j = JSON.stringify(value);
        return j.length > 30 ? j.slice(0, 27) + '…' : j;
    } catch {
        return String(value);
    }
}

export const ChatExchange = (properties: Properties) => {
    const { t } = useTranslation();
    const { showMessageDialog } = useModalContext() as any;
    const [_locale] = useState(i18next.resolvedLanguage);
    const [authentication] = useAtom(authenticationAtom) as any;
    const { theme } = useCustomerTheme();
    // Best-effort device geolocation; when available it is added to the request
    // context's `location` as lat/lon. Kept in a ref so submitInput reads the
    // latest coords without widening its dependency array.
    const { coords: geoCoords, locate: geoLocate } = useGeolocation();
    const geoCoordsRef = useRef(geoCoords);
    geoCoordsRef.current = geoCoords;
    useEffect(() => {
        // Fires the permission prompt once on mount; failures are silent.
        geoLocate();
    }, [geoLocate]);
    /**
     * Portal guide, stage 2: the effect that executes a registered auto-jump.
     * It holds `useGuideNavigate` — a hook that must not live in the stream
     * parser below (`src/guide/autoNavigate.ts`).
     */
    useAutoNavigateRunner();
    /**
     * The guide blocks the running answer has reported, per conversation.
     *
     * Per conversation, because this component runs several streams at once
     * (`runsRef`): a background run must not overwrite the pointer of the open
     * conversation. Both are only redeemed at `endOfMessage` — before that the
     * answer isn't complete, and a jump mid-stream would take away the very
     * sentence that explains the way to the user.
     *
     * The entry carries the `requestId` of its turn. Otherwise a stream that
     * ends without `endOfMessage` (user stop, timeout, exhausted retries) would
     * leave it lying around, and the **next** answer in the same conversation
     * would fire it — see `chat/guideRelease.ts`.
     */
    const guideBlocksRef = useRef<Map<unknown, PendingGuideBlocks>>(new Map());
    /**
     * Redeem the pointer and auto-jump of the finished answer.
     *
     * The decision itself — does the entry belong to this turn, is the
     * conversation on screen, what is the idempotency key — is a pure function
     * (`chat/guideRelease.ts`) and tested there. All that remains here is
     * executing it.
     *
     * `requestAutoNavigate` returns `null` if this key has already had its turn
     * (a stream retry delivers the same payload again). Then the pointer stays,
     * the jump doesn't.
     */
    const releaseGuideBlocks = useCallback((conversationId: unknown, requestId: number, messageIndex: number) => {
        const plan = planGuideRelease({
            pending: guideBlocksRef.current.get(conversationId),
            conversationId,
            requestId,
            messageIndex,
            isDisplayed: isDisplayedConversation(conversationId, conversationRef.current?._id),
            locale: guideLocale(i18next.resolvedLanguage),
        });
        if (plan.drop) guideBlocksRef.current.delete(conversationId);
        if (plan.navigate) {
            const claimed = requestAutoNavigate({
                href: plan.navigate.href,
                key: plan.navigate.key,
                spotlight: plan.spotlight ?? undefined,
            });
            if (claimed) return;
        }
        if (plan.spotlight) requestSpotlight(plan.spotlight);
    }, []);
    const [conversation, setConversationState] = useState<any>(properties.conversation);
    const conversationRef = useRef<any>(properties.conversation);
    conversationRef.current = conversation;
    // A request belongs to its conversation, not to this component: runs are
    // keyed by conversation id so switching conversations neither shows another
    // conversation's progress dots nor stops a second conversation from being
    // started while the first one still streams.
    const runsRef = useRef<ChatRunMap>(new Map());
    const [runningConversations, setRunningConversations] = useState<string[]>([]);
    const displayedConversationId = conversation?._id ?? null;
    const displayedRun = getChatRun(runsRef.current, displayedConversationId);
    const pendingRequest = isChatRunPending(runsRef.current, displayedConversationId);
    const manualReconnectAvailable = displayedRun?.manualReconnectAvailable === true;
    const publishRunningConversations = useCallback(() => {
        const ids = runningConversationIds(runsRef.current);
        setRunningConversations(previous => (sameConversationIds(previous, ids) ? previous : ids));
    }, []);
    /** Starts/ends the run of one conversation and republishes the sidebar state. */
    const setRunPending = useCallback((conversationId: unknown, pending: boolean): ChatRun => {
        const run = ensureChatRun(runsRef.current, conversationId);
        if (pending) {
            run.pending = true;
        } else {
            finishChatRun(runsRef.current, conversationId);
        }
        publishRunningConversations();
        return run;
    }, [publishRunningConversations]);
    const setManualReconnectAvailable = useCallback((conversationId: unknown, available: boolean) => {
        const run = ensureChatRun(runsRef.current, conversationId);
        if (run.manualReconnectAvailable === available) return;
        run.manualReconnectAvailable = available;
        // Only the affordance of the open conversation is on screen, but the flag
        // has to be published so it appears when the user switches back to it.
        setRunningConversations(previous => [...previous]);
    }, []);
    const textField = useRef<any>(null);
    /** `prefers-reduced-motion` — der Wechsel Senden↔Anhalten schaltet danach ab. */
    const reduceMotion = useReducedMotion() ?? false;
    const setConversation = useCallback((convOrUpdater: any) => {
        setConversationState((prev: any) => {
            const next = typeof convOrUpdater === 'function' ? convOrUpdater(prev) : convOrUpdater;
            conversationRef.current = next;
            return next;
        });
    }, []);
    const mergePendingContextDocuments = useCallback((
        incomingConversation: Conversation | null,
        options?: { dropPendingFilenames?: string[] }
    ): Conversation | null => {
        if (!incomingConversation) {
            return incomingConversation;
        }

        const previousConversation = conversationRef.current;
        const previousDocs = Array.isArray(previousConversation?.contextDocuments)
            ? previousConversation.contextDocuments
            : [];

        if (!previousDocs.length) {
            return incomingConversation;
        }

        const pendingDocs = previousDocs.filter((doc: any) => doc?.isUploading && doc?.status !== 'completed');

        if (!pendingDocs.length) {
            return incomingConversation;
        }

        const dropPendingFilenames = new Set(
            (options?.dropPendingFilenames || [])
                .filter((filename): filename is string => typeof filename === 'string' && filename.trim().length > 0)
                .map(filename => filename.toLowerCase())
        );

        const incomingDocs = Array.isArray(incomingConversation.contextDocuments)
            ? incomingConversation.contextDocuments
            : [];
        const incomingDocKeys = new Set(
            incomingDocs
                .map((doc: any) => getContextDocumentKey(doc))
                .filter((key): key is string => Boolean(key))
        );

        const pendingDocsToKeep = pendingDocs.filter((doc: any) => {
            const key = getContextDocumentKey(doc);
            if (key && dropPendingFilenames.has(key)) {
                return false;
            }
            return !key || !incomingDocKeys.has(key);
        });

        if (!pendingDocsToKeep.length) {
            return incomingConversation;
        }

        const mergedConversation = cloneConversation(incomingConversation);
        const existingDocs = Array.isArray(mergedConversation.contextDocuments)
            ? mergedConversation.contextDocuments
            : [];

        mergedConversation.contextDocuments = [...existingDocs, ...pendingDocsToKeep];
        return mergedConversation;
    }, []);

    const applyIncomingConversation = useCallback(
        (
            incomingConversation: Conversation | null,
            options?: { propagate?: boolean; dropPendingFilenames?: string[] }
        ) => {
            if (!incomingConversation) {
                return;
            }

            const conversationToStore = mergePendingContextDocuments(incomingConversation, {
                dropPendingFilenames: options?.dropPendingFilenames,
            });
            if (!conversationToStore) {
                return;
            }

            // Keep a task that is being confirmed in the background from
            // reappearing when its still-finishing upload reports the worklist.
            const completing = backgroundCompletingTaskIdsRef.current;
            if (completing.size > 0 && Array.isArray((conversationToStore as any).worklist)) {
                (conversationToStore as any).worklist = (conversationToStore as any).worklist.filter(
                    (task: any) => !completing.has(String(task?._id))
                );
            }

            const current = conversationRef.current;
            const activeTask = (current as any)?.activeTask;
            const merged = activeTask && conversationToStore._id === current?._id
                ? new Conversation({ ...conversationToStore, activeTask })
                : conversationToStore;

            setConversation(merged);
            conversationRef.current = merged;

            if (options?.propagate !== false && properties.updateConversation) {
                properties.updateConversation(merged as Conversation);
            }
        },
        [mergePendingContextDocuments, properties.updateConversation, setConversation]
    );
    const applyIncomingConversationRef = useRef(applyIncomingConversation);
    useEffect(() => {
        applyIncomingConversationRef.current = applyIncomingConversation;
    }, [applyIncomingConversation]);
    const reloadConversationRef = useRef(properties.reloadConversation);
    reloadConversationRef.current = properties.reloadConversation;
    /**
     * A background job of this conversation ended (LV from an uploaded list): its answer was
     * appended on the server — reload so it shows below the job card.
     */
    useEffect(() => {
        const onJobFinished = (event: Event) => {
            const conversationId = (event as CustomEvent).detail?.conversationId;
            const customer = authentication?.customer;
            if (!conversationId || !customer || String(displayedConversationId ?? '') !== String(conversationId)) return;
            (async () => {
                try {
                    if (reloadConversationRef.current) await reloadConversationRef.current(String(conversationId));
                    else applyIncomingConversationRef.current(await userAPI.getConversation(customer, String(conversationId)));
                } catch (e) {
                    console.error('Reloading the conversation after its background job failed:', e);
                }
            })();
        };
        window.addEventListener(BACKGROUND_JOB_FINISHED_EVENT, onJobFinished);
        return () => window.removeEventListener(BACKGROUND_JOB_FINISHED_EVENT, onJobFinished);
    }, [authentication?.customer, displayedConversationId]);
    /**
     * A turn that runs on the server but not in this tab — after a reload, or a connection that
     * dropped. Show the progress dots while it runs, then reload the conversation, which then holds
     * the answer (src/followConversationRun.ts). A run of this tab has its own stream and is left
     * alone.
     */
    useEffect(() => {
        const conversationId = displayedConversationId ? String(displayedConversationId) : null;
        const customer = authentication?.customer;
        if (!conversationId || !customer) return;
        if (isChatRunPending(runsRef.current, conversationId)) return;
        const controller = new AbortController();
        let following = false;
        void (async () => {
            let running = false;
            try {
                running = (await userAPI.getConversationRun(customer, conversationId, controller.signal)).running;
            } catch {
                return; // no answer (or an older server without the endpoint): nothing to follow
            }
            if (!running || controller.signal.aborted) return;
            // Started a turn of its own in the meantime — its stream shows the answer.
            if (isChatRunPending(runsRef.current, conversationId)) return;
            following = true;
            setRunPending(conversationId, true);
            const outcome = await waitForRunToFinish(
                {
                    checkRun: signal => userAPI.getConversationRun(customer, conversationId, signal),
                    sleep: abortableSleep,
                    now: () => Date.now(),
                },
                controller.signal
            );
            following = false;
            setRunPending(conversationId, false);
            if (outcome === 'aborted') return;
            try {
                if (reloadConversationRef.current) {
                    await reloadConversationRef.current(conversationId);
                } else {
                    applyIncomingConversationRef.current(await userAPI.getConversation(customer, conversationId));
                }
            } catch (e) {
                console.error('Reloading the conversation after its turn finished failed:', e);
            }
        })();
        return () => {
            controller.abort();
            // Switching away must not leave this conversation's dots on in the sidebar.
            if (following) setRunPending(conversationId, false);
        };
        // Only when another conversation is opened; the refs carry the rest.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayedConversationId, authentication?.customer]);
    /**
     * Completing a task lost its connection (TaskCompletionInterruptedError) while the server runs
     * the process on. Wait for that run to end (GET …/run), then load what it wrote — through
     * `reloadConversation`, which sets the next task from the instance's worklist, exactly as a
     * conversation is opened. `null` when there is nothing to follow (an older server without the
     * endpoint, or the reload failed), so the caller reports the failure as before; otherwise
     * whether the process ended, which the caller announces as it does for a normal completion.
     * The progress dots stay on throughout — the caller's `finally` ends them.
     */
    const followInterruptedTaskCompletion = async (
        conversationId: unknown
    ): Promise<{ processEnded: boolean } | null> => {
        const customer = authentication?.customer;
        if (!customer || !conversationId) return null;
        const id = String(conversationId);
        const controller = new AbortController();
        try {
            await userAPI.getConversationRun(customer, id, controller.signal);
        } catch {
            return null;
        }
        const outcome = await waitForRunToFinish(
            {
                checkRun: signal => userAPI.getConversationRun(customer, id, signal),
                sleep: abortableSleep,
                now: () => Date.now(),
            },
            controller.signal
        );
        if (outcome !== 'finished') return null;
        try {
            const fresh = await userAPI.getConversation(customer, id);
            const nextTasks = (fresh as any)?.worklist;
            if (reloadConversationRef.current) {
                await reloadConversationRef.current(id);
            } else {
                applyIncomingConversationRef.current(fresh);
            }
            return { processEnded: !(Array.isArray(nextTasks) && nextTasks.length > 0) };
        } catch (e) {
            console.error('Reloading the conversation after an interrupted task completion failed:', e);
            return null;
        }
    };
    const conversationAreaRef = useRef<HTMLDivElement>(null);
    const [inputValue, setInputValue] = useState('') as any;
    const [_inputFocussed, setInputFocussed] = useState(false);
    const [id, _setId] = useState(null) as any;
    const [requestIndex, setRequestIndex] = useState(0);
    const [requests, setRequests] = useState([]) as any;
    const [_skillAgentResponse, setSkillAgentResponse] = useState(null);
    const [transcribing, setTranscribing] = useState(false);
    const [agent, _setAgent] = useState(null) as any;
    const [chatUpdate, setChatUpdate] = useState(Date.now());
    const [showSuggestions, setShowSuggestions] = useState(false);

    // Offen ist die Vorschlagszeile, wenn sie angefordert wurde und das
    // Eingabefeld leer ist — wer tippt, braucht sie nicht.
    const suggestionsOpen = showSuggestions && !(inputValue && inputValue.trim().length > 0);

    const [isDragOver, setIsDragOver] = useState(false);
    const [isDragValid, setIsDragValid] = useState(false);
    const [isUploading, setIsUploading] = useState(false);
    // Mirror of isUploading readable from callbacks/promises, plus a list of
    // resolvers waiting for the in-flight uploads to settle. Lets a background
    // task confirmation fire the moment the last upload finishes without
    // re-rendering or blocking the user (see submitActiveTaskInBackground).
    const isUploadingRef = useRef(false);
    const uploadSettleWaitersRef = useRef<Array<() => void>>([]);
    // Background task confirmations shown as a small floating bubble: the user
    // confirmed a file-collection task while uploads were still running, so the
    // task disappeared and the upload + BPM continuation run out of the way.
    const [backgroundConfirms, setBackgroundConfirms] = useState<
        Array<{ id: string; convId: string; title: string; status: 'uploading' | 'completing' | 'error' }>
    >([]);
    // Ids of tasks being confirmed in the background. The upload that is still
    // finishing reports the conversation with this (not-yet-completed) task
    // still in the worklist; without this guard applyIncomingConversation would
    // re-activate it for a beat before the completion call clears it. Filtered
    // there — the one choke point both the upload poll and the completion pass
    // through — so the task stays gone until it is really done.
    const backgroundCompletingTaskIdsRef = useRef<Set<string>>(new Set());
    const [storagePickerOpen, setStoragePickerOpen] = useState(false);
    // The server's upload limit, so an oversized file can be refused before it is
    // sent. Null until the settings call answers (and if it fails) — the check is
    // skipped then, and the server's 413 remains the backstop.
    const [maxUploadFileSizeBytes, setMaxUploadFileSizeBytes] = useState<number | null>(null);
    const [contextFileError, setContextFileError] = useState<string | null>(null);
    // Keep isUploadingRef in step and, when the last upload settles, release any
    // background confirmations that were waiting on it.
    useEffect(() => {
        isUploadingRef.current = isUploading;
        if (!isUploading && uploadSettleWaitersRef.current.length > 0) {
            const waiters = uploadSettleWaitersRef.current;
            uploadSettleWaitersRef.current = [];
            waiters.forEach((resolve) => resolve());
        }
    }, [isUploading]);
    // Resolves once no uploads are in flight (immediately if none are).
    const waitForUploadsToSettle = useCallback(
        () =>
            new Promise<void>((resolve) => {
                if (!isUploadingRef.current) {
                    resolve();
                    return;
                }
                uploadSettleWaitersRef.current.push(resolve);
            }),
        []
    );
    const [showSampleRequests, setShowSampleRequests] = useState(true);
    const [taskActionPopupOpen, setTaskActionPopupOpen] = useState(false);
    const [taskAction, setTaskAction] = useState<'complete' | 'defer' | 'requestInfo'>('complete');
    const taskActionButtonRef = useRef<HTMLButtonElement>(null);
    const [worklistPopupOpen, setWorklistPopupOpen] = useState(false);
    const worklistButtonRef = useRef<HTMLButtonElement>(null);
    const [processHistoryOpen, setProcessHistoryOpen] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);
    // Checklist runtime state — populated when the active user task carries
    // tri:uxElement="checklist". `instance` is the bound Checklist doc; the
    // input area swaps from textarea to ChecklistRunner while it is set.
    const [checklistInstance, setChecklistInstance] = useState<any | null>(null);
    const [checklistComplete, setChecklistComplete] = useState(false);
    const [checklistLoadFailed, setChecklistLoadFailed] = useState(false);
    const [checklistLoadAttempt, setChecklistLoadAttempt] = useState(0);
    const checklistFieldsRef = useRef<any[]>([]);
    type ChecklistPatch = {
        customer: any;
        taskId: string;
        payload: { fields: any; data: any };
    };
    const checklistPatchTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const pendingChecklistPatchRef = useRef<ChecklistPatch | null>(null);
    const failedChecklistPatchQueueRef = useRef<ChecklistPatch[]>([]);
    const previousChecklistTaskIdRef = useRef<string | null>(null);
    const [_timeoutWarning, setTimeoutWarning] = useState(false);
    const [uploadProgress, setUploadProgress] = useState<
        Array<{
            filename: string;
            estimatedTokens: number | null;
            status: 'uploading' | 'processing' | 'completed' | 'error';
            error?: string;
            progressDetail?: string | null;
            jobId?: string;
        }>
    >([]);
    const [selectedModel, setSelectedModel] = useState<LLM>(() => {
        // Load from localStorage or default to 'auto'
        const saved = localStorage.getItem('chatExchange.selectedModel');
        
        // Handle migration from old string values to enum values
        if (saved === 'auto') {
            return LLM.auto;
        } else if (saved === 'gemini2_5flash') {
            return LLM.gemini2_5_flash;
        } else if (saved === 'qwen2_5_1M') {
            return LLM.qwen2_5_14B_1M;
        } else if (saved === 'gemini-2.5-flash') {
            return LLM.gemini2_5_flash;
        } else if (saved === 'qwen2_5-14B_instruct_1M') {
            return LLM.qwen2_5_14B_1M;
        } else if (saved && Object.values(LLM).includes(saved as LLM)) {
            return saved as LLM;
        }
        
        return LLM.auto;
    });
    const [dataPoolDialogOpen, setDataPoolDialogOpen] = useState(false);
    const [dataPoolData, setDataPoolData] = useState<any[]>([]);
    const [dataPoolLoading, setDataPoolLoading] = useState(false);
    const [dataPoolRefreshCountdown, setDataPoolRefreshCountdown] = useState(30);
    const _dataPoolRefreshIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const dataPoolCountdownIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const [documentMenuDoc, setDocumentMenuDoc] = useState<any | null>(null);
    const documentMenuTargetRef = useRef<HTMLDivElement | null>(null);
    const [documentMarkdownDialog, setDocumentMarkdownDialog] = useState<{ doc: any } | null>(null);
    const [contextDocumentsCollapsed, setContextDocumentsCollapsed] = useState(() => shouldCollapseContextDocuments(properties.conversation));
    /** Die Dokumente, deren Namen in den Antworten zu Quellenlinks werden (siehe rehypeDocumentCitations). */
    const citableDocuments = React.useMemo<ConversationDocument[]>(
        () =>
            (conversation?.contextDocuments ?? [])
                .filter((doc: any) => doc?.fileId && doc?.filename)
                .map((doc: any) => ({
                    fileId: String(doc.fileId),
                    filename: String(doc.filename),
                    webUrl: doc.webUrl || undefined,
                    mimeType: doc.mimeType || undefined,
                    // „00 AzA (1).pdf" im Speicher — so sieht das Modell den Namen (documentMentions).
                    storedName: typeof doc.path === 'string' ? doc.path.split('/').pop() || undefined : undefined,
                })),
        [conversation?.contextDocuments]
    );
    const previousConversationIdRef = useRef<string | null>(properties.conversation?._id ?? null);
    const previousMessageCountRef = useRef<number>(properties.conversation?.messages?.length ?? 0);

    // Index of the bot message currently streaming progress lines from a
    // client-bot run; -1 means "no run in progress".
    const botRunMessageIndexRef = useRef<number>(-1);
    const [activeBotRunId, setActiveBotRunId] = useState<string | null>(null);
    const activeBotRunIdRef = useRef<string | null>(null);
    // Pending approval requests from the active bot run (policy: ask).
    // Keyed by callId so duplicates are coalesced and tool_result events can
    // resolve the entry. Each card carries the data needed to render the
    // Approve/Deny buttons and post the decision back to the extension.
    interface PendingApproval {
        runId: string;
        callId: string;
        tool: string;
        input: unknown;
        reason: string;
        receivedAt: number;
    }
    const [pendingApprovals, setPendingApprovals] = useState<Record<string, PendingApproval>>({});
    const clientBotApprovalPolicy = getClientBotConfig().approvalPolicy;
    const clearBotRunState = useCallback(() => {
        botRunMessageIndexRef.current = -1;
        setActiveBotRunId(null);
        setPendingApprovals({});
    }, []);
    
    /* **Auf diesem Branch fährt jeder Zug durch die Agenten-Schleife.** Der Router ist hier nicht
       erreichbar, und zwar fest verdrahtet statt als Voreinstellung.

       Vorher war es ein Schalter je Konversation im localStorage. Das hat wiederholt Zeit
       gekostet, ohne dass es wie ein Fehler aussah: Eine neue Konversation hatte keinen
       gespeicherten Wert, fiel auf den Router zurück, und weil beide Maschinen dieselbe Art
       Antwort liefern, sucht man den Fehler danach beim Loop, beim Werkzeug oder beim
       Werkzeugkatalog — überall, nur nicht am Schalter. Genau das ist drei Sitzungen lang
       passiert.

       Der Schalter ist deshalb entfernt, nicht nur umgestellt: Eine Voreinstellung kann man
       verlieren, eine Konstante nicht. Serverseitig entscheidet weiterhin AGENT_LOOP_ENABLED, ob
       die Engine überhaupt bereitsteht — das Portal wählt sie hier nur nicht mehr ab. */
    const engine = 'agent' as const;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleModelChange = useCallback((model: LLM) => {
        setSelectedModel(model);
        localStorage.setItem('chatExchange.selectedModel', model);
    }, []);
    
    const _contextFileInputRef = useRef<HTMLInputElement>(null);
    const replayLastRequestRef = useRef<(() => void) | null>(null);
    const resetStreamReconnectState = (run: ChatRun) => {
        run.reconnect = {
            runId: null,
            resumeFromChunk: 0,
        };
    };
    const clearSavedReconnectState = (run: ChatRun) => {
        run.savedCursor = null;
        run.savedConversation = null;
    };
    const clearAllReconnectState = (run: ChatRun) => {
        clearSavedReconnectState(run);
        resetStreamReconnectState(run);
    };
    const saveReconnectState = (run: ChatRun, conversationSnapshot?: any) => {
        const runId = run.reconnect.runId?.trim();
        if (!runId) {
            clearSavedReconnectState(run);
            return;
        }

        run.savedCursor = {
            runId,
            resumeFromChunk: Math.max(0, run.reconnect.resumeFromChunk ?? 0),
        };
        run.savedConversation = cloneConversation(conversationSnapshot || run.snapshot || conversationRef.current);
    };
    const _reconnectCurrentStream = useCallback(() => {
        const run = getChatRun(runsRef.current, conversationRef.current?._id);
        if (!run?.pending || !run.attemptAbortController) {
            if (replayLastRequestRef.current) {
                replayLastRequestRef.current();
                return;
            }
            console.warn('Reconnect requested but no active stream attempt is available.');
            return;
        }

        run.abortCause = MANUAL_RECONNECT_REASON;
        setTimeoutWarning(false);
        run.lastStreamActivity = Date.now();
        run.attemptAbortController.abort(MANUAL_RECONNECT_REASON);
    }, []);

    // Fetch data pool from server
    const fetchDataPool = useCallback(async () => {
        if (!authentication?.customer || !conversation?._id) {
            return;
        }

        const url = `${configuration.serverUrl}/${authentication.customer}/conversations/${conversation._id}/data-pool`;

        setDataPoolLoading(true);
        try {
            const response = await authenticatedFetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                const data = await response.json();
                
                // Extract items array from response object
                let items = [];
                if (Array.isArray(data)) {
                    items = data;
                } else if (data && Array.isArray(data.items)) {
                    items = data.items;
                } else if (data && data.items) {
                    items = Array.isArray(data.items) ? data.items : [];
                }
                
                setDataPoolData(items);
            } else {
                const errorText = await response.text();
                console.error('[DataPool] Failed to fetch data pool:', {
                    status: response.status,
                    statusText: response.statusText,
                    errorText: errorText
                });
                setDataPoolData([]);
            }
        } catch (error) {
            console.error('[DataPool] Error fetching data pool:', error);
            if (error instanceof Error) {
                console.error('[DataPool] Error details:', {
                    message: error.message,
                    stack: error.stack
                });
            }
            setDataPoolData([]);
        } finally {
            setDataPoolLoading(false);
        }
    }, [authentication?.customer, conversation?._id]);

    // Open data pool dialog and fetch data
    const handleOpenDataPoolDialog = useCallback(() => {
        setDataPoolDialogOpen(true);
        setDataPoolRefreshCountdown(30);
        fetchDataPool();
    }, [fetchDataPool]);

    // Manual refresh handler
    const handleRefreshDataPool = useCallback(() => {
        setDataPoolRefreshCountdown(30);
        fetchDataPool();
    }, [fetchDataPool]);

    // Set up countdown timer when dialog opens
    useEffect(() => {
        if (dataPoolDialogOpen) {
            // Clear any existing intervals first
            if (dataPoolCountdownIntervalRef.current) {
                clearInterval(dataPoolCountdownIntervalRef.current);
                dataPoolCountdownIntervalRef.current = null;
            }
            
            // Set up countdown timer (runs every second)
            dataPoolCountdownIntervalRef.current = setInterval(() => {
                setDataPoolRefreshCountdown((prev) => {
                    const newValue = prev <= 1 ? 30 : prev - 1;
                    // When countdown reaches 1, trigger refresh on next tick
                    if (prev === 1) {
                        fetchDataPool();
                    }
                    return newValue;
                });
            }, 1000);
        } else {
            // Cleanup when dialog closes
            if (dataPoolCountdownIntervalRef.current) {
                clearInterval(dataPoolCountdownIntervalRef.current);
                dataPoolCountdownIntervalRef.current = null;
            }
        }
        
        return () => {
            if (dataPoolCountdownIntervalRef.current) {
                clearInterval(dataPoolCountdownIntervalRef.current);
                dataPoolCountdownIntervalRef.current = null;
            }
        };
    }, [dataPoolDialogOpen, fetchDataPool]);

    // Persisted "good"/"bad" feedback per message index, restored when a conversation opens.
    const [feedbackByIndex, setFeedbackByIndex] = useState<Record<number, 'good' | 'bad'>>({});
    const feedbackByIndexRef = useRef<Record<number, 'good' | 'bad'>>({});
    useEffect(() => {
        feedbackByIndexRef.current = feedbackByIndex;
    }, [feedbackByIndex]);

    // Rückmeldung zur Bewertung: der Toast des Portals (`sonner`, unten rechts,
    // gestellt in `index.tsx`) statt eines eigenen Kastens am unteren Rand.
    const showFeedbackToast = useCallback((text: string, error?: boolean) => {
        if (error) toast.error(text);
        else toast.success(text);
    }, []);

    // Restore persisted feedback whenever the conversation changes.
    useEffect(() => {
        const customer = authentication?.customer;
        const convId = conversation?._id;
        if (!customer || !convId) {
            setFeedbackByIndex({});
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const res = await authenticatedFetch(
                    `${configuration.serverUrl}/${customer}/conversations/${convId}/feedback`,
                    { method: 'GET', headers: { 'Content-Type': 'application/json' } },
                );
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();
                if (!cancelled) setFeedbackByIndex(data?.feedbackByIndex || {});
            } catch {
                if (!cancelled) setFeedbackByIndex({});
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [authentication?.customer, conversation?._id]);

    // Persist "good answer" / "not so good answer"; confirm on success, revert + warn on failure.
    const handleFeedback = useCallback(
        async (messageIndex: number, isPositive: boolean) => {
            const customer = authentication?.customer;
            const convId = conversation?._id;
            if (!customer || !convId) return;
            const feedback: 'good' | 'bad' = isPositive ? 'good' : 'bad';
            const previous = feedbackByIndexRef.current[messageIndex];
            setFeedbackByIndex(prev => ({ ...prev, [messageIndex]: feedback })); // optimistic
            try {
                const res = await authenticatedFetch(
                    `${configuration.serverUrl}/${customer}/conversations/${convId}/feedback`,
                    {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ messageIndex, feedback }),
                    },
                );
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                showFeedbackToast(t('global.feedbackThanks'));
            } catch {
                // Revert the optimistic highlight and warn.
                setFeedbackByIndex(cur => {
                    const next = { ...cur };
                    if (previous === undefined) delete next[messageIndex];
                    else next[messageIndex] = previous;
                    return next;
                });
                showFeedbackToast(t('global.feedbackError'), true);
            }
        },
        [authentication?.customer, conversation?._id, showFeedbackToast, t],
    );

    const capitalizeFirstLetter = (value: string) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    const scrollToBottom = () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                const messagesContainer = conversationAreaRef.current?.querySelector('.messagesContainer') as HTMLElement;
                if (!messagesContainer) return;

                const messagesDiv = messagesContainer.querySelector('.messages') as HTMLElement;
                if (messagesDiv && messagesDiv.scrollHeight > messagesDiv.clientHeight) {
                    // Scroll to absolute bottom
                    messagesDiv.scrollTop = messagesDiv.scrollHeight;

                    // Verify and retry if needed
                    setTimeout(() => {
                        const currentMaxScroll = messagesDiv.scrollHeight - messagesDiv.clientHeight;
                        if (Math.abs(messagesDiv.scrollTop - currentMaxScroll) > 1) {
                            messagesDiv.scrollTop = messagesDiv.scrollHeight;
                        }
                    }, 50);
                }
            });
        });
    };
    
    // Auto-scroll to bottom when new bot messages are added (but not when user messages are added)
    useEffect(() => {
        if (!conversation?.messages || conversation.messages.length === 0) return;

        // Auto-scroll disabled - user controls scrolling
        // const lastMessage = conversation.messages[conversation.messages.length - 1];
        // // Only auto-scroll if the last message is a bot message and there's a pending request
        // if ((lastMessage?.type === 'botMessage' || lastMessage?.type === 'botSuggestion') && pendingRequest) {
        //     scrollToBottom();
        // }
    }, [conversation?.messages, pendingRequest]);

    // Bind checklist instance to the active task when it carries
    // tri:uxElement="checklist". POST is idempotent server-side: creates the
    // instance on first claim, returns existing one on reclaim. Clears state
    // when the task goes away (resume to non-checklist, conversation switch).
    const activeTaskForChecklist = (conversation as any)?.activeTask;
    const activeTaskId = activeTaskForChecklist?._id;
    // Robust lookup: prefer triAttrs.uxElement set by applyActiveTask, but
    // fall back to raw extensions and the conversation-level map so a task
    // that hasn't been through enrichment yet still routes correctly.
    const activeTaskNodeId = activeTaskForChecklist?.nodeId;
    const activeTaskUxElement =
        activeTaskForChecklist?.triAttrs?.uxElement
        ?? activeTaskForChecklist?.extensions?.['tri:uxElement']
        ?? (conversation as any)?.triAttrsByNodeId?.[activeTaskNodeId]?.uxElement;
    const isChecklistTask = activeTaskUxElement === 'checklist';
    const isSliderTask = activeTaskUxElement === 'slider';
    const isTextInputTask = activeTaskUxElement === 'text-input';
    const isConfirmationTask = activeTaskUxElement === 'confirmation';
    const isSelectTask = activeTaskUxElement === 'select';
    const isFormTask = activeTaskUxElement === 'form';
    // Process instance backing the active task — used to load the process history.
    const processInstanceId =
        (conversation as any)?.processInstance
        ?? activeTaskForChecklist?.instanceId
        ?? null;
    const isBotInvokeTask =
        activeTaskUxElement === 'cli-bot'
        || activeTaskUxElement === 'browser-bot'
        || activeTaskUxElement === 'client-bot';
    const checklistReady = isChecklistTask && !!checklistInstance;
    useEffect(() => {
        let cancelled = false;
        const resetChecklistBindingState = () => {
            setChecklistInstance(null);
            setChecklistComplete(false);
            setChecklistLoadFailed(false);
            checklistFieldsRef.current = [];
        };
        if (!isChecklistTask || !activeTaskId || !authentication?.customer) {
            resetChecklistBindingState();
            return;
        }
        // Clear any previously bound checklist immediately so the runner
        // cannot render stale fields while the next bind request is in flight.
        resetChecklistBindingState();
        (async () => {
            try {
                const inst = await userAPI.startWorkItemChecklistInstance(
                    authentication.customer,
                    String(activeTaskId),
                );
                if (cancelled) return;
                if (!inst) {
                    throw new Error('Checklist instance missing in response');
                }
                setChecklistInstance(inst);
            } catch (err) {
                if (!cancelled) {
                    console.error('Checklist start failed:', err);
                    setChecklistLoadFailed(true);
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [activeTaskId, isChecklistTask, authentication?.customer, checklistLoadAttempt]);
    const loadActiveTaskSelectOptions = useCallback(() => {
        const convId = conversation?._id;
        if (!authentication?.customer || !convId || !activeTaskId) {
            return Promise.resolve([] as TaskSelectOption[]);
        }
        return userAPI.getConversationTaskSelectOptions(authentication.customer, String(convId), String(activeTaskId));
    }, [authentication?.customer, conversation?._id, activeTaskId]);
    const loadActiveTaskForm = useCallback(() => {
        const convId = conversation?._id;
        if (!authentication?.customer || !convId || !activeTaskId) {
            return Promise.resolve({ fields: [] } as TaskForm);
        }
        return userAPI.getConversationTaskForm(authentication.customer, String(convId), String(activeTaskId));
    }, [authentication?.customer, conversation?._id, activeTaskId]);
    const retryChecklistLoad = useCallback(() => {
        setChecklistLoadAttempt((prev) => prev + 1);
    }, []);
    useEffect(() => {
        if ((!checklistReady && !isSliderTask && !isTextInputTask && !isConfirmationTask && !isSelectTask && !isFormTask) || taskAction === 'complete') return;
        setTaskAction('complete');
        setTaskActionPopupOpen(false);
    }, [checklistReady, isSliderTask, isTextInputTask, isConfirmationTask, isSelectTask, isFormTask, taskAction]);

    // Debounced PATCH of checklist values. The runner reports the whole
    // mutated checklist (data + fields); we forward both to the server
    // every 600ms of quiescence. Server-side validation still runs on
    // task completion as defense-in-depth.
    const flushChecklistPatch = useCallback(async (): Promise<boolean> => {
        if (checklistPatchTimerRef.current) {
            clearTimeout(checklistPatchTimerRef.current);
            checklistPatchTimerRef.current = null;
        }

        while (true) {
            const retryPatch = failedChecklistPatchQueueRef.current.shift() ?? null;
            const patchToFlush = retryPatch ?? pendingChecklistPatchRef.current;
            if (!patchToFlush) return true;
            if (!retryPatch) {
                pendingChecklistPatchRef.current = null;
            }

            try {
                await userAPI.updateWorkItemChecklistInstance(
                    patchToFlush.customer,
                    patchToFlush.taskId,
                    patchToFlush.payload,
                );
            } catch (err) {
                if (retryPatch) {
                    failedChecklistPatchQueueRef.current.unshift(retryPatch);
                } else {
                    // Keep failed payloads queued even if new edits arrived while this request was in flight.
                    failedChecklistPatchQueueRef.current.push(patchToFlush);
                }
                console.error('Checklist PATCH failed:', err);
                return false;
            }
        }
    }, []);

    const handleChecklistChange = useCallback(
        ({
            checklist,
            isComplete,
            workItemId,
            hasLocalEdits,
        }: {
            checklist: any;
            isComplete: boolean;
            workItemId?: string | null;
            hasLocalEdits: boolean;
        }) => {
            const customer = authentication?.customer;
            const currentActiveTaskId = activeTaskId ? String(activeTaskId) : null;
            const sourceTaskId = workItemId ? String(workItemId) : currentActiveTaskId;
            const isForActiveTask = !!currentActiveTaskId && sourceTaskId === currentActiveTaskId;
            const resolvedFields = resolveChecklistFields(checklist);
            if (isForActiveTask) {
                checklistFieldsRef.current = resolvedFields;
                setChecklistComplete(isComplete);
            }
            if (!hasLocalEdits) return;
            if (!sourceTaskId || !customer) return;
            const pendingPatch = pendingChecklistPatchRef.current;
            if (pendingPatch && pendingPatch.taskId !== sourceTaskId) {
                // Preserve the previous task's payload before replacing pending state.
                // If we only fire-and-forget flushChecklistPatch here, an in-flight flush
                // can read the new task payload and skip the previous task's last edits.
                pendingChecklistPatchRef.current = null;
                failedChecklistPatchQueueRef.current.push(pendingPatch);
                void flushChecklistPatch();
            }
            pendingChecklistPatchRef.current = {
                customer,
                taskId: sourceTaskId,
                payload: {
                    fields: resolvedFields,
                    data: checklist?.data,
                },
            };
            if (checklistPatchTimerRef.current) clearTimeout(checklistPatchTimerRef.current);
            checklistPatchTimerRef.current = setTimeout(() => {
                void flushChecklistPatch();
            }, 600);
        },
        [activeTaskId, authentication?.customer, flushChecklistPatch],
    );
    useEffect(() => {
        const normalizedTaskId = activeTaskId ? String(activeTaskId) : null;
        const previousTaskId = previousChecklistTaskIdRef.current;
        if (previousTaskId && previousTaskId !== normalizedTaskId) {
            void flushChecklistPatch();
        }
        previousChecklistTaskIdRef.current = normalizedTaskId;
    }, [activeTaskId, flushChecklistPatch]);
    useEffect(() => {
        return () => {
            void flushChecklistPatch();
        };
    }, [flushChecklistPatch]);

    // Opening a conversation (switch, first load, reload) is positioned by the
    // `MessageScroller` in `ChatConversation` (`openKey`): it lands at the end
    // before the first paint. A delayed scroll here would only show as a jump.

    const recordRequest = useCallback((request: string) => {
        if (request) {
            setRequests([...requests, request]);
            setRequestIndex(requests.length);
        }
    }, [requests])

    // The upload limit is a server-side env knob; ask for it rather than hardcoding a
    // copy that would silently drift from it.
    useEffect(() => {
        if (!authentication.customer) return;

        let cancelled = false;

        void (async () => {
            try {
                const settings: any = await userAPI.getCustomerSettings(authentication.customer);

                if (!cancelled && typeof settings?.limits?.maxUploadFileSizeBytes === 'number') {
                    setMaxUploadFileSizeBytes(settings.limits.maxUploadFileSizeBytes);
                }
            } catch (error) {
                // Non-fatal: without the limit we simply skip the pre-flight check and
                // let the server's 413 reject the file.
                console.error('Could not load the upload size limit:', error);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [authentication.customer]);

    // Helper function to process folder entries and extract files with relative paths
    const processDataTransferItems = async (items: DataTransferItemList): Promise<File[]> => {
        const files: File[] = [];
        
        const processEntry = async (entry: any, path: string = ''): Promise<void> => {
            if (entry.isFile) {
                return new Promise<void>((resolve) => {
                    entry.file((file: File) => {
                        // Create a new file with the relative path as name if it's in a folder
                        if (path) {
                            const newFile = new File([file], `${path}/${file.name}`, { type: file.type });
                            files.push(newFile);
                        } else {
                            files.push(file);
                        }
                        resolve();
                    });
                });
            } else if (entry.isDirectory) {
                const dirReader = entry.createReader();
                return new Promise<void>((resolve) => {
                    const readEntries = () => {
                        dirReader.readEntries(async (entries: any[]) => {
                            if (entries.length === 0) {
                                resolve();
                                return;
                            }
                            
                            await Promise.all(entries.map(childEntry => 
                                processEntry(childEntry, path ? `${path}/${entry.name}` : entry.name)
                            ));
                            
                            // Continue reading if there might be more entries
                            readEntries();
                        });
                    };
                    readEntries();
                });
            }
        };

        const promises: Promise<void>[] = [];
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.kind === 'file') {
                const entry = item.webkitGetAsEntry();
                if (entry) {
                    promises.push(processEntry(entry));
                }
            }
        }
        
        await Promise.all(promises);
        return files;
    };

    const validateDraggedContent = (dataTransfer: DataTransfer): boolean => {
        const items = Array.from(dataTransfer.items || []);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const files = Array.from(dataTransfer.files || []);

        if (items.length === 0) {
            return false;
        }

        const draggedFiles = Array.from(dataTransfer.files || []);
        if (draggedFiles.length > 0) {
            return draggedFiles.every(file => isValidContextFile(file));
        }

        const fileItems = items.filter(item => item.kind === 'file');
        if (fileItems.length === 0) {
            return false;
        }

        return fileItems.every(item =>
            item.type
                ? allowedMimeTypes.some(mimeType => item.type.toLowerCase() === mimeType)
                : true
        );
    };

    // Drag and drop handlers
    const handleDragOver = (e: React.DragEvent) => {
        // No drop target, so no "drop it here" overlay either.
        if (properties.readOnly) return;
        e.preventDefault();
        e.stopPropagation();
        
        // Check if dragged items contain files or folders
        if (e.dataTransfer.items) {
            const items = Array.from(e.dataTransfer.items);
            const hasFilesOrFolders = items.some(item => 
                item.kind === 'file'
            );
            
            if (hasFilesOrFolders) {
                setIsDragValid(validateDraggedContent(e.dataTransfer));
                setIsDragOver(true);
            }
        }
    };

    const handleDragEnter = (e: React.DragEvent) => {
        if (properties.readOnly) return;
        e.preventDefault();
        e.stopPropagation();
        
        // Check if dragged items contain files or folders
        if (e.dataTransfer.items) {
            const items = Array.from(e.dataTransfer.items);
            const hasFilesOrFolders = items.some(item => 
                item.kind === 'file'
            );
            
            if (hasFilesOrFolders) {
                setIsDragValid(validateDraggedContent(e.dataTransfer));
                setIsDragOver(true);
            }
        }
    };

    const handleDragLeave = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        // Only set to false if we're leaving the container entirely
        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
            setIsDragOver(false);
            setIsDragValid(false);
        }
    };

    // Handler to remove a context document
    const handleRemoveDocument = async (documentID: string) => {
        if (properties.conversation?._id) {
            try {
                const updatedConversation = await userAPI.deleteContextDocument(authentication.customer, properties.conversation._id, documentID);
                
                // Update the conversation with the returned object
                if (updatedConversation) {
                    applyIncomingConversation(updatedConversation);
                }
            } catch (error) {
                console.error('Error deleting document:', error);
            }
        }
    };

    const handleDocumentDownload = useCallback(async (doc: any) => {
        setDocumentMenuDoc(null);
        const fileId = (doc as any).fileId;
        const filename = (doc as any).filename || 'document';

        const doDownload = (blob: Blob, downloadFilename: string) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = downloadFilename;
            a.click();
            URL.revokeObjectURL(url);
        };

        if (fileId) {
            try {
                const { blob, filename: fn } = await userAPI.getDocumentByFileId(
                    authentication.customer,
                    fileId,
                    'download',
                    filename
                );
                doDownload(blob, fn);
                return;
            } catch (err) {
                console.error('Failed to download original via fileId:', err);
                try {
                    const { blob, filename: fn } = await userAPI.getDocumentByFileId(
                        authentication.customer,
                        fileId,
                        'markdown',
                        filename
                    );
                    doDownload(blob, fn);
                    return;
                } catch (markdownErr) {
                    console.error('Failed to download markdown via fileId:', markdownErr);
                }
            }
        }

        const conversationId = conversationRef.current?._id;
        const documentId = (doc as any)._id;
        if (conversationId && documentId) {
            try {
                const { blob, filename: fn } = await userAPI.getContextDocumentDownload(
                    authentication.customer,
                    conversationId,
                    documentId,
                    filename
                );
                doDownload(blob, fn);
                return;
            } catch (err) {
                console.error('Failed to download via context-documents:', err);
            }
        }

        const content = (doc as any).markdown || (doc as any).content || '';
        const ext = (doc.filename || '').toLowerCase();
        const isTextOriginal = ext.endsWith('.md') || ext.endsWith('.txt') || ext.endsWith('.html');
        if (content && isTextOriginal) {
            const blob = new Blob([content], { type: 'text/markdown' });
            const downloadFilename = (doc.filename || 'document').replace(/\.[^.]+$/, '') + (ext.endsWith('.md') ? '' : '.md');
            doDownload(blob, downloadFilename);
        } else if (!content) {
            showMessageDialog(t('chatExchange.documentDownloadFailed', { filename }));
        } else {
            const blob = new Blob([content], { type: 'text/markdown' });
            const downloadFilename = (doc.filename || 'document').replace(/\.[^.]+$/, '') + '.md';
            doDownload(blob, downloadFilename);
        }
    }, [authentication.customer, showMessageDialog, t]);

    const handleDocumentOpenInSharePoint = useCallback((doc: any) => {
        setDocumentMenuDoc(null);
        const webUrl = (doc as any).webUrl;
        if (webUrl) {
            window.open(webUrl, '_blank', 'noopener,noreferrer');
        }
    }, []);

    const handleDocumentMarkdownOpen = useCallback(async (doc: any) => {
        setDocumentMenuDoc(null);
        const fileId = (doc as any).fileId;
        if (fileId) {
            try {
                const { blob } = await userAPI.getDocumentByFileId(
                    authentication.customer,
                    fileId,
                    'markdown',
                    (doc as any).filename
                );
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank', 'noopener,noreferrer');
                setTimeout(() => URL.revokeObjectURL(url), 1000);
                return;
            } catch (err) {
                console.error('Failed to open markdown via fileId:', err);
            }
        }
        const content = (doc as any).markdown || (doc as any).content || '';
        if (!content) return;
        const blob = new Blob([content], { type: 'text/markdown' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank', 'noopener,noreferrer');
        setTimeout(() => URL.revokeObjectURL(url), 1000);
    }, [authentication.customer]);

    const handleDocumentMarkdownShow = useCallback(async (doc: any) => {
        setDocumentMenuDoc(null);
        const fileId = (doc as any).fileId;
        let docToShow = doc;
        if (fileId && !(doc as any).markdown && !(doc as any).content) {
            try {
                const { blob } = await userAPI.getDocumentByFileId(
                    authentication.customer,
                    fileId,
                    'markdown',
                    (doc as any).filename
                );
                const content = await blob.text();
                docToShow = { ...doc, markdown: content };
            } catch (err) {
                console.error('Failed to fetch markdown via fileId:', err);
            }
        }
        setDocumentMarkdownDialog({ doc: docToShow });
    }, [authentication.customer]);

    // One job can cover several files: the upload path sends one file per request, while attaching
    // files picked from storage resolves the whole selection into a single job.
    const pollContextDocumentJob = useCallback(
        (jobId: string, fileNames: string[], conversationId: string) => {
            const coversFile = (filename: string) => fileNames.includes(filename);
            return new Promise<void>((resolve, reject) => {
                const poll = async (attempt: number) => {
                    try {
                        const status = await userAPI.getContextDocumentJobStatus(
                            authentication.customer,
                            conversationId,
                            jobId
                        );

                        if (status?.progress?.detail) {
                            setUploadProgress(prev =>
                                prev.map(progress =>
                                    coversFile(progress.filename)
                                        ? {
                                              ...progress,
                                              status: 'processing',
                                              progressDetail: status?.progress?.detail || null,
                                          }
                                        : progress
                                )
                            );
                        }

                        if (status?.jobStatus === 'completed' && status.conversation) {
                            const updatedConversation = new Conversation(status.conversation);
                            applyIncomingConversation(updatedConversation, {
                                dropPendingFilenames: fileNames,
                            });
                            setUploadProgress(prev =>
                                prev.filter(progress => !coversFile(progress.filename))
                            );
                            resolve();
                            return;
                        }

                        if (status?.jobStatus === 'failed') {
                            const errorMessage =
                                status?.error || status?.ragStatus || 'Processing failed';

                            setConversation((prevConversation: any) => {
                                if (!prevConversation) {
                                    return prevConversation;
                                }

                                const updatedDocs = (prevConversation.contextDocuments || []).map(
                                    (doc: any) => {
                                        if (doc.isUploading && coversFile(doc.filename)) {
                                            return {
                                                ...doc,
                                                status: 'error',
                                                error: errorMessage,
                                            };
                                        }
                                        return doc;
                                    }
                                );

                                const clonedConversation = cloneConversation(prevConversation);
                                clonedConversation.contextDocuments = updatedDocs;
                                return clonedConversation;
                            });

                            setUploadProgress(prev =>
                                prev.map(progress =>
                                    coversFile(progress.filename)
                                        ? {
                                              ...progress,
                                              status: 'error',
                                              error: errorMessage,
                                          }
                                        : progress
                                )
                            );
                            resolve();
                            return;
                        }

                        const nextDelay = Math.min(10000, 2000 + attempt * 500);
                        setTimeout(() => poll(attempt + 1), nextDelay);
                    } catch (error) {
                        if (attempt > 20) {
                            setUploadProgress(prev =>
                                prev.map(progress =>
                                    coversFile(progress.filename)
                                        ? {
                                              ...progress,
                                              status: 'error',
                                              error: 'Failed to check processing status',
                                          }
                                        : progress
                                )
                            );
                            reject(error);
                            return;
                        }
                        const nextDelay = Math.min(10000, 2000 + attempt * 500);
                        setTimeout(() => poll(attempt + 1), nextDelay);
                    }
                };

                poll(0);
            });
        },
        [authentication.customer, applyIncomingConversation]
    );

    const handleContextFilesSelected = useCallback(
        async (selectedFiles: File[]) => {
            // Both rejection checks live here, and the entry points (attach button,
            // drag-and-drop, file input) hand over everything the user picked: this is the
            // one place they all funnel through, so it is the only place that can see what
            // was refused and say so. Filtering at the entry points instead is what made
            // rejected files vanish silently.
            const unsupported = selectedFiles.filter(file => !isValidContextFile(file));
            const supported = selectedFiles.filter(file => isValidContextFile(file));

            // Refuse an oversized file rather than uploading it just to have the server
            // reject it — a file well over the limit can take minutes to send before it fails.
            const tooLarge = maxUploadFileSizeBytes
                ? supported.filter(file => file.size > maxUploadFileSizeBytes)
                : [];
            const validFiles = supported.filter(file => !tooLarge.includes(file));

            // Dropping a folder walks it recursively, so a rejected set can be large — name a
            // few files and count the rest rather than printing a wall of filenames.
            const names = (files: File[]) => {
                const shown = files.slice(0, 3).map(file => file.name);
                const remaining = files.length - shown.length;

                return remaining > 0 ? `${shown.join(', ')} (+${remaining})` : shown.join(', ');
            };
            const problems: string[] = [];

            if (unsupported.length > 0) {
                problems.push(
                    t('chatExchange.unsupportedFileType', {
                        files: names(unsupported),
                        formats: t('chatExchange.supportedFormats'),
                    })
                );
            }

            if (tooLarge.length > 0 && maxUploadFileSizeBytes) {
                problems.push(
                    t('chatExchange.fileTooLarge', {
                        files: names(tooLarge),
                        maxSize: formatMegabytes(maxUploadFileSizeBytes),
                    })
                );
            }

            setContextFileError(problems.length > 0 ? problems.join(' ') : null);

            if (validFiles.length === 0 || !conversation?._id) {
                return;
            }

            setIsUploading(true);

            const initialProgress = validFiles.map(file => ({
                filename: file.name.replace(/[^a-zA-Z0-9._\- ]/g, ''),
                estimatedTokens: null,
                status: 'uploading' as const,
            }));

            setUploadProgress(initialProgress);

            setConversation((prevConversation: any) => {
                if (!prevConversation) return prevConversation;

                const uploadingDocs = validFiles.map(file => ({
                    _id: `uploading-${file.name}-${Date.now()}`,
                    filename: file.name.replace(/[^a-zA-Z0-9._\- ]/g, ''),
                    status: 'uploading',
                    isUploading: true,
                }));

                const clonedConversation = cloneConversation(prevConversation);
                const existingDocs = clonedConversation.contextDocuments || [];
                clonedConversation.contextDocuments = [...existingDocs, ...uploadingDocs];

                return clonedConversation;
            });

            try {
                const uploadPromises = validFiles.map(async file => {
                    try {
                        const jobResponse = await userAPI.uploadSingleContextDocument(
                            authentication.customer,
                            conversation!._id!,
                            file
                        );

                        if (!jobResponse?.jobId) {
                            throw new Error('Missing job reference from server');
                        }

                        setUploadProgress(prevProgress =>
                            prevProgress.map(progress =>
                                progress.filename === file.name.replace(/[^a-zA-Z0-9._\- ]/g, '')
                                    ? {
                                          ...progress,
                                          status: 'processing',
                                          jobId: jobResponse.jobId,
                                          progressDetail: 'File uploaded. Processing...',
                                      }
                                    : progress
                            )
                        );

                        await pollContextDocumentJob(
                            jobResponse.jobId,
                            [file.name.replace(/[^a-zA-Z0-9._\- ]/g, '')],
                            conversation!._id!
                        );

                        setUploadProgress(prevProgress => {
                            return prevProgress.filter(
                                progress => progress.filename !== file.name.replace(/[^a-zA-Z0-9._\- ]/g, '')
                            );
                        });

                        return { success: true, file: file.name.replace(/[^a-zA-Z0-9._\- ]/g, '') };
                    } catch (error) {
                        console.error(`Error uploading file ${file.name.replace(/[^a-zA-Z0-9._\- ]/g, '')}:`, error);

                        // The server rejected the file as too large (413). Reachable when the
                        // pre-flight check above could not run — the limit failed to load, or
                        // it changed after this page did.
                        const failure =
                            error instanceof FileTooLargeError
                                ? t('chatExchange.fileTooLargeShort', {
                                      maxSize: formatMegabytes(error.maxFileSizeBytes),
                                  })
                                : error instanceof Error
                                  ? error.message
                                  : t('chatExchange.uploadFailed');

                        setConversation((prevConversation: any) => {
                            if (!prevConversation) return prevConversation;

                            const updatedDocs = (prevConversation.contextDocuments || []).map((doc: any) => {
                                if (doc.isUploading && doc.filename === file.name.replace(/[^a-zA-Z0-9._\- ]/g, '')) {
                                    return {
                                        ...doc,
                                        status: 'error',
                                        error: failure,
                                    };
                                }
                                return doc;
                            });

                            const clonedConversation = cloneConversation(prevConversation);
                            clonedConversation.contextDocuments = updatedDocs;

                            return clonedConversation;
                        });

                        setUploadProgress(prevProgress => {
                            return prevProgress.map(progress =>
                                progress.filename === file.name.replace(/[^a-zA-Z0-9._\- ]/g, '')
                                    ? {
                                          ...progress,
                                          status: 'error' as const,
                                          error: failure,
                                      }
                                    : progress
                            );
                        });

                        return { success: false, file: file.name.replace(/[^a-zA-Z0-9._\- ]/g, ''), error };
                    }
                });

                await Promise.all(uploadPromises);

                setTimeout(() => {
                    setUploadProgress([]);
                    setIsUploading(false);
                }, 2000);
            } catch (error) {
                console.error('Error in parallel upload process:', error);
                setIsUploading(false);
                setUploadProgress([]);
            }
        },
        [authentication.customer, conversation, pollContextDocumentJob, maxUploadFileSizeBytes, t]
    );

    // Attach files the customer already has in the managed file system. Nothing is uploaded — the
    // server resolves the picked ids and folders and answers with the same job reference the upload
    // path returns, so from here on the two flows are identical. The placeholder documents can only
    // be created once that answer names the files: a picked folder's contents are resolved server-
    // side, so the client does not know them beforehand.
    const handleStoragePickConfirm = useCallback(
        async (picked: StoragePickResult) => {
            if (!conversation?._id) {
                return;
            }

            setContextFileError(null);
            setIsUploading(true);

            try {
                const jobResponse = await userAPI.attachStorageContextDocuments(
                    authentication.customer,
                    conversation._id,
                    picked
                );

                const filenames = (jobResponse.files || [])
                    .map((file: any) => file?.filename)
                    .filter((filename: any): filename is string => typeof filename === 'string');

                // A pick can partly succeed — an unsupported type, or a file whose processing could
                // not be started. Say which ones were left out, and why, rather than quietly
                // attaching fewer files than the user selected. A server that predates the reasons
                // sends only the names; then the generic sentence stands.
                const skipped = (jobResponse.skipped || []).filter(
                    (name: any): name is string => typeof name === 'string' && name.length > 0
                );
                const skippedMessage = describeStorageAttachSkips(
                    t,
                    readSkippedDetails(jobResponse.skippedDetails)
                );
                if (skippedMessage) {
                    setContextFileError(skippedMessage);
                } else if (skipped.length > 0) {
                    const shown = skipped.slice(0, 3).join(', ');
                    const remaining = skipped.length - Math.min(skipped.length, 3);
                    setContextFileError(
                        t('chatExchange.storagePickSkipped', {
                            files: remaining > 0 ? `${shown} (+${remaining})` : shown,
                        })
                    );
                }

                if (filenames.length === 0) {
                    setIsUploading(false);
                    return;
                }

                setUploadProgress(
                    filenames.map(filename => ({
                        filename,
                        estimatedTokens: null,
                        status: 'processing' as const,
                        jobId: jobResponse.jobId,
                    }))
                );

                setConversation((prevConversation: any) => {
                    if (!prevConversation) return prevConversation;

                    const attachingDocs = filenames.map(filename => ({
                        _id: `attaching-${filename}-${Date.now()}`,
                        filename,
                        status: 'processing',
                        isUploading: true,
                    }));

                    const clonedConversation = cloneConversation(prevConversation);
                    const existingDocs = clonedConversation.contextDocuments || [];
                    clonedConversation.contextDocuments = [...existingDocs, ...attachingDocs];

                    return clonedConversation;
                });

                await pollContextDocumentJob(jobResponse.jobId, filenames, conversation._id);

                setTimeout(() => {
                    setUploadProgress([]);
                    setIsUploading(false);
                }, 2000);
            } catch (error) {
                console.error('Error attaching files from storage:', error);
                // The refusals the user can act on get said in their language, with what to do
                // instead; the server's own message stands in for everything else. The cap is the
                // one the server sent, rather than a second copy of the number kept here.
                const refusal = error as {
                    code?: string;
                    maxFiles?: number;
                    skippedDetails?: unknown;
                };
                const message =
                    refusal?.code === 'TOO_MANY_SELECTED_FILES' &&
                    typeof refusal.maxFiles === 'number'
                        ? t('chatExchange.storagePickTooMany', { max: refusal.maxFiles })
                        : refusal?.code === 'NOTHING_ATTACHABLE'
                          ? describeStorageAttachSkips(
                                t,
                                readSkippedDetails(refusal.skippedDetails),
                                true
                            )
                          : error instanceof Error
                          ? error.message
                          : t('chatExchange.uploadFailed');
                setContextFileError(message);
                setIsUploading(false);
                setUploadProgress([]);
            }
        },
        [authentication.customer, conversation, pollContextDocumentJob, t]
    );

    const _handleContextFileInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const list = e.target.files;
        e.target.value = '';
        if (!list?.length) return;
        void handleContextFilesSelected(Array.from(list));
    };

    // Upload via drag-and-drop (folders supported) or via file input (attach button)
    const handleDrop = async (e: React.DragEvent) => {
        // Hiding the buttons is not enough — a file dragged onto the panel would still land.
        if (properties.readOnly) {
            e.preventDefault();
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        setIsDragOver(false);
        setIsDragValid(false);

        try {
            let allFiles: File[] = [];

            if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
                allFiles = await processDataTransferItems(e.dataTransfer.items);
            } else {
                allFiles = Array.from(e.dataTransfer.files);
            }

            await handleContextFilesSelected(allFiles);
        } catch (error) {
            console.error('Error processing dropped files:', error);
            setIsUploading(false);
        }
    };



    const parseMessageChunk = (chunk: string, parsingState: {
        newConversation: any;
        payloadBuffer: string;
        insidePayload: boolean;
        requestId: number;
        streamCompleted: boolean;
        lastTextChunk: string;
        streamRunId: string | null;
        resumeFromChunk: number;
        justClosedPayloadFence: boolean;
        /** Conversation this stream belongs to — not necessarily the open one. */
        conversationId: unknown;
    }) => {
        const run = ensureChatRun(runsRef.current, parsingState.conversationId);
        let {
            newConversation,
            payloadBuffer,
            insidePayload,
            streamCompleted,
            lastTextChunk,
            streamRunId,
            resumeFromChunk,
            justClosedPayloadFence
        } = parsingState;
        let currentMessage = newConversation.messages[newConversation.messages.length - 1];
        const requestId = parsingState.requestId;

        // Helper function to update UI if this is still the current request
        const updateUI = () => {
            if (requestId === parsingState.requestId) {
                // Track stream activity
                run.lastStreamActivity = Date.now();

                // Shallow clone is enough to trigger Jotai/React update since ChatConversation is not memoized
                const cloned = cloneConversation(newConversation);
                // The snapshot is what a background run streams into; switching
                // back to its conversation resumes from it. Only the conversation
                // on screen may write the displayed state.
                run.snapshot = cloned;
                if (!isDisplayedConversation(parsingState.conversationId, conversationRef.current?._id)) {
                    return;
                }
                setConversation(cloned);
                setChatUpdate(Date.now() + Math.random());
                // Following the stream is `MessageScroller`'s job: it glides after
                // growing content while the reader is at the end and leaves them
                // alone once they scrolled up. A hard `scrollTop = scrollHeight`
                // per chunk here cut into that glide and pulled readers back down.
            }
        };

        // Helper function to process a complete payload
        const processPayload = (payloadData: string) => {
            try {
                const payload = JSON.parse(payloadData);

                if (payload.stream) {
                    if (typeof payload.stream.runId === 'string' && payload.stream.runId.trim().length > 0) {
                        streamRunId = payload.stream.runId.trim();
                        run.reconnect.runId = streamRunId;
                    }

                    if (Number.isInteger(payload.stream.chunkIndex)) {
                        // Each data chunk is followed by a stream metadata chunk.
                        resumeFromChunk = Number(payload.stream.chunkIndex) + 2;
                        run.reconnect.resumeFromChunk = resumeFromChunk;
                    }
                }
                
                // BPM / agentic workflow: match persisted per–service-task messages (one bubble per task)
                if (payload.newAssistantMessage) {
                    newConversation.messages.push(new Message({
                        type: MessageType.botMessage,
                        content: '',
                        confirmation: false,
                        resources: [],
                    }));
                    currentMessage = newConversation.messages[newConversation.messages.length - 1];
                    updateUI();
                }
                
                if (payload.resources) {
                    // Handle resources - separate source, file, and inline resources.
                    // The sorting itself is a pure function (`chat/payloadResources.ts`)
                    // and tested there: sources, files, rendered-at-the-end (they need
                    // `onSubmitInput` + `isLastMessage`, which the inline renderer lacks),
                    // inline — and the two portal guide blocks.
                    const groups = groupPayloadResources(payload.resources);
                    const sourceResources = groups.sourceResources;
                    const fileResources = groups.fileResources;
                    const followUpSuggestions = groups.endRenderedResources;
                    const inlineResources = groups.inlineResources;

                    // Portal guide, stage 2: `highlight` creates no tile (intercepted
                    // in `groupPayloadResources`), `navigate` with `auto` jumps on its
                    // own. Both are remembered and redeemed at `endOfMessage` — see
                    // `releaseGuideBlocks`.
                    if (groups.highlight || groups.autoNavigate) {
                        guideBlocksRef.current.set(
                            parsingState.conversationId,
                            rememberGuideBlocks(
                                guideBlocksRef.current.get(parsingState.conversationId),
                                groups,
                                requestId,
                            ),
                        );
                    }

                    // Add inline resources (charts, maps, tables) - render inline with markdown
                    if (inlineResources.length > 0) {
                        if (!currentMessage.resources) {
                            currentMessage.resources = [];
                        }
                        
                        // Process each resource individually for progressive rendering
                        for (const resource of inlineResources) {
                            // Ensure the resource has an ID so it can be matched in ChatMessage
                            if (!resource.reference && !resource._id) {
                                resource.reference = `resource-${Date.now()}-${Math.random()}`;
                            }
                            
                            // Assign a stable ID if it doesn't have one yet to keep keys consistent across tokens
                            if (!resource._stableId) {
                                resource._stableId = resource.reference || resource._id;
                            }
                            
                            const resourceId = resource._stableId;
                            
                            // CRITICAL: Mark resource as being processed during streaming
                            resource._streamingContext = true;
                            
                            // Check if this resource is already rendered inline to avoid duplicates
                            const isAlreadyRendered = currentMessage.content?.includes(`data-resource-id="${resourceId}"`);
                            
                            // Always update data if resource already exists
                            const existingResource = currentMessage.resources?.find((r: any) => 
                                (r._stableId || r.reference || r._id) === resourceId
                            );
                            if (existingResource) {
                                Object.assign(existingResource, resource);
                            }

                            if (!isAlreadyRendered) {
                                // Add resource to the message's resources array first
                                if (!existingResource) {
                                    currentMessage.resources.push(resource);
                                }
                                
                                // Then add the placeholder to content
                                const resourcePlaceholder = `\n\n<div class="inline-resource" data-resource-id="${resourceId}"></div>\n\n`;
                                
                                // Insert resource placeholder at the current end of content to preserve stream order
                                currentMessage.content += resourcePlaceholder;
                                
                                // Update UI immediately after adding each resource for progressive rendering
                                updateUI();
                            }
                        }
                        
                        // Final deduplication of resources array (in case there were any duplicates)
                        const uniqueInlineResources = currentMessage.resources.filter((resource: any, index: number, self: any[]) => {
                            const key = resource.reference || resource._id || index;
                            return index === self.findIndex(r => 
                                (r.reference || r._id || index) === key
                            );
                        });
                        
                        // Update resources array with unique resources
                        currentMessage.resources = uniqueInlineResources;
                    }
                    
                    // Add follow-up suggestions / toolChoices / actionChips — rendered at end via ResourceDetails.
                    // These must get the same synthetic identity as inline resources: without
                    // reference/_id/_stableId, ResourceDetails falls back to `resource-{type}-{index}`
                    // (often `resource-actionChips-0` / `resource-toolChoices-0`). Module-level
                    // dismissed/chosen Sets in those components key off that stableKey, so later
                    // turns would reuse the same key and keep pills hidden for the session.
                    if (followUpSuggestions.length > 0) {
                        if (!currentMessage.resources) {
                            currentMessage.resources = [];
                        }
                        
                        // Filter out duplicates
                        const newFollowUpSuggestions = followUpSuggestions.filter((resource: any) => {
                            return !currentMessage.resources.some((r: any) => 
                                (r.type === 'followUpSuggestions' || r.type === 'toolChoices' || r.type === 'actionChips' || r.type === 'approvalRequest') && 
                                r.type === resource.type &&
                                JSON.stringify(r.data) === JSON.stringify(resource.data)
                            );
                        });

                        for (const resource of newFollowUpSuggestions) {
                            if (!resource.reference && !resource._id) {
                                resource.reference = `resource-${Date.now()}-${Math.random()}`;
                            }
                            if (!resource._stableId) {
                                resource._stableId = resource.reference || resource._id;
                            }
                        }
                        
                        currentMessage.resources.push(...newFollowUpSuggestions);
                    }
                    
                    // Add file resources - render as download links at the bottom
                    if (fileResources.length > 0) {
                        if (!currentMessage.resources) {
                            currentMessage.resources = [];
                        }
                        
                        // Add file resources to the message's resources array (they'll be rendered as download links)
                        currentMessage.resources.push(...fileResources);
                    }
                    
                    // Add source resources - collect for "Quellen" section (mirror server shape: also in resources[])
                    if (sourceResources.length > 0) {
                        if (!currentMessage.sourceResources) {
                            currentMessage.sourceResources = [];
                        }
                        
                        // Deduplicate source resources by URL
                        const allSourceResources = [...currentMessage.sourceResources, ...sourceResources];
                        const uniqueSourceResources = allSourceResources.filter((resource: any, index: number, self: any[]) => {
                            return index === self.findIndex(r => 
                                isSourceResource(r) &&
                                r.url === resource.url &&
                                r.startpage === resource.startpage &&
                                r.endpage === resource.endpage
                            );
                        });
                        
                        currentMessage.sourceResources = uniqueSourceResources;

                        if (!currentMessage.resources) {
                            currentMessage.resources = [];
                        }
                        for (const sr of uniqueSourceResources) {
                            const dup = currentMessage.resources.some((r: any) => {
                                if (!isSourceResource(r)) {
                                    return false;
                                }

                                // Only compare references when both resources actually have one.
                                if (r.reference && sr.reference) {
                                    return r.reference === sr.reference;
                                }

                                return (
                                    !!r.url &&
                                    !!sr.url &&
                                    r.url === sr.url &&
                                    r.startpage === sr.startpage &&
                                    r.endpage === sr.endpage &&
                                    (r.tool ?? '') === (sr.tool ?? '') &&
                                    (r.document ?? '') === (sr.document ?? '')
                                );
                            });
                            if (!dup) {
                                currentMessage.resources.push(sr);
                            }
                        }
                    }

                    // Handle skill agent response if present
                    if (requestId === parsingState.requestId && (payload.output || payload)) {
                        const newSkillAgentResponse = payload.output || payload;
                        setSkillAgentResponse(newSkillAgentResponse);
                    }
                }
                
                /**
                 * Only here, **after** `payload.resources`: a payload may carry
                 * `resources` and `endOfMessage` at the same time — `readPayload` in
                 * the questions panel reads it that way, and its own test uses
                 * exactly this shape. If the branch came first, the main chat would
                 * discard this payload's resources with its `return false`, and a
                 * `navigate`/`highlight` would be silently lost while the panel keeps
                 * it (CONTRACT.md §7.3 requires the same semantics). Today tri-server
                 * writes the two separately; the dependency was not recorded anywhere.
                 */
                // Check for endOfMessage signal
                if (payload.endOfMessage) {
                    // Clear streaming context flags to prevent duplicate shadow resource creation
                    if (currentMessage.resources) {
                        currentMessage.resources.forEach((resource: any) => {
                            if (resource._streamingContext) {
                                delete resource._streamingContext;
                            }
                        });
                    }
                    
                    // Force completion when we receive endOfMessage
                    if (requestId === parsingState.requestId && run.pending) {
                        setRunPending(parsingState.conversationId, false);
                        setTimeoutWarning(false);
                        setManualReconnectAvailable(parsingState.conversationId, false);
                        properties.updateConversation?.(parsingState.newConversation);
                        // Defer refresh so React processes updateConversation first; avoids race where
                        // refresh overwrites with stale data before streamed state is committed
                        queueMicrotask(() => properties.onStreamComplete?.());
                    }
                    
                    // Portal guide, stage 2: now the answer is complete — now we may
                    // point and jump. The boundaries live in `planGuideRelease`: the
                    // entry must belong to this turn (`requestId`), and the
                    // conversation must be the displayed one — otherwise a background
                    // run would yank the user out of the open conversation onto an
                    // unrelated page.
                    releaseGuideBlocks(parsingState.conversationId, requestId, newConversation.messages.length - 1);

                    // Mark stream as completed but continue parsing remaining stream text
                    streamCompleted = true;
                    clearAllReconnectState(run);
                    return false;
                }

                // Update UI for any payload processing to ensure scrolling works
                updateUI();
            } catch (error) {
                console.error('Error parsing payload:', error);
                // Continue processing even if payload parsing fails
            }
        };

        // Main parsing loop - much simpler now!
        while (chunk.length > 0) {
            if (insidePayload) {
                // We're inside a payload block, look for the closing ```
                const endIndex = chunk.indexOf('```');
                        if (endIndex >= 0) {
                            // Found closing ``` - complete the payload
                            payloadBuffer += chunk.substring(0, endIndex);
                            const _shouldStop = processPayload(payloadBuffer);
                            
                            // Reset state and continue with remaining chunk
                            insidePayload = false;
                            payloadBuffer = '';
                            chunk = chunk.substring(endIndex + 3);
                            justClosedPayloadFence = true;
                            
                            // If endOfMessage was received, continue processing remaining chunk content.
                } else {
                    // Still inside payload, accumulate
                    payloadBuffer += chunk;
                    chunk = '';
                }
            } else {
                if (justClosedPayloadFence && (chunk.startsWith('\n') || chunk.startsWith('\r\n'))) {
                    chunk = chunk.startsWith('\r\n') ? chunk.substring(2) : chunk.substring(1);
                }
                justClosedPayloadFence = false;

                // We're in text mode, look for opening ```payload
                const startIndex = chunk.indexOf('```payload');
                if (startIndex >= 0) {
                    // Found opening ```payload - add text before it to message.
                    // Strip one trailing newline: server emits \n```payload as transport framing.
                    let textChunk = chunk.substring(0, startIndex);
                    if (textChunk.endsWith('\r\n')) {
                        textChunk = textChunk.slice(0, -2);
                    } else if (textChunk.endsWith('\n')) {
                        textChunk = textChunk.slice(0, -1);
                    }
                    // Only log longer text chunks to reduce noise
                    if (textChunk.trim() && textChunk.length > 50) {
                        // Adding text chunk
                    }
                    // Ignore whitespace-only framing before payload fences to avoid
                    // splitting markdown words/formatting sequences.
                    if (textChunk.trim() && textChunk !== lastTextChunk) {
                        currentMessage.content += textChunk;
                        lastTextChunk = textChunk;
                    }
                    updateUI();
                    
                    // Start payload accumulation
                    insidePayload = true;
                    payloadBuffer = '';
                    chunk = chunk.substring(startIndex + 11); // Skip '```payload'
                } else {
                    // Just text - add to message
                    // Only log longer text chunks to reduce noise
                    if (chunk.trim() && chunk.length > 50) {
                        // Adding text chunk
                    }
                    if (chunk && chunk !== lastTextChunk) {
                        currentMessage.content += chunk;
                        lastTextChunk = chunk;
                    }
                    updateUI();
                    chunk = '';
                }
            }
        }

        return {
            newConversation,
            payloadBuffer,
            insidePayload,
            requestId,
            streamCompleted,
            lastTextChunk,
            streamRunId,
            resumeFromChunk,
            justClosedPayloadFence,
            conversationId: parsingState.conversationId
        };
    }

    const submitInput = useCallback(async (input: string, prompt?: string, options?: {
        reconnect?: boolean;
        runId?: string;
        resumeFromChunk?: number;
        replayConversation?: any;
        // P3b: pin this turn's routing to a single tool's offer (exclusive tools filter).
        // Set when the user taps a routing-disambiguation choice, so the resume routes
        // deterministically to the chosen tool instead of re-running the ambiguous router.
        exclusiveToolId?: string;
        // Tools named with @ in the input. Unlike `exclusiveToolId` they add to the tool picker's
        // choice instead of replacing it; the server calls each of them (agentLoopRunner).
        exclusiveToolIds?: string[];
        // Fired only after this submission is accepted (pendingRequest set). Pill UIs use
        // this so they do not mark themselves consumed when submitInput no-ops on a
        // still-pending prior turn.
        onAccepted?: () => void;
        // Answer of a `tri:uxElement="select"` task. `input` carries the label for the chat
        // bubble; the server checks the value against the options it reloads.
        selection?: { value: string | number };
        // Answer of a `tri:uxElement="form"` task; `input` carries a short text for the bubble.
        form?: { values: Record<string, unknown> };
    }) => {
        // The single choke point through which every write passes — all nine call sites end up
        // here. Gating the textarea alone would leave the slider, the confirmation button and the
        // action chips able to write, so the refusal lives here as well as in the UI.
        if (properties.readOnly) return;

        const isResumeAttempt = Boolean(options?.reconnect && options?.runId);
        // The conversation this run belongs to, fixed at submit time: the user may
        // switch away while it streams, and every piece of run state — including
        // the stream's own conversation id — has to keep pointing here.
        const conversationAtSubmit = conversationRef.current;
        const targetConversationId = (conversationAtSubmit as any)?._id ?? null;
        const run = ensureChatRun(runsRef.current, targetConversationId);
        const isDisplayedRun = () => isDisplayedConversation(targetConversationId, conversationRef.current?._id);
        // Empty input is rejected by default — but checklist completion can
        // submit without a typed comment (the checklist payload is the input).
        const activeTaskAtSubmit = (conversationRef.current as any)?.activeTask;
        const activeTaskAtSubmitNodeId = activeTaskAtSubmit?.nodeId;
        const activeTaskAtSubmitUxElement =
            activeTaskAtSubmit?.triAttrs?.uxElement
            ?? activeTaskAtSubmit?.extensions?.['tri:uxElement']
            ?? (conversationRef.current as any)?.triAttrsByNodeId?.[activeTaskAtSubmitNodeId]?.uxElement;
        const isChecklistCompletionAction =
            !!activeTaskAtSubmit
            && activeTaskAtSubmitUxElement === 'checklist'
            && taskAction === 'complete';
        const isEmptyCompletion =
            isChecklistCompletionAction
            && (!input || input.trim().length === 0);
        if (!isEmptyCompletion && (!input || input.trim().length === 0)) {
            return;
        }

        // Don't allow a second request in *this* conversation; another
        // conversation may well be streaming at the same time.
        if (run.pending) {
            return;
        }

        const checklistPatchFlushed = await flushChecklistPatch();
        if (!checklistPatchFlushed && !isResumeAttempt && isChecklistCompletionAction) {
            const currentConversation = conversationRef.current;
            if (currentConversation) {
                const withError = cloneConversation(currentConversation);
                withError.messages.push(new Message({
                    type: MessageType.botMessage,
                    content: t('chatMessages.communicationProblems'),
                    confirmation: false,
                    resources: [],
                }));
                setConversation(withError);
                properties.updateConversation?.(withError);
            } else {
                showMessageDialog(
                    t('chatBotPage.workInProcessCompletedTitle'),
                    t('chatMessages.communicationProblems'),
                    undefined,
                    'error',
                );
            }
            return;
        }

        input = capitalizeFirstLetter(input);
        const actualPrompt = prompt || input;

        // Check if conversation exists before accessing messages
        if (!conversationAtSubmit || !conversationAtSubmit.messages) {
            console.error('No conversation available for input submission');
            return;
        }

        const activeTask = (conversationAtSubmit as any)?.activeTask;
        const isCompleteTaskFlow = !isResumeAttempt && activeTask && taskAction === 'complete';

        if (isCompleteTaskFlow && properties.updateConversation && properties.onCompleteTaskClosed) {
            // The task belongs to the conversation the answer was given in, even if
            // the awaits above let the user switch away in the meantime.
            const conv = isDisplayedRun() ? conversationRef.current : conversationAtSubmit;
            const convId = conv?._id;
            const taskId = activeTask?._id;
            if (!convId || !taskId) return;

            const lastTaskActivation = (conv.messages || []).slice().reverse().find((m: any) => (m as any)._taskActivation) as any;
            const botMessageToSend = lastTaskActivation
                ? { content: lastTaskActivation.content, confirmation: lastTaskActivation.confirmation, resources: lastTaskActivation.resources }
                : undefined;

            const newConversation = cloneConversation(conv);
            // Don't push a blank user bubble when the user clicks Send on a
            // checklist (no typed comment). Keeps the chat clean.
            if (input && input.trim().length > 0) {
                newConversation.messages.push(new Message({
                    type: MessageType.userMessage,
                    content: input,
                    confirmation: false,
                    resources: [],
                    user: { id: authentication.id ?? authentication._id, firstName: authentication.firstName, lastName: authentication.lastName, email: authentication.email } as any
                }));
            }
            run.snapshot = newConversation;
            if (isDisplayedRun()) {
                setConversation(newConversation);
                conversationRef.current = newConversation;
            }
            setInputValue('');
            setShowSuggestions(false);
            setShowSampleRequests(false);
            // New turn: leftovers of an aborted earlier run (`navigate`/`highlight`,
            // never redeemed at `endOfMessage`) don't belong to it.
            guideBlocksRef.current.delete(targetConversationId);
            setRunPending(targetConversationId, true);
            options?.onAccepted?.();

            try {
                const result = await userAPI.completeConversationTask(
                    authentication.customer,
                    convId,
                    taskId,
                    input,
                    botMessageToSend,
                    options?.selection,
                    options?.form
                );
                if (result) {
                    run.snapshot = result;
                    // The user may have switched conversations while the task was
                    // completing; the sidebar still gets the result below.
                    if (isDisplayedRun()) {
                        // No jump to the end here: `MessageScroller` is still following if
                        // the reader was, and a reader who scrolled up stays where they are.
                        applyIncomingConversation(result);
                    } else {
                        properties.updateConversation?.(result);
                    }
                }
                // Treat only a missing response as terminal completion; an empty/absent
                // worklist in a valid response can represent an in-progress state. The user may
                // have moved on while this was awaiting, so the notice is suppressed unless the
                // finished conversation is still on screen — its acknowledge handler closes
                // whatever conversation is displayed, which would be the wrong one.
                if (shouldShowProcessCompletionDialog(!!result, isDisplayedRun())) {
                    showMessageDialog(
                        t('chatBotPage.workInProcessCompletedTitle'),
                        t('chatBotPage.workInProcessCompleted'),
                        async () => { await properties.onCompleteTaskClosed?.(); },
                        'success'
                    );
                }
            } catch (err) {
                // The connection dropped, but the server carries the process on: follow the run
                // and show what it wrote, instead of reporting a failure over work that succeeded.
                if (err instanceof TaskCompletionInterruptedError) {
                    const followed = await followInterruptedTaskCompletion(convId);
                    if (followed) {
                        if (followed.processEnded && shouldShowProcessCompletionDialog(false, isDisplayedRun())) {
                            showMessageDialog(
                                t('chatBotPage.workInProcessCompletedTitle'),
                                t('chatBotPage.workInProcessCompleted'),
                                async () => { await properties.onCompleteTaskClosed?.(); },
                                'success'
                            );
                        }
                        return;
                    }
                }
                console.error('Task completion failed:', err);
                const withError = cloneConversation(newConversation);
                withError.messages.push(new Message({
                    type: MessageType.botMessage,
                    content: t('chatMessages.communicationProblems'),
                    confirmation: false,
                    resources: []
                }));
                run.snapshot = withError;
                if (isDisplayedRun()) {
                    setConversation(withError);
                }
                properties.updateConversation?.(withError);
            } finally {
                setRunPending(targetConversationId, false);
            }
            return;
        }

        // The awaits above can outlive the conversation being open (a switch lands
        // between them), so the run builds on the conversation it was submitted in
        // rather than on whatever is displayed by now.
        const baseConversation = isDisplayedRun() ? conversationRef.current : conversationAtSubmit;
        const lastBaseMessage = baseConversation?.messages?.[baseConversation.messages.length - 1] as any;
        const allowsConfirmation = !isResumeAttempt && (baseConversation?.messages?.length ?? 0) > 0
            && (lastBaseMessage?.type === 'botSuggestion' || lastBaseMessage?.confirmation);
        const reconnectBaseConversation = cloneConversation(options?.replayConversation || baseConversation);
        let newConversation = cloneConversation(options?.replayConversation || baseConversation);

        if (!isResumeAttempt) {
            newConversation.messages.push(new Message({
                type: MessageType.userMessage,
                content: input,
                confirmation: false,
                resources: [],
                user: { id: authentication.id ?? authentication._id, firstName: authentication.firstName, lastName: authentication.lastName, email: authentication.email } as any
            }));
        } else {
            const lastMessage = newConversation.messages?.[newConversation.messages.length - 1];
            if (!lastMessage || lastMessage.type !== MessageType.botMessage) {
                newConversation.messages.push(new Message({
                    type: MessageType.botMessage,
                    content: '',
                    confirmation: false,
                    resources: []
                }));
            }
        }

        // Set conversation first so the new message exists — but only while this
        // run's conversation is the one on screen.
        run.snapshot = newConversation;
        if (isDisplayedRun()) {
            setConversation(newConversation);
            // Update conversationRef immediately to keep it in sync
            conversationRef.current = newConversation;

            // Scroll the new message into view
            scrollToBottom();
        }

        setInputValue('');
        setShowSuggestions(false);
        setShowSampleRequests(false);

        if (allowsConfirmation && lastBaseMessage) {
            if (input.trim().toLowerCase() === 'yes' && lastBaseMessage.type === 'botSuggestion') {
                input = lastBaseMessage.content || input;
            } else if (input.trim().toLowerCase() === 'no') {
                textField.current?.focus();

                return;
            }
        } else if (!isResumeAttempt) {
            recordRequest(input);
        }

        if (!isResumeAttempt) {
            run.replayRequest = {
                conversation: reconnectBaseConversation,
                input,
                prompt: actualPrompt,
                exclusiveToolId: options?.exclusiveToolId,
                exclusiveToolIds: options?.exclusiveToolIds,
            };
            clearSavedReconnectState(run);
        }
        setManualReconnectAvailable(targetConversationId, false);

        // New turn: leftovers of an aborted earlier run (`navigate`/`highlight`,
        // never redeemed at `endOfMessage`) don't belong to it.
        guideBlocksRef.current.delete(targetConversationId);
        setRunPending(targetConversationId, true);
        options?.onAccepted?.();

        // Initialize stream activity tracking
        run.lastStreamActivity = Date.now();

        // Declare timeoutId at function scope
        let timeoutId: NodeJS.Timeout | undefined;

        try {
            const userContext = {
                firstName: authentication.firstName,
                lastName: authentication.lastName,
                email: authentication.email
            };

            // Enrich the location context with device coordinates when geolocation
            // has resolved; otherwise fall back to just the space name.
            const locationContext: any = { spaceName: 'Space1' };
            const c = geoCoordsRef.current;
            if (c && Number.isFinite(c.lat) && Number.isFinite(c.lng)) {
                locationContext.lat = c.lat;
                locationContext.lon = c.lng;
            }



            // Create abort controller for this request
            const requestAbortController = new AbortController();
            run.abortController = requestAbortController;
            run.abortCause = null;

            // Add timeout protection
            // Show timeout warning 30 seconds before actual timeout
            const warningTimeout = Math.max(0, configuration.requestTimeout - 30000);
            if (warningTimeout > 0) {
                setTimeout(() => {
                    if (run.pending && run.requestId !== null) {
                        setTimeoutWarning(true);
                    }
                }, warningTimeout);
            }

            // Modified timeout: Only abort connection, don't hide progress bubbles if stream is still active
            timeoutId = setTimeout(() => {
                if (run.abortController) {
                    // Check if stream has been inactive for more than 30 seconds
                    const streamInactive = !run.lastStreamActivity ||
                                         (Date.now() - run.lastStreamActivity) > 30000;

                    if (streamInactive) {
                        run.abortCause = TIMEOUT_ABORT_REASON;
                        run.abortController.abort(TIMEOUT_ABORT_REASON);
                    } else {
                        setTimeoutWarning(true); // Keep showing warning but don't abort active stream
                    }
                }
            }, configuration.requestTimeout); // Configurable timeout from configuration

            // if (newSkillAgentResponse.skill && newSkillAgentResponse.followUp === 'clientAction') {
            //     if (newSkillAgentResponse.resources && newSkillAgentResponse.resources[0] && newSkillAgentResponse.resources[0].path) {
            //         navigate(newSkillAgentResponse.resources[0].path);
            //     } else {
            //         // TODO Should generate error text
            //         toggleHideDialog();
            //     }
            // } else {        

            if (!isResumeAttempt) {
                newConversation.messages.push(new Message({
                    type: MessageType.botMessage,
                    content: '',
                    confirmation: false,
                    resources: []
                }));
            }
            const initialStreamingConversation = cloneConversation(newConversation);
            const allowFullRestartFallback = Boolean(properties.toolsFilter?.toolVersion);

            // Generate unique request ID to prevent race conditions
            const requestId = Date.now() + Math.random();
            run.requestId = requestId;

            const createInitialParsingState = (): {
                newConversation: any;
                payloadBuffer: string;
                insidePayload: boolean;
                requestId: number;
                streamCompleted: boolean;
                lastTextChunk: string;
                streamRunId: string | null;
                resumeFromChunk: number;
                justClosedPayloadFence: boolean;
                conversationId: unknown;
            } => ({
                newConversation: cloneConversation(initialStreamingConversation),
                payloadBuffer: '',
                insidePayload: false,
                requestId: requestId,
                streamCompleted: false,
                lastTextChunk: '',
                streamRunId: null,
                resumeFromChunk: 0,
                justClosedPayloadFence: false,
                conversationId: targetConversationId,
            });
            let parsingState = createInitialParsingState();
            resetStreamReconnectState(run);
            if (isResumeAttempt && options?.runId) {
                const initialResumeFromChunk = Math.max(0, options.resumeFromChunk ?? 0);
                run.reconnect = {
                    runId: options.runId,
                    resumeFromChunk: initialResumeFromChunk,
                };
                parsingState.streamRunId = options.runId;
                parsingState.resumeFromChunk = initialResumeFromChunk;
            }
            const maxReconnectAttempts = 3;
            let reconnectAttempts = 0;
            // P3b: when a routing-disambiguation choice was tapped, pin this turn to the
            // chosen tool's offer via the exclusive tools filter (merged onto any existing
            // toolsFilter) so routing is deterministic instead of re-running the near-tie.
            // Tools named with @ go along with the picker's choice — all of them, not just one.
            const pinnedToolIds = options?.exclusiveToolId
                ? [options.exclusiveToolId]
                : options?.exclusiveToolIds?.length
                    ? Array.from(new Set([...options.exclusiveToolIds, ...(properties.selectedToolId ? [properties.selectedToolId] : [])]))
                    : [];
            const effectiveToolsFilter = pinnedToolIds.length
                ? { ...((properties.toolsFilter as any) || {}), exclusiveToolsFilter: pinnedToolIds }
                : properties.toolsFilter;
            const persistPartialStreamState = () => {
                const currentMessage = parsingState.newConversation.messages[parsingState.newConversation.messages.length - 1];
                const hasRenderableContent =
                    Boolean(currentMessage?.content?.trim()) ||
                    Boolean(currentMessage?.resources?.length) ||
                    Boolean(currentMessage?.sourceResources?.length);

                if (hasRenderableContent) {
                    properties.updateConversation?.(parsingState.newConversation);
                }
            };

            const clearPendingStreamState = () => {
                setShowSuggestions(false);
                setRunPending(targetConversationId, false);
                setTimeoutWarning(false);
                // If the run ends here instead of at `endOfMessage` (stop, timeout,
                // exhausted retries), the remembered guide block is discarded. The
                // `requestId` in the entry would prevent redeeming it anyway; this
                // is the matching cleanup.
                guideBlocksRef.current.delete(targetConversationId);
            };
            const restartStreamFromBeginning = () => {
                clearAllReconnectState(run);
                parsingState = createInitialParsingState();
                const restartedConversation = cloneConversation(parsingState.newConversation);
                run.snapshot = restartedConversation;
                if (isDisplayedRun()) {
                    setConversation(restartedConversation);
                    conversationRef.current = restartedConversation;
                    setChatUpdate(Date.now() + Math.random());
                }
                run.lastStreamActivity = Date.now();
            };

            while (!parsingState.streamCompleted) {
                const isReconnect = reconnectAttempts > 0 || isResumeAttempt;
                const hasReconnectCursor = Boolean(run.reconnect.runId);
                run.abortCause = null;
                const attemptAbortController = new AbortController();
                run.attemptAbortController = attemptAbortController;
                const { signal: streamAttemptSignal, cleanup: cleanupStreamAttemptSignal } = createLinkedAbortSignal(
                    requestAbortController.signal,
                    attemptAbortController.signal
                );
                if (isReconnect && hasReconnectCursor) {
                    console.info('Reconnecting stream with cursor', {
                        runId: run.reconnect.runId,
                        resumeFromChunk: run.reconnect.resumeFromChunk,
                    });
                }
                const responseStream = await userAPI.streamPromptResponse(
                    // The run's own conversation — never the one on screen, which
                    // the user may have switched in the meantime.
                    targetConversationId || '',
                    agent,
                    'Profile1',
                    isReconnect && hasReconnectCursor ? '' : actualPrompt,
                    { location: locationContext, user: userContext, locale: i18next.resolvedLanguage || 'de', llm: selectedModel, engine },
                    effectiveToolsFilter,
                    streamAttemptSignal,
                    isReconnect && hasReconnectCursor
                        ? {
                            reconnect: true,
                            runId: run.reconnect.runId || undefined,
                            resumeFromChunk: run.reconnect.resumeFromChunk,
                        }
                        : undefined,
                    pinnedToolIds.length ? undefined : (properties.selectedToolId || undefined),
                ) as any;

                // Clear timeout warning after successful (re)connect
                clearTimeout(timeoutId);
                setTimeoutWarning(false);

                const headerRunId = responseStream?.headers?.get('X-Stream-Run-Id') || responseStream?.headers?.get('x-stream-run-id');
                if (headerRunId && headerRunId.trim().length > 0) {
                    run.reconnect.runId = headerRunId.trim();
                    parsingState.streamRunId = headerRunId.trim();
                }

                if (!responseStream?.body) {
                    cleanupStreamAttemptSignal();
                    throw new Error('Streaming response body is missing.');
                }

                let writerAbortReason: unknown = null;
                const writer = new WritableStream({
                    write(chunk) {
                        parsingState = parseMessageChunk(chunk, parsingState);
                    },
                    abort(reason) {
                        writerAbortReason = reason;
                    },
                    close() {
                        if (requestId !== parsingState?.requestId) {
                            return;
                        }
                        if (!parsingState.streamCompleted) {
                            return;
                        }
                        clearPendingStreamState();
                        clearAllReconnectState(run);
                        setManualReconnectAvailable(targetConversationId, false);
                        properties.updateConversation?.(parsingState.newConversation);
                    }
                });
                run.lastStreamActivity = Date.now();
                const stallReconnectIntervalId = setInterval(() => {
                    if (parsingState.streamCompleted || streamAttemptSignal.aborted) {
                        return;
                    }

                    const lastActivity = run.lastStreamActivity ?? 0;
                    if ((Date.now() - lastActivity) < STREAM_STALL_RECONNECT_AFTER_MS) {
                        return;
                    }

                    run.abortCause = STREAM_STALL_RECONNECT_REASON;
                    attemptAbortController.abort(STREAM_STALL_RECONNECT_REASON);
                }, STREAM_STALL_CHECK_INTERVAL_MS);
                
                try {
                    await responseStream.body
                        .pipeThrough(new TextDecoderStream("utf-8"))
                        .pipeTo(writer);
                } catch (pipeError: any) {
                    const abortReason = getRequestAbortReason(pipeError) ??
                        getRequestAbortReason(writerAbortReason) ??
                        getRequestAbortReason(streamAttemptSignal.reason) ??
                        getRequestAbortReason(attemptAbortController.signal.reason) ??
                        getRequestAbortReason(requestAbortController.signal?.reason) ??
                        run.abortCause;

                    if (
                        abortReason === MANUAL_RECONNECT_REASON ||
                        abortReason === STREAM_STALL_RECONNECT_REASON ||
                        isReconnectableStreamError(pipeError) ||
                        isReconnectableStreamError(writerAbortReason)
                    ) {
                        if (
                            (
                                requestAbortController.signal?.aborted &&
                                abortReason !== STREAM_STALL_RECONNECT_REASON &&
                                abortReason !== MANUAL_RECONNECT_REASON
                            ) ||
                            requestId !== parsingState?.requestId ||
                            !run.pending
                        ) {
                            return;
                        }

                        if (!run.reconnect.runId) {
                            if (allowFullRestartFallback) {
                                reconnectAttempts += 1;
                                if (reconnectAttempts > maxReconnectAttempts) {
                                    throw new Error('Stream restart failed after multiple attempts.');
                                }
                                console.warn('Restarting stalled test-mode stream from the beginning because no reconnect cursor is available.');
                                restartStreamFromBeginning();
                                await new Promise(resolve => setTimeout(resolve, Math.min(1000 * reconnectAttempts, 3000)));
                                continue;
                            }
                            throw new Error('Stream interrupted and reconnect state is missing.');
                        }

                        reconnectAttempts += 1;
                        if (reconnectAttempts > maxReconnectAttempts) {
                            saveReconnectState(run, parsingState.newConversation);
                            throw new Error('Stream reconnect failed after multiple attempts.');
                        }

                        await new Promise(resolve => setTimeout(resolve, Math.min(1000 * reconnectAttempts, 3000)));
                        continue;
                    }

                    if (isAbortError(pipeError) || isAbortError(writerAbortReason)) {
                        if (abortReason === TIMEOUT_ABORT_REASON) {
                            if (requestId === parsingState?.requestId) {
                                parsingState.newConversation.messages.push(new Message({
                                    type: MessageType.botMessage,
                                    content: t('chatMessages.requestTimeout', { timeout: configuration.requestTimeout / 1000 }),
                                    confirmation: false,
                                    resources: []
                                }));
                                properties.updateConversation?.(parsingState.newConversation);
                                saveReconnectState(run, parsingState.newConversation);
                                setManualReconnectAvailable(targetConversationId, true);
                                clearPendingStreamState();
                                resetStreamReconnectState(run);
                            }
                            return;
                        }

                        setManualReconnectAvailable(targetConversationId, false);
                        clearAllReconnectState(run);
                        clearPendingStreamState();
                        return;
                    }

                    if (requestId === parsingState?.requestId) {
                        console.warn('Suppressing post-response stream interruption UI', {
                            pipeError,
                            writerAbortReason,
                        });
                        persistPartialStreamState();
                        saveReconnectState(run, parsingState.newConversation);
                        if (run.reconnect.runId) {
                            reconnectAttempts += 1;
                            if (reconnectAttempts <= maxReconnectAttempts) {
                                console.info('Auto-retrying interrupted stream after suppressed post-response error.', {
                                    reconnectAttempts,
                                    runId: run.reconnect.runId,
                                    resumeFromChunk: run.reconnect.resumeFromChunk,
                                });
                                await new Promise(resolve => setTimeout(resolve, Math.min(1000 * reconnectAttempts, 3000)));
                                continue;
                            }
                        } else if (allowFullRestartFallback) {
                            reconnectAttempts += 1;
                            if (reconnectAttempts <= maxReconnectAttempts) {
                                console.warn('Auto-restarting interrupted test-mode stream after suppressed post-response error because no reconnect cursor is available.');
                                restartStreamFromBeginning();
                                await new Promise(resolve => setTimeout(resolve, Math.min(1000 * reconnectAttempts, 3000)));
                                continue;
                            }
                        }
                        setManualReconnectAvailable(targetConversationId, true);
                        resetStreamReconnectState(run);
                        clearPendingStreamState();
                    }
                    return;
                } finally {
                    clearInterval(stallReconnectIntervalId);
                    if (run.attemptAbortController === attemptAbortController) {
                        run.attemptAbortController = null;
                    }
                    cleanupStreamAttemptSignal();
                }

                if (parsingState.streamCompleted) {
                    break;
                }

                if (
                    requestAbortController.signal?.aborted ||
                    requestId !== parsingState?.requestId ||
                    !run.pending
                ) {
                    return;
                }

                if (!run.reconnect.runId) {
                    if (allowFullRestartFallback) {
                        reconnectAttempts += 1;
                        if (reconnectAttempts > maxReconnectAttempts) {
                            throw new Error('Stream restart failed after multiple attempts.');
                        }
                        console.warn('Restarting incomplete test-mode stream from the beginning because no reconnect cursor is available.');
                        restartStreamFromBeginning();
                        await new Promise(resolve => setTimeout(resolve, Math.min(1000 * reconnectAttempts, 3000)));
                        continue;
                    }
                    throw new Error('Stream interrupted and reconnect state is missing.');
                }

                reconnectAttempts += 1;
                if (reconnectAttempts > maxReconnectAttempts) {
                    saveReconnectState(run, parsingState.newConversation);
                    throw new Error('Stream reconnect failed after multiple attempts.');
                }

                await new Promise(resolve => setTimeout(resolve, Math.min(1000 * reconnectAttempts, 3000)));
            }

            setShowSuggestions(false);
            
            // Note: pendingRequest will be set to false when endOfMessage is received
            // or when the stream is closed/aborted
        } catch (error: any) {
            // Clear timeout if it exists
            if (typeof timeoutId !== 'undefined') {
                clearTimeout(timeoutId);
            }

            const abortReason = getRequestAbortReason(error) ??
                getRequestAbortReason(run.abortController?.signal?.reason) ??
                run.abortCause;

            // Errors belong to the run's conversation; when the user has switched
            // away the message is still persisted, just not drawn over what is
            // currently on screen.
            const showInPlace = (updated: any) => {
                run.snapshot = updated;
                if (isDisplayedRun()) {
                    setConversation(updated);
                }
            };

            // Check if this is a timeout error
            if ((error instanceof Error && error.name === 'AbortError' && error.message?.includes('timeout')) || abortReason === TIMEOUT_ABORT_REASON) {
                if (run.requestId !== null) {
                    newConversation.messages.push(new Message({
                        type: MessageType.botMessage,
                        content: t('chatMessages.requestTimeout', { timeout: configuration.requestTimeout / 1000 }),
                        confirmation: false,
                        resources: []
                    }));
                    showInPlace(cloneConversation(newConversation));
                    setShowSuggestions(false);
                    setRunPending(targetConversationId, false);
                    setTimeoutWarning(false); // Clear timeout warning
                    setManualReconnectAvailable(targetConversationId, true);
                }
                saveReconnectState(run, newConversation);
                resetStreamReconnectState(run);
                return;
            }

            if (isReconnectableStreamError(error)) {
                saveReconnectState(run, newConversation);
                resetStreamReconnectState(run);
                setShowSuggestions(false);
                setRunPending(targetConversationId, false);
                setTimeoutWarning(false);
                setManualReconnectAvailable(targetConversationId, true);
                return;
            }

            // Check if this is an abort error (user cancelled the request)
            if (isAbortError(error)) {
                clearAllReconnectState(run);
                setShowSuggestions(false);
                setRunPending(targetConversationId, false);
                setTimeoutWarning(false); // Clear timeout warning
                setManualReconnectAvailable(targetConversationId, false);
                return;
            }

            // Log the error for debugging
            console.error('Chat request failed:', error);

            // Add error message for any other errors
            // Only add error message if this is still the current request
            if (run.requestId !== null) {
                saveReconnectState(run, newConversation);
                newConversation.messages.push(new Message({
                    type: MessageType.botMessage,
                    content: t('chatMessages.communicationProblems'),
                    confirmation: false,
                    resources: []
                }));

                showInPlace(cloneConversation(newConversation));
                setShowSuggestions(false);
                setRunPending(targetConversationId, false);
                setTimeoutWarning(false); // Clear timeout warning
                setManualReconnectAvailable(targetConversationId, true);
            }
            resetStreamReconnectState(run);

            return t('chatMessages.communicationProblems');
        }
    }, [agent, id, recordRequest, authentication, selectedModel, engine, properties.toolsFilter, properties.selectedToolId, properties.updateConversation, properties.onCompleteTaskClosed, taskAction, applyIncomingConversation, flushChecklistPatch, setConversation, setInputValue, setShowSuggestions, setShowSampleRequests, setRunPending, setManualReconnectAvailable, t]);

    // Stage 3: a click on a follow-up question or card becomes a message — the same path as typing.
    useChatSendRunner(submitInput);

    /**
     * Complete the active task with `rawInput` without making the user wait for
     * the file uploads they just started. Works for any task answer — a "Ja"/
     * "Nein" from a slider, a "Bestätigt", or a typed prompt. The task
     * disappears from the conversation immediately; a small floating bubble
     * reports the upload, and the moment the last upload settles the BPM task is
     * completed server-side (which continues the process). Used only for the
     * completion action while uploads are in flight; with no uploads pending,
     * submitInput handles it inline as before.
     */
    const submitActiveTaskInBackground = useCallback(async (rawInput: string) => {
        const conv = conversationRef.current as any;
        const activeTask = conv?.activeTask;
        const convId = conv?._id;
        const taskId = activeTask?._id;
        if (!convId || !taskId) return;

        const input = capitalizeFirstLetter(rawInput);
        const lastTaskActivation = (conv.messages || [])
            .slice()
            .reverse()
            .find((m: any) => (m as any)._taskActivation) as any;
        const botMessageToSend = lastTaskActivation
            ? {
                  content: lastTaskActivation.content,
                  confirmation: lastTaskActivation.confirmation,
                  resources: lastTaskActivation.resources,
              }
            : undefined;

        // Optimistically drop the task so its UI disappears and the sidebar row
        // stops showing it. Clearing both activeTask and worklist is what keeps
        // ChatBot.updateConversation from re-activating it on the next refresh.
        const optimistic = cloneConversation(conv);
        if (input && input.trim().length > 0) {
            optimistic.messages.push(
                new Message({
                    type: MessageType.userMessage,
                    content: input,
                    confirmation: false,
                    resources: [],
                    user: {
                        id: authentication.id ?? authentication._id,
                        firstName: authentication.firstName,
                        lastName: authentication.lastName,
                        email: authentication.email,
                    } as any,
                })
            );
        }
        delete (optimistic as any).activeTask;
        (optimistic as any).worklist = ((optimistic as any).worklist || []).filter(
            (task: any) => String(task._id) !== String(taskId)
        );
        backgroundCompletingTaskIdsRef.current.add(String(taskId));
        setConversation(optimistic);
        conversationRef.current = optimistic;
        properties.updateConversation?.(optimistic as Conversation);
        setInputValue('');
        setShowSuggestions(false);

        const opId = `${convId}-${taskId}-${Date.now()}`;
        const firstLine = String(conv.messages?.[0]?.content || '').split('\n')[0].trim();
        const title = firstLine.slice(0, 80) || t('chatExchange.newConversation');
        setBackgroundConfirms((prev) => [
            ...prev,
            { id: opId, convId: String(convId), title, status: 'uploading' },
        ]);

        try {
            await waitForUploadsToSettle();
            setBackgroundConfirms((prev) =>
                prev.map((op) => (op.id === opId ? { ...op, status: 'completing' } : op))
            );
            const result = await userAPI.completeConversationTask(
                authentication.customer,
                convId,
                taskId,
                input,
                botMessageToSend
            );
            // Apply the fresh conversation only if the user is still looking at it;
            // either way refresh the sidebar so the next task surfaces.
            if (result && String(conversationRef.current?._id) === String(convId)) {
                applyIncomingConversation(result);
            }
            backgroundCompletingTaskIdsRef.current.delete(String(taskId));
            properties.onStreamComplete?.();
            setBackgroundConfirms((prev) => prev.filter((op) => op.id !== opId));
        } catch (err) {
            console.error('Background task confirmation failed:', err);
            // The BPM task is still open server-side — resync so it reappears,
            // and leave a dismissable error bubble.
            backgroundCompletingTaskIdsRef.current.delete(String(taskId));
            setBackgroundConfirms((prev) =>
                prev.map((op) => (op.id === opId ? { ...op, status: 'error' } : op))
            );
            properties.onStreamComplete?.();
        }
    }, [
        authentication,
        waitForUploadsToSettle,
        applyIncomingConversation,
        properties,
        setConversation,
        setInputValue,
        setShowSuggestions,
        t,
    ]);

    /**
     * Single entry point for every task answer (Ja/Nein, Bestätigt, a typed
     * prompt). While an active task's files are still uploading it hands the
     * completion to the background so the user is freed at once; otherwise it
     * falls through to the normal inline submit. Plain chat (no active task)
     * keeps blocking during an upload, as before.
     */
    const submitTaskInput = useCallback(
        (rawInput: string) => {
            const activeTask = (conversationRef.current as any)?.activeTask;
            const isTaskCompleteFlow = !!activeTask && taskAction === 'complete';
            const hasInput = !!rawInput && rawInput.trim().length > 0;
            if (isTaskCompleteFlow && isUploadingRef.current && hasInput) {
                void submitActiveTaskInBackground(rawInput);
                return;
            }
            // No active task, or empty input: keep the old rule of not sending
            // while an upload is still in flight.
            if (isUploadingRef.current) return;
            // In process mode the answer bypasses tool routing — @ names nothing there.
            const mentioned = activeTask ? [] : findMentionedTools(rawInput ?? '', properties.customerTools ?? []);
            submitInput(rawInput, undefined, mentioned.length ? { exclusiveToolIds: mentioned.map((tool) => tool.id) } : undefined);
        },
        [taskAction, submitActiveTaskInBackground, submitInput, properties.customerTools]
    );

    replayLastRequestRef.current = () => {
        // A replay is always triggered from the conversation on screen.
        const replayConversationId = conversationRef.current?._id ?? null;
        const run = getChatRun(runsRef.current, replayConversationId);
        const replay = run?.replayRequest;
        if (!replay) {
            console.warn('Reconnect requested but no replayable request is available.');
            return;
        }

        const reconnectCursor = run.savedCursor;
        const reconnectConversation = reconnectCursor
            ? cloneConversation(run.savedConversation || conversationRef.current || replay.conversation)
            : null;
        const restoredConversation = reconnectConversation || cloneConversation(replay.conversation);
        run.abortCause = null;
        run.abortController = null;
        run.attemptAbortController = null;
        resetStreamReconnectState(run);
        setTimeoutWarning(false);
        setManualReconnectAvailable(replayConversationId, false);
        setRunPending(replayConversationId, false);
        run.snapshot = restoredConversation;
        setConversation(restoredConversation);
        conversationRef.current = restoredConversation;
        setChatUpdate(Date.now() + Math.random());
        if (reconnectCursor && reconnectConversation) {
            console.info('Replaying request with saved stream cursor', reconnectCursor);
            void submitInput(replay.input, replay.prompt, {
                reconnect: true,
                runId: reconnectCursor.runId,
                resumeFromChunk: reconnectCursor.resumeFromChunk,
                replayConversation: reconnectConversation,
                exclusiveToolId: replay.exclusiveToolId,
                exclusiveToolIds: replay.exclusiveToolIds,
            });
            return;
        }
        void submitInput(
            replay.input,
            replay.prompt,
            replay.exclusiveToolId || replay.exclusiveToolIds?.length
                ? { exclusiveToolId: replay.exclusiveToolId, exclusiveToolIds: replay.exclusiveToolIds }
                : undefined,
        );
    };

    const submitSuggestion = (suggestion: Suggestion) => {
        setInputValue(suggestion.text);
        setShowSuggestions(false);
        // Ein Vorschlag stammt aus einem bestimmten Werkzeug — dorthin geht er auch, statt die
        // Auswahl dem Routing zu überlassen, das ein Beispiel eines anderen Werkzeugs anders deuten kann.
        submitInput(suggestion.text, undefined, suggestion.toolId ? { exclusiveToolId: suggestion.toolId } : undefined);
    }

    const toolMentions = useToolMentions({
        tools: properties.customerTools ?? [],
        value: inputValue ?? '',
        onValueChange: setInputValue,
        fieldRef: textField,
        enabled: !(conversation as any)?.activeTask && !properties.readOnly,
    });

    const onKeyDown = (event: any) => {
        if (toolMentions.handleKeyDown(event)) return;
        if (event.key === 'Enter') {
            if (event.shiftKey) {
                // Allow SHIFT + ENTER for line breaks, don't submit
                return;
            } else {
                // Submit on ENTER without SHIFT. submitTaskInput decides whether
                // to hand an active task's completion to the background (uploads
                // in flight) or block a plain-chat send during an upload.
                event.preventDefault();
                submitTaskInput(inputValue);
            }
        } else if (event.key === 'ArrowUp') {
            const newRequestIndex = Math.max(requestIndex - 1, 0);

            setRequestIndex(newRequestIndex);
            setInputValue(requests[newRequestIndex]);
            event.preventDefault();

            return false;
        } else if (event.key === 'ArrowDown') {
            const newRequestIndex = Math.min(requestIndex + 1, requests.length - 1);

            setRequestIndex(newRequestIndex);
            setInputValue(requests[newRequestIndex]);
            event.preventDefault();

            return false;
        }
    };

    useSpeech((text: string, final: any) => {
        setInputValue(text);

        if (final) {
            setTranscribing(false);
            setTimeout(() => {
                if (textField.current) {
                    textField.current.focus();
                    textField.current.select();
                }
            }, 0);
        }
    }, transcribing);

    useEffect(() => {
        if (!properties.conversation) return;
        const incoming = properties.conversation;
        const prev = conversationRef.current;
        const isSwitchingConversation = incoming._id !== prev?._id;
        if (isSwitchingConversation) {
            clearBotRunState();
        }
        const incomingRun = getChatRun(runsRef.current, incoming._id);
        // Switching back into a conversation that is still streaming: its own
        // snapshot is ahead of anything the server can return for it, so the
        // stream is picked up where it stands instead of being rewound.
        const liveSnapshot = isSwitchingConversation && incomingRun?.pending ? incomingRun.snapshot : null;
        const incomingAddsMessages = (incoming.messages?.length ?? 0) > (prev?.messages?.length ?? 0);
        // Don't overwrite with stale data: refresh may return before server has persisted streamed content
        const incomingHasFewerMessages = (incoming.messages?.length ?? 0) < (prev?.messages?.length ?? 0);
        if (!isSwitchingConversation && incomingHasFewerMessages) return;
        if (isChatRunPending(runsRef.current, incoming._id) && !isSwitchingConversation && !incomingAddsMessages) return;
        setConversationState((prevState: any) => {
            const prevActiveTask = (prevState as any)?.activeTask;
            const incomingActiveTask = (incoming as any)?.activeTask;
            // Preserve in-progress uploads when refresh/timers overwrite conversation from server
            const withPendingDocs = liveSnapshot
                ? liveSnapshot
                : !isSwitchingConversation
                    ? mergePendingContextDocuments(incoming)
                    : incoming;
            const merged =
                incoming._id === prevState?._id
                    ? { ...withPendingDocs, activeTask: incomingActiveTask ?? prevActiveTask }
                    : withPendingDocs;
            conversationRef.current = merged;
            return merged as any;
        });

        if (!properties.conversation.messages || properties.conversation.messages.length === 0) {
            setShowSuggestions(properties.showSuggestions);
        } else {
            setShowSuggestions(false);
        }

        setTaskActionPopupOpen(false);
    }, [properties.conversation, properties.showSuggestions, mergePendingContextDocuments, clearBotRunState]);

    // Scroll to end when last message is a task activation (dynamically added from worklist)
    // This handles the redraw when ChatBot's updateConversation applies applyActiveTask.
    // Only when the activation is *new*: the 60s silent refresh rebuilds the
    // conversation object with the very same activation message re-appended, so an
    // effect keyed on the messages array alone yanked a reader back to the bottom
    // once a minute. The signature stays stable across those rebuilds.
    const scrolledToActivationRef = useRef<string | null>(null);
    useEffect(() => {
        const messages = conversation?.messages;
        if (!messages?.length) return;
        const last = messages[messages.length - 1] as any;
        if (!last?._taskActivation) {
            scrolledToActivationRef.current = null;
            return;
        }
        const signature = [
            conversation?._id ?? '',
            (conversation as any)?.activeTask?._id ?? '',
            messages.length,
            last.content ?? '',
        ].join('|');
        if (scrolledToActivationRef.current === signature) return;
        scrolledToActivationRef.current = signature;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setTimeout(() => scrollToBottom(), 250);
            });
        });
    }, [conversation]);

    useEffect(() => {
        // Auto-scroll disabled - user controls scrolling
        // scrollToBottom();
    }, [conversation, chatUpdate]);

    // TODO Cleanup!

    // useEffect(() => {
    //     scrollToBottom();
    //     // const socket = io(`${baseUrl}`);

    //     // socket.on("connect", () => {
    //     //     setId(socket.id);

    //     //     socket.on("suggestion", (suggestion) => {
    //     //         setConversation([...conversation, {
    //     //             type: 'botSuggestion',
    //     //             content: suggestion.message,
    //     //             prompt: suggestion.prompt,
    //     //         }]);

    //     //         textField.current.focus();
    //     //     });

    //     //     socket.on("message", (message) => {
    //     //         setConversation([...conversation, {
    //     //             type: 'botMessage',
    //     //             content: message
    //     //         }]);
    //     //     });
    //     // });
    // }, [chatUpdate]);

    useEffect(() => {
        if (!textField.current) {
            return;
        }

        if (!pendingRequest) {
            textField.current.focus();
        } else {
            textField.current.blur();
        }
    }, [pendingRequest]);

    // Which conversation the in-flight upload belongs to. `isUploading` is a
    // single flag (one upload session at a time) and it stays true until the
    // server has finished processing the files, so it is enough to remember the
    // conversation it started in — the user may switch away meanwhile.
    const [uploadingConversationId, setUploadingConversationId] = useState<string | null>(null);
    useEffect(() => {
        if (!isUploading) {
            setUploadingConversationId(null);
            return;
        }
        const id = conversationRef.current?._id;
        setUploadingConversationId(id ? String(id) : null);
    }, [isUploading]);

    // Report the busy conversations so the sidebar can mark them: an LLM run, an
    // upload being processed, or a task confirmation still waiting on its files.
    const onRunningConversationsChange = properties.onRunningConversationsChange;
    useEffect(() => {
        const ids = new Set(runningConversations);
        if (uploadingConversationId) {
            ids.add(uploadingConversationId);
        }
        backgroundConfirms.forEach(operation => {
            if (operation.status !== 'error') {
                ids.add(String(operation.convId));
            }
        });
        onRunningConversationsChange?.(Array.from(ids));
    }, [runningConversations, uploadingConversationId, backgroundConfirms, onRunningConversationsChange]);

    useEffect(() => {
        if (properties.inputFocusTrigger != null && properties.inputFocusTrigger > 0 && textField.current && !pendingRequest) {
            textField.current.focus();
        }
    }, [properties.inputFocusTrigger, pendingRequest]);

    useEffect(() => {
        if (properties.scrollToEndTrigger != null && properties.scrollToEndTrigger > 0) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setTimeout(() => scrollToBottom(), 250);
                });
            });
        }
    }, [properties.scrollToEndTrigger]);

    useEffect(() => {
        const conversationId = conversation?._id ?? null;
        const messageCount = conversation?.messages?.length ?? 0;
        const contextDocumentCount = conversation?.contextDocuments?.length ?? 0;

        if (conversationId !== previousConversationIdRef.current) {
            previousConversationIdRef.current = conversationId;
            previousMessageCountRef.current = messageCount;
            setContextDocumentsCollapsed(shouldCollapseContextDocuments(conversation));
            return;
        }

        if (contextDocumentCount <= 1) {
            if (contextDocumentsCollapsed) {
                setContextDocumentsCollapsed(false);
            }
            previousMessageCountRef.current = messageCount;
            return;
        }

        if (previousMessageCountRef.current === 0 && messageCount > 0) {
            setContextDocumentsCollapsed(true);
        }

        previousMessageCountRef.current = messageCount;
    }, [
        conversation?._id,
        conversation?.messages?.length,
        conversation?.contextDocuments?.length,
        contextDocumentsCollapsed,
    ]);

    // useEffect(() => {
    //     speechController.current.recognizingCallback = (text) => {
    //         setInputValue(text);
    //     }
    //     speechController.current.recognizedCallback = submitInput;
    //     speechController.current.stateChangeCallback = (state) => {
    //         setSpeechControllerState(state);
    //     }
    //     speechController.current.listen();
    // }, [speechController, submitInput]);

    // ---- Client-bot streaming progress ----
    const escapeProgressHtml = useCallback((s: string): string =>
        String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'), []);

    const formatBotEventLine = useCallback((evt: any): string => {
        const safe = (v: any) => escapeProgressHtml(typeof v === 'string' ? v : JSON.stringify(v));
        switch (evt?.type) {
            case 'started':
                return t('chatBotPage.botEventStarted', 'Bot gestartet.');
            case 'thought':
                return safe(evt.text || '');
            case 'tool_call':
                // Re-use the same friendly text the approval card shows.
                return escapeProgressHtml(toolCallToText(evt.tool, evt.input, t));
            case 'tool_result':
                return `${safe(evt.tool || evt.callId || '')} ${evt.ok ? '✓' : '✗'}`;
            case 'approval_requested':
                return `${t('chatBotPage.approvalRequiredTitle', 'Approval requested')}: ${escapeProgressHtml(toolCallToText(evt.tool, evt.input, t))}`;
            case 'completed':
                return safe(evt?.result?.summary || t('chatBotPage.botEventCompleted', 'Bot abgeschlossen.'));
            case 'failed':
                return `${safe(evt?.error?.code || 'error')}: ${safe(evt?.error?.message || '')}`;
            default:
                return safe(evt?.type || 'event');
        }
    }, [escapeProgressHtml, t]);

    /** Append/create the streaming bot message for the active bot run. */
    const appendBotRunMessage = useCallback((html: string) => {
        const prev = conversationRef.current;
        if (!prev) return;

        const next = cloneConversation(prev);
        const messages = [...(next.messages || [])];
        const idx = botRunMessageIndexRef.current;

        if (idx >= 0 && idx < messages.length && messages[idx].type === MessageType.botMessage) {
            const existing = messages[idx];
            messages[idx] = new Message({
                ...existing,
                content: (existing.content || '') + html,
            });
        } else {
            messages.push(new Message({
                type: MessageType.botMessage,
                content: html,
                confirmation: false,
                resources: [],
            }));
            botRunMessageIndexRef.current = messages.length - 1;
        }

        next.messages = messages;
        // Keep bot-run progress updates on the same propagation path used by
        // regular streaming updates so parent conversation state stays in sync.
        applyIncomingConversationRef.current(next);
    }, []);

    useEffect(() => {
        activeBotRunIdRef.current = activeBotRunId;
    }, [activeBotRunId]);

    /** Called by ClientBotInvokeButton when the run is accepted by the bot. */
    const startBotRun = useCallback((runId: string) => {
        // A second invoke while a run is still active would swap listeners and
        // orphan the original run's progress/approvals in the UI.
        if (activeBotRunIdRef.current) return;
        activeBotRunIdRef.current = runId;
        // Reset so this run gets its own message bubble.
        botRunMessageIndexRef.current = -1;
        appendBotRunMessage(`<div class="progress">${escapeProgressHtml(`▶ Bot run ${runId}`)}</div>\n`);
        setActiveBotRunId(runId);
    }, [appendBotRunMessage, escapeProgressHtml]);

    // Subscribe to `bot-event:<runId>` for the active run and stream events
    // into the chat as progress lines. Cleans up on terminal events or unmount.
    useEffect(() => {
        if (!activeBotRunId) return;
        const socket = io(configuration.serverUrl);
        const channel = `bot-event:${activeBotRunId}`;
        let isSettled = false;
        const appendSocketFailure = (prefix: string, detail?: string) => {
            const safeDetail = typeof detail === 'string' && detail.trim().length > 0 ? ` (${detail.trim()})` : '';
            appendBotRunMessage(`<div class="progress">${escapeProgressHtml(`${prefix}${safeDetail}`)}</div>\n`);
        };
        const teardownSocket = () => {
            if (isSettled) return;
            isSettled = true;
            socket.off(channel, handler);
            socket.off('disconnect', handleDisconnect);
            socket.off('connect_error', handleConnectError);
            socket.off('error', handleSocketError);
            socket.disconnect();
        };
        const finalizeRun = () => {
            teardownSocket();
            clearBotRunState();
        };
        const handler = (evt: any) => {
            appendBotRunMessage(`<div class="progress">${escapeProgressHtml(formatBotEventLine(evt))}</div>\n`);
            // Approval lifecycle: open a pending card on `approval_requested`,
            // close it once the call settles (tool_result / failed / completed).
            if (evt?.type === 'approval_requested' && evt.callId && clientBotApprovalPolicy === 'ask') {
                setPendingApprovals((prev) => ({
                    ...prev,
                    [evt.callId]: {
                        runId: evt.runId ?? activeBotRunId!,
                        callId: evt.callId,
                        tool: String(evt.tool ?? 'tool'),
                        input: evt.input,
                        reason: String(evt.reason ?? ''),
                        receivedAt: Date.now(),
                    },
                }));
            } else if (evt?.type === 'tool_result' && evt.callId) {
                setPendingApprovals((prev) => {
                    if (!(evt.callId in prev)) return prev;
                    const next = { ...prev };
                    delete next[evt.callId];
                    return next;
                });
            }
            if (evt?.type === 'completed' || evt?.type === 'failed') {
                finalizeRun();
            }
        };
        const handleDisconnect = (reason: string) => {
            if (isSettled || reason === 'io client disconnect') return;
            appendSocketFailure(t('chatBotPage.botSocketDisconnected', 'Bot connection dropped. Run state reset.'), reason);
            finalizeRun();
        };
        const handleConnectError = (error: any) => {
            if (isSettled) return;
            appendSocketFailure(
                t('chatBotPage.botSocketConnectError', 'Bot connection failed. Run state reset.'),
                error?.message,
            );
            finalizeRun();
        };
        const handleSocketError = (error: any) => {
            if (isSettled) return;
            appendSocketFailure(
                t('chatBotPage.botSocketError', 'Bot socket error. Run state reset.'),
                error?.message,
            );
            finalizeRun();
        };
        socket.on(channel, handler);
        socket.on('disconnect', handleDisconnect);
        socket.on('connect_error', handleConnectError);
        socket.on('error', handleSocketError);
        return () => {
            teardownSocket();
        };
    }, [activeBotRunId, appendBotRunMessage, escapeProgressHtml, formatBotEventLine, clearBotRunState, clientBotApprovalPolicy, t]);

    // Wire Approve/Deny on a pending-approval card. Sends the decision to
    // the browser-bot extension; on success the card is removed locally
    // (the corresponding tool_result event will also clear it on the next
    // socket tick — both paths are idempotent).
    const handleApprovalDecision = useCallback(async (
        approval: PendingApproval,
        decision: 'approve' | 'deny',
    ) => {
        const result = await sendBrowserBotApproval({
            runId: approval.runId,
            callId: approval.callId,
            decision,
        });
        if (result.ok) {
            setPendingApprovals((prev) => {
                if (!(approval.callId in prev)) return prev;
                const next = { ...prev };
                delete next[approval.callId];
                return next;
            });
        } else {
            appendBotRunMessage(
                `<div class="progress">${escapeProgressHtml(`Approval ${decision} failed: ${result.error ?? 'unknown'}`)}</div>\n`,
            );
        }
    }, [appendBotRunMessage, escapeProgressHtml]);
    // ---- end client-bot streaming progress ----

    // Add null check after all hooks to prevent errors when properties is null
    if (!properties || typeof properties !== "object") {
        console.error("[ChatExchange] called with invalid properties:", properties);
        return <div>Loading...</div>;
    }

    // The empty chat is a start screen (28.09.2026, modelled on ChatGPT): headline, the
    // composer centred in the column, the suggestions as plain rows beneath it. The transcript
    // area collapses to nothing; `.chat-empty-state` in chat-oa.css does the centring.
    const emptyChat = !!conversation && (conversation.messages?.length ?? 0) === 0 && !pendingRequest;
    return (
        <>
            {backgroundConfirms.length > 0 && (
                <div className="pointer-events-none fixed bottom-5 right-5 z-[9999] flex flex-col gap-2">
                    {backgroundConfirms.map((op) => (
                        <div
                            key={op.id}
                            role="status"
                            data-testid="chat-background-confirm"
                            className={`pointer-events-auto flex max-w-[340px] items-center gap-2.5 rounded-lg px-3.5 py-2.5 text-[13px] shadow-lg ${op.status === 'error' ? 'bg-destructive text-destructive-foreground' : 'bg-foreground text-background'}`}
                        >
                            {op.status !== 'error' && <Loader2 className="h-4 w-4 shrink-0 animate-spin" />}
                            <div className="min-w-0">
                                <div className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold">
                                    {op.title}
                                </div>
                                <div className="opacity-90">
                                    {op.status === 'uploading' && t('chatExchange.backgroundUploadInProgress')}
                                    {op.status === 'completing' && t('chatExchange.backgroundCompleting')}
                                    {op.status === 'error' && t('chatExchange.backgroundConfirmError')}
                                </div>
                            </div>
                            {op.status === 'error' && (
                                <button
                                    type="button"
                                    onClick={() =>
                                        setBackgroundConfirms((prev) => prev.filter((o) => o.id !== op.id))
                                    }
                                    aria-label={t('chatExchange.backgroundConfirmDismiss')}
                                    className="ml-1 shrink-0 cursor-pointer border-0 bg-transparent p-0 leading-none text-current"
                                >
                                    <X className="h-4 w-4" />
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
            <style>{`
                .chat-conversation-area .overflowYScroll::-webkit-scrollbar,
                .chat-conversation-area *::-webkit-scrollbar {
                    display: none !important;
                }
                [style*="scrollbarWidth"][style*="none"]::-webkit-scrollbar {
                    display: none !important;
                }
            `}</style>
            <div
                // `min-w-0`: Ohne das wächst die Unterhaltung als Flex-Kind mit ihrem breitesten
                // Inhalt (eine Tabelle, ein Codeblock) über ihren Rahmen hinaus, statt zu rollen —
                // sichtbar im Test-Dialog der Einstellungen, wo der Rahmen eng ist.
                className={`${properties.fullWidth ? '' : 'chatColumn'} relative flex min-w-0 flex-col${emptyChat ? ' chat-empty-state' : ''}`}
                style={{
                    height: properties.height || '100%',
                }}
                onDragOver={handleDragOver}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
            {/* Full-screen drag overlay */}
            {isDragOver && (
                <div
                    data-testid="chat-drop-overlay"
                    className="pointer-events-none fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm transition-all"
                >
                    <div
                        className={`flex max-w-[600px] flex-col items-center justify-center text-center text-white ${isDragValid ? 'animate-[pulse_1.5s_infinite]' : 'animate-[shake_0.5s_infinite]'}`}
                    >
                        {isDragValid ? (
                            <CloudUpload
                                size={64}
                                className="mb-5"
                                style={{ color: theme.secondaryLight || theme.secondaryLighter || undefined }}
                            />
                        ) : (
                            <CircleAlert size={64} className="mb-5 text-red-400" />
                        )}
                        <div className={`mb-3 text-[28px] font-semibold [text-shadow:0_2px_4px_rgba(0,0,0,0.5)] ${isDragValid ? 'text-white' : 'text-red-400'}`}>
                            {isDragValid ? t('chatExchange.dropFilesHere') : t('chatExchange.invalidFileType')}
                        </div>
                        <div className={`text-base leading-[1.4] [text-shadow:0_1px_2px_rgba(0,0,0,0.5)] ${isDragValid ? 'text-white/90' : 'text-red-400/90'}`}>{t('chatExchange.supportedFormats')}
                        </div>
                    </div>
                </div>
            )}
            {(() => {
                const contextDocuments = conversation?.contextDocuments || [];
                const contextDocumentCount = contextDocuments.length;
                const conversationHasActiveTask = !!(conversation as any)?.activeTask;
                // Process-mode accent: use the portal's themed primary instead of
                // the previous hard-coded orange, so the active-task UI matches the
                // rest of the portal styling.
                const processAccent = theme.primaryDark || theme.primary || '#0078d4';
                // A send during an upload is only blocked for plain chat; an
                // active task's answer is handed to the background instead.
                const activeTaskCompleteFlow =
                    !!(conversation as any)?.activeTask && taskAction === 'complete';
                const sendBlockedByUpload = isUploading && !activeTaskCompleteFlow;
                const hasMultipleContextDocuments = contextDocumentCount > 1;
                const showCollapsedContextDocuments = hasMultipleContextDocuments && contextDocumentsCollapsed;
                const contextDocumentCountLabel = t('chatExchange.fileCount', {
                    count: contextDocumentCount,
                    fileLabel: t(contextDocumentCount === 1 ? 'Datei' : 'Dateien'),
                });
                // Über dem Feld steht nur noch, was zur Sache gehört: die
                // angehängten Dateien. Die Token-Schätzung ist weg — für
                // Nutzende war sie Jargon (Prod-Test 22.10.2026). Die beiden Wege,
                // Dateien hinzuzufügen (hochladen, aus der Dateiablage wählen),
                // sind Symbole in der Aktionszeile unter dem Feld geworden.
                const showComposerHeader = contextDocumentCount > 0;
                // Ein rundes Symbol der Aktionszeile: ohne Fläche, aus der
                // Opazitätsleiter, mit Fläche erst beim Überfahren.
                const composerIconClass =
                    'size-8 shrink-0 rounded-full text-[var(--oa-fg-3)] hover:bg-[var(--oa-surface)] hover:text-[var(--oa-fg)]';

                return (
                    <>
            <div className='chat-conversation-area'>
                {conversation && conversation.messages.length === 0 && properties.showLogo ? (
                    <div className='logo marginBottomXXXL'>
                        {(() => {
                            // First check if theme has a custom logo
                            if (theme?.logoURL) {
                                return <img className="logoImage max-h-16 w-auto max-w-[70%] object-contain" src={userAPI.getResourceURL(theme.logoURL)} alt="logo" />;
                            }
                            
                            // Fallback to hardcoded customer logos
                            switch (authentication?.customer) {
                                case 'A8Z1-ZQGN-YKN3': // BOSCH
                                    return <img className="botBrandingImage max-h-24 w-auto max-w-[70%] object-contain" src="/logos/bosch/schlaubi.jpeg" alt="logo" />;
                                case 'C2Z2-QQGN-YKW6': // gefma
                                    return <img className="botBrandingImage max-h-24 w-auto max-w-[70%] object-contain" src="/logos/gefma/logo.png" alt="logo" />;
                                case '4714': // Pastor
                                    return <img className="botBrandingImage max-h-24 w-auto max-w-[70%] object-contain" src="/logos/pastor/schlaubi.jpeg" alt="logo" />;
                                default:
                                    return <img className="logoImage max-h-16 w-auto max-w-[70%] object-contain" src="/logo.png" alt="logo" />;
                            }
                        })()}
                    </div>
                ) : (
                    <div ref={conversationAreaRef} className='overflowYScroll relative h-full max-h-full bg-transparent' style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' } as React.CSSProperties}>
                        {/* The transcript stops following once the reader scrolls
                            up; this is the one click back to the newest message. */}
                        <ScrollToBottomButton
                            scroller={() => {
                                // Whichever of the two actually scrolls. Both are
                                // candidates depending on conversation length and
                                // layout, and picking a fixed order gets it wrong
                                // half the time — so ask the DOM instead.
                                const root = conversationAreaRef.current;
                                const candidates = [
                                    root?.querySelector('.messages'),
                                    root?.querySelector('.messagesContainer'),
                                    root,
                                ] as (HTMLElement | null | undefined)[];
                                return candidates.find(
                                    (element) => element && element.scrollHeight - element.clientHeight > 8,
                                ) ?? null;
                            }}
                            watch={conversation?.messages?.length}
                            bottom={24}
                        />
                        <ConversationDocumentsContext.Provider value={citableDocuments}>
                            <ChatConversation
                                conversation={conversation}
                                pendingRequest={pendingRequest}
                                submitInput={submitInput}
                                onFeedback={handleFeedback}
                                feedbackByIndex={feedbackByIndex}
                                resourceSelected={properties.resourceSelected}
                                hideMessageActions={properties.hideMessageActions}
                            />
                        </ConversationDocumentsContext.Provider>
                    </div>
                )}
            </div>
            <div className={`chat-bottom-section ${properties.fullWidth ? 'no-padding' : ''}`}>
                {emptyChat && (
                    <h2 className='chat-empty-headline order-first' data-testid='chat-empty-headline'>
                        {t('chatBotPage.emptyHeadline')}
                    </h2>
                )}
                {/* Die Vorschläge bleiben eingehängt, sobald die Seite sie
                    anbietet — geschlossen stehen sie auf Höhe null. Würden sie
                    beim Öffnen neu gebaut, holte die Komponente die Skills
                    erneut und würfelte drei andere aus: erst Platzhalter, dann
                    fremder Text. So steht beim Aufschieben sofort dasselbe da
                    wie beim letzten Mal.

                    Die Höhe läuft von 0 auf den gemessenen Wert und zurück; im
                    geschlossenen Zustand ist der Block für Tastatur und
                    Vorleseprogramme nicht vorhanden. */}
                {properties.showSuggestions && (
                    <motion.div
                        initial={false}
                        animate={
                            reduceMotion
                                ? { opacity: suggestionsOpen ? 1 : 0 }
                                : {
                                    height: suggestionsOpen ? 'auto' : 0,
                                    opacity: suggestionsOpen ? 1 : 0,
                                }
                        }
                        // Kurze, ruhige Kurve statt Feder: Jeder Frame dieser
                        // Höhe rechnet die Chatspalte neu — der Verlauf darüber
                        // bekommt eine neue Höhe, der `MessageScroller` misst
                        // und hält die Leseposition nach. Weniger Frames und
                        // kein Nachschwingen heißt hier weniger Arbeit.
                        transition={
                            reduceMotion
                                ? { duration: 0 }
                                : {
                                    height: { duration: 0.28, ease: EASE_OUT },
                                    opacity: { duration: 0.18, ease: EASE_OUT },
                                }
                        }
                        // Layout und Malen bleiben im Block, statt die Seite
                        // darunter mitzuziehen.
                        style={{ contain: 'layout paint', willChange: 'height' }}
                        // On the start screen the suggestions move under the composer.
                        className={`overflow-hidden${emptyChat ? ' order-2 mt-3' : ''}`}
                        aria-hidden={!suggestionsOpen}
                        {...(suggestionsOpen ? {} : { inert: '' as unknown as boolean })}
                    >
                        <Suggestions
                            key={authentication?.customer ?? 'anon'}
                            onSuggestionClick={submitSuggestion}
                            onClose={() => setShowSuggestions(false)}
                            variant={emptyChat ? 'list' : 'cards'}
                            showControls={!emptyChat}
                            // The three suggestions rotate every 12 s, each slot swapping in
                            // place with a soft lift/drop (28.09.2026); the button still reshuffles.
                            refreshIntervalSeconds={12}
                        />
                    </motion.div>
                )}
                            {properties.sampleRequests && properties.sampleRequests.length > 0 && !(inputValue && inputValue.trim().length > 0) && (
                <div className="sample-requests">
                    <div className='my-5'>
                        <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            data-testid="chat-sample-requests-toggle"
                            className="mr-[15px] gap-2"
                            aria-expanded={showSampleRequests}
                            onClick={() => setShowSampleRequests(!showSampleRequests)}
                        >
                            {showSampleRequests
                                ? <ChevronUp className="h-4 w-4" />
                                : <ChevronDown className="h-4 w-4" />}
                            <div className='colorPrimary'>{t('ui.sampleRequests')}</div>
                        </Button>
                    </div>
                    {showSampleRequests && (
                        <div className="sample-requests-list">
                            {properties.sampleRequests.map((sampleRequest: string, index: number) => (
                                <div
                                    key={index}
                                    className="sample-request"
                                    onClick={() => submitInput(sampleRequest)}
                                >
                                    {sampleRequest}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
                <div className={`inputContainer relative${emptyChat ? ' order-1' : ''}`}>
                {contextFileError && (
                    <Alert
                        variant="destructive"
                        data-testid="chat-context-file-error"
                        className="mb-2 flex items-start gap-3 pr-10"
                    >
                        <XCircle className="h-4 w-4" />
                        <AlertDescription className="flex-1">{contextFileError}</AlertDescription>
                        <button
                            type="button"
                            onClick={() => setContextFileError(null)}
                            aria-label={t('global.close')}
                            className="absolute right-2 top-2 rounded-sm p-1 text-muted-foreground hover:text-foreground"
                        >
                            <X className="h-4 w-4" />
                        </button>
                    </Alert>
                )}
                <div>
                    <input
                        ref={fileInputRef}
                        type="file"
                        multiple
                        accept={contextUploadAccept}
                        style={{ display: 'none' }}
                        onChange={(e) => {
                            const files = e.target.files;
                            if (files && files.length > 0) {
                                void handleContextFilesSelected(Array.from(files));
                            }
                            e.target.value = '';
                        }}
                    />
                    <StorageFilePickerDialog
                        hidden={!storagePickerOpen}
                        onDismiss={() => setStoragePickerOpen(false)}
                        onConfirm={picked => void handleStoragePickConfirm(picked)}
                    />
                    {/* Kopfzeile über dem Feld: links die angehängten Dateien,
                        rechts die Token-Schätzung. Sie erscheint nur, wenn sie
                        etwas zu sagen hat. */}
                    {showComposerHeader && (
                    <div className="mb-1.5 flex min-h-[20px] items-start justify-between">
                        {/* Left side: context documents list */}
                        <div
                            className={`flex min-w-0 flex-1 flex-col ${showCollapsedContextDocuments ? 'gap-0' : 'gap-1.5'}`}
                        >
                            {contextDocumentCount === 0 ? null : (
                                <>
                                <div className="flex min-w-0 flex-wrap items-center gap-3">
                                    {hasMultipleContextDocuments && (
                                        <button
                                            type="button"
                                            data-testid="chat-context-documents-toggle"
                                            onClick={() => setContextDocumentsCollapsed(prev => !prev)}
                                            aria-expanded={!showCollapsedContextDocuments}
                                            aria-label={showCollapsedContextDocuments ? t('chatExchange.showFiles') : t('chatExchange.hideFiles')}
                                            className={`inline-flex min-w-0 cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-xs ${conversationHasActiveTask ? '' : 'text-muted-foreground'}`}
                                            style={conversationHasActiveTask ? { color: processAccent } : undefined}
                                        >
                                            {showCollapsedContextDocuments
                                                ? <ChevronRight className="h-3 w-3 shrink-0" />
                                                : <ChevronDown className="h-3 w-3 shrink-0" />}
                                            <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                                                {contextDocumentCountLabel}
                                            </span>
                                        </button>
                                    )}
                                </div>
                                {!showCollapsedContextDocuments && (
                                    <div
                                        className={`flex min-w-0 flex-wrap gap-2 ${hasMultipleContextDocuments ? 'overflowYScroll max-h-[72px] overflow-y-auto pr-1' : 'overflow-y-visible pr-0'}`}
                                    >
                                {contextDocuments.map((doc: any, idx: number) => {
                                    const uploadState = uploadProgress.find(progress => progress.filename === doc.filename);
                                    const hasPendingUpload = Boolean(
                                        uploadState
                                            ? uploadState.status === 'uploading' || uploadState.status === 'processing'
                                            : doc.isUploading && (doc.status === 'uploading' || doc.status === 'processing' || !doc.status)
                                    );
                                    const hasError = doc.status === 'error' || uploadState?.status === 'error';
                                    const hasDocumentData = !!((doc as any).markdown || (doc as any).content || (doc as any).fileId || (doc as any).webUrl);
                                    const canOpenDocumentMenu = !hasPendingUpload && !hasError && hasDocumentData;
                                    
                                    // Only show tooltip for completed uploads. Use a plain
                                    // string for the native browser tooltip (matches the
                                    // conversation list and is auto-wrapped by the browser).
                                    const tooltipTitle = !hasPendingUpload && !hasError
                                        ? `${doc.filename}${(doc as any).summary ? `\n\n${(doc as any).summary}` : ''}`
                                        : undefined;

                                    // Fehlerfarbe kommt als `destructive`-Token über Klassen; hier steht
                                    // nur der (dynamische) Kundenakzent.
                                    const accentColor = conversationHasActiveTask ? processAccent : (theme.primaryDark || theme.primary || '#0078d4');
                                    const chipBackground = hasError
                                        ? undefined
                                        : (conversationHasActiveTask ? tinycolor(processAccent).setAlpha(0.15).toRgbString() : tinycolor(theme.secondaryLighter).setAlpha(0.15).toRgbString());

                                    // Der Chip enthält selbst einen Button (Entfernen) und darf
                                    // deshalb kein <button> sein — role/tabIndex/Enter geben dem
                                    // Menü-Öffnen trotzdem Tastaturzugang.
                                    const openDocumentMenuFromChip = canOpenDocumentMenu ? (e: any) => {
                                        e.stopPropagation();
                                        documentMenuTargetRef.current = e.currentTarget as HTMLDivElement;
                                        setDocumentMenuDoc(doc);
                                    } : undefined;
                                    const chipContent = (
                                        <div
                                            className={`flex min-w-0 max-w-[220px] items-center rounded-md px-2 py-[3px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${conversationHasActiveTask && !hasError ? 'processModeFileChip ' : ''}${hasError ? 'border border-destructive/30 bg-destructive/10 ' : 'border-0 '}${canOpenDocumentMenu ? 'cursor-pointer' : 'cursor-default'}`}
                                            data-testid="chat-context-document"
                                            title={tooltipTitle}
                                            style={chipBackground ? { background: chipBackground } : undefined}
                                            role={canOpenDocumentMenu ? 'button' : undefined}
                                            tabIndex={canOpenDocumentMenu ? 0 : undefined}
                                            aria-haspopup={canOpenDocumentMenu ? 'menu' : undefined}
                                            onClick={openDocumentMenuFromChip}
                                            onKeyDown={canOpenDocumentMenu ? (e: any) => {
                                                if (e.key === 'Enter' || e.key === ' ') {
                                                    e.preventDefault();
                                                    openDocumentMenuFromChip?.(e);
                                                }
                                            } : undefined}
                                        >
                                            <FileText
                                                className={`mr-1.5 h-3.5 w-3.5 shrink-0${hasError ? ' text-destructive' : ''}`}
                                                style={hasError ? undefined : { color: accentColor }}
                                            />
                                            <span
                                                className={`min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-xs${hasError ? ' text-destructive' : ''}`}
                                                style={!hasError && conversationHasActiveTask ? { color: processAccent } : undefined}
                                            >
                                                {doc.filename}
                                            </span>
                                            {hasPendingUpload && !hasError ? (
                                                <span
                                                    role="status"
                                                    aria-label={uploadState?.progressDetail || t('global.loading')}
                                                    title={uploadState?.progressDetail || undefined}
                                                    className="ml-1.5 inline-flex shrink-0 items-center"
                                                >
                                                    <Loader2 className="h-3 w-3 animate-spin text-primary" />
                                                </span>
                                            ) : hasError ? (
                                                // Show error icon and allow removal for error files
                                                <button
                                                    type="button"
                                                    className="ml-1.5 shrink-0 cursor-pointer border-0 bg-transparent p-0 text-destructive"
                                                    aria-label={doc.error ? `${t('chatExchange.uploadFailed')}: ${doc.error}` : t('chatExchange.uploadFailed')}
                                                    title={doc.error ? `${t('chatExchange.uploadFailed')}: ${doc.error}` : t('chatExchange.uploadFailed')}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        // Remove failed upload from context documents
                                                        setConversation((prevConversation: any) => {
                                                            if (!prevConversation) return prevConversation;
                                                            const filteredDocs = (prevConversation.contextDocuments || [])
                                                                .filter((d: any) => d._id !== doc._id);
                                                            const clonedConversation = cloneConversation(prevConversation);
                                                            clonedConversation.contextDocuments = filteredDocs;
                                                            return clonedConversation;
                                                        });
                                                    }}
                                                >
                                                    <CircleAlert className="h-3.5 w-3.5" />
                                                </button>
                                            ) : (
                                                // Show delete button for completed uploads
                                                <button
                                                    type="button"
                                                    className="ml-1.5 shrink-0 cursor-pointer border-0 bg-transparent p-0"
                                                    style={{ color: accentColor }}
                                                    data-testid="chat-context-document-remove"
                                                    aria-label={t('global.remove')}
                                                    title={t('global.remove')}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveDocument((doc as any)._id);
                                                    }}
                                                >
                                                    <Trash2 className="h-3.5 w-3.5" />
                                                </button>
                                            )}
                                        </div>
                                    );

                                    return (
                                        <div key={idx}>
                                            {chipContent}
                                        </div>
                                    );
                                })}
                                    </div>
                                )}
                                </>
                            )}
                        </div>
                        <Popover
                            open={!!documentMenuDoc}
                            onOpenChange={(open) => { if (!open) setDocumentMenuDoc(null); }}
                        >
                            {/* Der Anker ist der angeklickte Chip; er wird beim Klick in
                                documentMenuTargetRef gemerkt (virtueller Anker statt Trigger,
                                damit die Öffnen-Logik unverändert bleibt). */}
                            <PopoverAnchor virtualRef={documentMenuTargetRef as any} />
                            {documentMenuDoc && documentMenuTargetRef.current && (
                                <PopoverContent
                                    align="start"
                                    side="bottom"
                                    sideOffset={4}
                                    data-testid="chat-document-menu"
                                    className="w-auto min-w-[160px] p-0 py-1"
                                >
                                    {(documentMenuDoc as any)?.webUrl && (
                                        <button
                                            type="button"
                                            className="block w-full cursor-pointer border-0 bg-transparent px-3 py-2 text-left text-[13px] hover:bg-accent hover:text-accent-foreground"
                                            onClick={() => handleDocumentOpenInSharePoint(documentMenuDoc)}
                                        >
                                            {t('chatExchange.documentOpen')}
                                        </button>
                                    )}
                                    {!!(
                                        (documentMenuDoc as any)?.fileId ||
                                        (documentMenuDoc as any)?.markdown ||
                                        (documentMenuDoc as any)?.content
                                    ) && (
                                        <>
                                            <button
                                                type="button"
                                                className="block w-full cursor-pointer border-0 bg-transparent px-3 py-2 text-left text-[13px] hover:bg-accent hover:text-accent-foreground"
                                                onClick={() => handleDocumentDownload(documentMenuDoc)}
                                            >
                                                {t('chatExchange.documentDownload')}
                                            </button>
                                            <button
                                                type="button"
                                                className="block w-full cursor-pointer border-0 bg-transparent px-3 py-2 text-left text-[13px] hover:bg-accent hover:text-accent-foreground"
                                                onClick={() => handleDocumentMarkdownOpen(documentMenuDoc)}
                                            >
                                                {t('chatExchange.documentMarkdownOpen')}
                                            </button>
                                            <button
                                                type="button"
                                                className="block w-full cursor-pointer border-0 bg-transparent px-3 py-2 text-left text-[13px] hover:bg-accent hover:text-accent-foreground"
                                                onClick={() => handleDocumentMarkdownShow(documentMenuDoc)}
                                            >
                                                {t('chatExchange.documentMarkdownShow')}
                                            </button>
                                        </>
                                    )}
                                </PopoverContent>
                            )}
                        </Popover>

                    </div>
                    )}
                </div>
                {/* Der Kasten der Eingabe im Zuschnitt von beuis `PromptInput`:
                    weicher Radius, haarfeiner Rand aus der Opazitätsleiter, der
                    beim Tippen nachdunkelt. Im Prozessmodus trägt er weiter die
                    Kundenfarbe. */}
                <div
                    className={`relative mt-1.5 rounded-2xl bg-[var(--oa-panel)] p-2 ${composerWidthClass(pendingRequest)}${(conversation as any)?.activeTask ? '' : ' border border-[var(--oa-border)] focus-within:border-[var(--oa-fg-5)]'}`}
                    data-composer-pending={pendingRequest ? 'true' : 'false'}
                    style={(conversation as any)?.activeTask ? { border: `1px solid ${processAccent}` } : undefined}
                >
                    {(conversation as any)?.activeTask && (
                        <Popover
                            open={taskActionPopupOpen}
                            onOpenChange={(open) => { if (!open) setTaskActionPopupOpen(false); }}
                        >
                        <div className="absolute bottom-0 right-10 flex translate-y-1/2 items-center gap-2">
                            {!isSliderTask && !isTextInputTask && !isChecklistTask && !isConfirmationTask && !isSelectTask && !isFormTask && (
                            <Popover
                                open={worklistPopupOpen}
                                onOpenChange={(open) => { if (!open) setWorklistPopupOpen(false); }}
                            >
                                <PopoverAnchor asChild>
                                    <button
                                        ref={worklistButtonRef}
                                        type="button"
                                        data-testid="chat-worklist-task"
                                        onClick={() => (conversation as any).worklist?.length > 1 && properties.onWorklistTaskSelect && setWorklistPopupOpen(true)}
                                        className={`box-border flex h-6 items-center gap-1 rounded-sm border bg-background px-2 font-[inherit] text-xs leading-6 ${(conversation as any).worklist?.length > 1 && properties.onWorklistTaskSelect ? 'cursor-pointer' : 'cursor-default'}`}
                                        style={{ border: `1px solid ${processAccent}`, color: processAccent }}
                                    >
                                        {(conversation as any).activeTask?.name ?? (conversation as any).activeTask?.label ?? (conversation as any).activeTask?.taskName ?? (conversation as any).activeTask?.taskDefinitionName ?? t('chatBotPage.worklistTasks')}
                                        {(conversation as any).worklist?.length > 1 && <ChevronDown className="h-3 w-3" />}
                                    </button>
                                </PopoverAnchor>
                                {worklistPopupOpen && worklistButtonRef.current && properties.onWorklistTaskSelect && (
                                    <PopoverContent
                                        side="top"
                                        align="center"
                                        sideOffset={4}
                                        data-testid="chat-worklist-menu"
                                        className="w-auto min-w-[240px] p-2"
                                    >
                                        {(conversation as any).worklist?.map((task: any) => {
                                            const name = task?.name ?? task?.label ?? task?.taskName ?? task?.taskDefinitionName ?? task?._id ?? '';
                                            const synopsis = typeof task?.instanceSynopsis === 'string' && task.instanceSynopsis.length > 0
                                                ? task.instanceSynopsis as string
                                                : undefined;
                                            const isActive = (conversation as any)?.activeTask?._id === task?._id;
                                            return (
                                                <button
                                                    key={task._id}
                                                    type="button"
                                                    data-testid="chat-worklist-menu-item"
                                                    className="block w-full cursor-pointer rounded-sm border-0 bg-transparent px-3 py-2 text-left hover:bg-accent hover:text-accent-foreground"
                                                    style={isActive ? { color: processAccent } : undefined}
                                                    onClick={() => {
                                                        void flushChecklistPatch();
                                                        properties.onWorklistTaskSelect?.(task);
                                                        setWorklistPopupOpen(false);
                                                    }}
                                                >
                                                    {synopsis && (
                                                        <div
                                                            title={synopsis}
                                                            className="overflow-hidden text-ellipsis whitespace-nowrap font-semibold"
                                                        >
                                                            {synopsis}
                                                        </div>
                                                    )}
                                                    <div
                                                        title={name}
                                                        className={`overflow-hidden text-ellipsis whitespace-nowrap ${synopsis ? 'text-[0.85em] text-muted-foreground' : ''}`}
                                                    >
                                                        {name}
                                                    </div>
                                                </button>
                                            );
                                        })}
                                    </PopoverContent>
                                )}
                            </Popover>
                            )}
                            {!isSliderTask && !isTextInputTask && !isChecklistTask && !isConfirmationTask && !isSelectTask && !isFormTask && (
                            <PopoverAnchor asChild>
                                <button
                                    ref={taskActionButtonRef}
                                    type="button"
                                    data-testid="chat-task-action"
                                    onClick={() => setTaskActionPopupOpen(true)}
                                    className="box-border flex h-6 cursor-pointer items-center gap-1 rounded-sm border bg-background px-2 font-[inherit] text-xs leading-6"
                                    style={{ border: `1px solid ${processAccent}`, color: processAccent }}
                                >
                                    {taskAction === 'complete' && t('chatBotPage.completeTask')}
                                    {taskAction === 'defer' && t('chatBotPage.deferTask')}
                                    {taskAction === 'requestInfo' && t('chatBotPage.requestTaskInfo')}
                                    <ChevronDown className="h-3 w-3" />
                                </button>
                            </PopoverAnchor>
                            )}
                        </div>
                        {taskActionPopupOpen && taskActionButtonRef.current && (
                            <PopoverContent
                                side="top"
                                align="center"
                                sideOffset={4}
                                data-testid="chat-task-action-menu"
                                className="w-auto min-w-[180px] p-2"
                            >
                                <button
                                    type="button"
                                    className="block w-full cursor-pointer rounded-sm border-0 bg-transparent px-3 py-2 text-left hover:bg-accent hover:text-accent-foreground"
                                    style={taskAction === 'complete' ? { color: processAccent } : undefined}
                                    onClick={() => { setTaskAction('complete'); setTaskActionPopupOpen(false); }}
                                >
                                    {t('chatBotPage.completeTask')}
                                </button>
                                {!checklistReady && (
                                    <button
                                        type="button"
                                        className="block w-full cursor-pointer rounded-sm border-0 bg-transparent px-3 py-2 text-left hover:bg-accent hover:text-accent-foreground"
                                        style={taskAction === 'defer' ? { color: processAccent } : undefined}
                                        onClick={() => { setTaskAction('defer'); setTaskActionPopupOpen(false); }}
                                    >
                                        {t('chatBotPage.deferTask')}
                                    </button>
                                )}
                                {!checklistReady && (
                                    <button
                                        type="button"
                                        className="block w-full cursor-pointer rounded-sm border-0 bg-transparent px-3 py-2 text-left hover:bg-accent hover:text-accent-foreground"
                                        style={taskAction === 'requestInfo' ? { color: processAccent } : undefined}
                                        onClick={() => { setTaskAction('requestInfo'); setTaskActionPopupOpen(false); }}
                                    >
                                        {t('chatBotPage.requestTaskInfo')}
                                    </button>
                                )}
                            </PopoverContent>
                        )}
                        </Popover>
                    )}
                    {!showSuggestions && properties.showSuggestions && !(inputValue && inputValue.trim().length > 0) && !(conversation as any)?.activeTask && (
                        <button
                            type="button"
                            data-testid="chat-more-ideas"
                            onClick={() => setShowSuggestions(true)}
                            // Mobil kollidiert die absolute Position mit dem
                            // Platzhalter — dort rückt der Hinweis als eigene
                            // Zeile über das Eingabefeld.
                            className="absolute right-3 top-2 z-[1] cursor-pointer border-0 bg-transparent p-0 text-[12px] text-[var(--oa-fg-4)] transition-colors hover:text-[var(--oa-fg-2)] max-sm:static max-sm:mb-1 max-sm:block max-sm:w-full max-sm:text-right"
                        >
                            {t('chatBotPage.needMoreIdeas')}
                        </button>
                    )}
                    {Object.values(pendingApprovals).length > 0 && (
                        <div
                            data-testid="chat-bot-approvals"
                            className="mb-2 flex flex-col gap-2 rounded-md border border-warning/50 bg-warning/10 p-2.5"
                        >
                            <div className="text-xs font-semibold text-warning">
                                {t('chatBotPage.approvalRequiredTitle', 'Bot approval requested')}
                            </div>
                            {Object.values(pendingApprovals)
                                .sort((a, b) => a.receivedAt - b.receivedAt)
                                .map((approval) => (
                                <div
                                    key={approval.callId}
                                    className="flex flex-col gap-1.5 rounded-sm border border-warning/40 bg-background p-2"
                                >
                                    <div className="text-sm leading-[1.4]">
                                        {renderApprovalSummary(approval.tool, approval.input, t)}
                                    </div>
                                    <div className="flex justify-end gap-1.5">
                                        <Button
                                            type="button"
                                            variant="outline"
                                            size="sm"
                                            className="gap-2"
                                            data-testid="chat-bot-approval-deny"
                                            onClick={() => handleApprovalDecision(approval, 'deny')}
                                        >
                                            {t('chatBotPage.deny', 'Deny')}
                                        </Button>
                                        <Button
                                            type="button"
                                            size="sm"
                                            className="gap-2"
                                            data-testid="chat-bot-approval-approve"
                                            onClick={() => handleApprovalDecision(approval, 'approve')}
                                        >
                                            {t('chatBotPage.approve', 'Approve')}
                                        </Button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    {(isSliderTask || isTextInputTask || isConfirmationTask || isSelectTask || isFormTask) ? (
                        <div className='flex flex-col gap-2.5 py-0.5'>
                            {(() => {
                                const sliderTask = (conversation as any).activeTask;
                                const sliderName = sliderTask?.name
                                    ?? sliderTask?.label
                                    ?? sliderTask?.taskName
                                    ?? sliderTask?.taskDefinitionName
                                    ?? '';
                                const sliderPrompt = sliderTask?.userPrompt
                                    ?? sliderTask?.triAttrs?.userPrompt
                                    ?? sliderName
                                    ?? '';
                                return (
                                    <>
                                        {sliderName && (
                                            <div className='text-left text-xs text-muted-foreground'>
                                                {sliderName}
                                            </div>
                                        )}
                                        {sliderPrompt && (
                                            // Beim Formular klein: Die Frage steht als Bot-Nachricht direkt
                                            // darüber, und jede Zeile hier fehlt dem Chat.
                                            <div className={isFormTask
                                                ? 'text-left text-xs text-muted-foreground'
                                                : 'text-center text-[15px] font-semibold text-foreground'}>
                                                {sliderPrompt}
                                            </div>
                                        )}
                                    </>
                                );
                            })()}
                            <div className='flex items-center justify-between gap-2'>
                                {/* Not offered on a select task: the server accepts only an
                                    option from the list there, and would refuse this text. */}
                                {!isSelectTask && !isFormTask && (
                                <TooltipHost content={t('chatBotPage.deferTask')}>
                                    <Button
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-task-defer"
                                        aria-label={t('chatBotPage.deferTask')}
                                        disabled={pendingRequest || isUploading}
                                        onClick={() => submitInput('Zurücklegen')}
                                    >
                                        <Undo2 className="h-4 w-4" />
                                    </Button>
                                </TooltipHost>
                                )}
                                {isFormTask ? (
                                    <TaskFormAnswer
                                        key={String(activeTaskId ?? '')}
                                        loadForm={loadActiveTaskForm}
                                        disabled={pendingRequest || isUploading}
                                        onSubmit={(values) => submitInput(
                                            t('chatBotPage.formSubmitted', { defaultValue: 'Formular ausgefüllt' }),
                                            undefined,
                                            { form: { values } },
                                        )}
                                    />
                                ) : isSelectTask ? (
                                    <TaskSelectAnswer
                                        key={String(activeTaskId ?? '')}
                                        loadOptions={loadActiveTaskSelectOptions}
                                        // Uploads settle first: a selection is not handed to
                                        // the background like a typed answer.
                                        disabled={pendingRequest || isUploading}
                                        onSubmit={(option) => submitInput(option.label, undefined, { selection: { value: option.value } })}
                                    />
                                ) : isSliderTask ? (
                                    <div className='flex gap-5'>
                                        <Button
                                            type="button"
                                            variant="outline"
                                            size="sm"
                                            className="gap-2"
                                            data-testid="chat-task-no"
                                            aria-label={t('chatBotPage.sliderNo', { defaultValue: 'Nein' })}
                                            // Uploads no longer block the answer — an
                                            // in-flight upload is handed to the background.
                                            disabled={pendingRequest}
                                            onClick={() => submitTaskInput('Nein')}
                                        >
                                            <X className="h-4 w-4" />
                                        </Button>
                                        <Button
                                            type="button"
                                            size="sm"
                                            className="gap-2"
                                            data-testid="chat-task-yes"
                                            aria-label={t('chatBotPage.sliderYes', { defaultValue: 'Ja' })}
                                            disabled={pendingRequest}
                                            onClick={() => submitTaskInput('Ja')}
                                        >
                                            <Check className="h-4 w-4" />
                                        </Button>
                                    </div>
                                ) : isConfirmationTask ? (
                                    <Button
                                        type="button"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-task-confirm"
                                        aria-label={t('chatBotPage.confirmTask', { defaultValue: 'Bestätigen' })}
                                        // No longer gated on isUploading: confirming with
                                        // uploads still running hands them off to the
                                        // background so the user is freed at once.
                                        disabled={pendingRequest}
                                        onClick={() => submitTaskInput('Bestätigt')}
                                    >
                                        <Check className="h-4 w-4" />
                                        {t('chatBotPage.confirmTask', { defaultValue: 'Bestätigen' })}
                                    </Button>
                                ) : (
                                    <>
                                        <input
                                            ref={textField}
                                            type="text"
                                            data-testid="chat-task-input"
                                            className="h-8 flex-1 rounded-sm border border-input px-2 font-[inherit] text-[length:inherit] outline-none focus-visible:ring-2 focus-visible:ring-ring"
                                            placeholder={t('chatBotPage.enterAnswer', { defaultValue: 'Antwort eingeben' })}
                                            value={inputValue}
                                            // Stay editable during an upload so the answer
                                            // can be typed and sent to the background.
                                            disabled={pendingRequest}
                                            onFocus={() => setInputFocussed(true)}
                                            onBlur={() => setInputFocussed(false)}
                                            onChange={(event) => setInputValue(event.target.value)}
                                            onKeyDown={onKeyDown}
                                        />
                                        <Button
                                            type="button"
                                            size="sm"
                                            className="gap-2"
                                            data-testid="chat-task-send"
                                            aria-label={t('chatBotPage.completeTask')}
                                            disabled={pendingRequest || !(inputValue && inputValue.trim().length > 0)}
                                            onClick={() => submitTaskInput(inputValue)}
                                        >
                                            <Send className="h-4 w-4" />
                                        </Button>
                                    </>
                                )}
                                <TooltipHost content={t('chatBotPage.showProcessHistory')}>
                                    <Button
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-process-history"
                                        aria-label={t('chatBotPage.showProcessHistory')}
                                        disabled={pendingRequest || !processInstanceId}
                                        onClick={() => setProcessHistoryOpen(true)}
                                    >
                                        <History className="h-4 w-4" />
                                    </Button>
                                </TooltipHost>
                            </div>
                        </div>
                    ) : isBotInvokeTask ? (
                        <ClientBotInvokeButton
                            activeTask={(conversation as any).activeTask}
                            authentication={authentication}
                            conversationId={conversation?._id}
                            customer={authentication?.customer}
                            hasActiveRun={Boolean(activeBotRunId)}
                            onRunStarted={startBotRun}
                            onRunError={(err) => {
                                appendBotRunMessage(`<div class="progress">${escapeProgressHtml(t('chatBotPage.botCallFailed', { error: err }))}</div>\n`);
                            }}
                        />
                    ) : checklistReady ? (
                        <div className='flex flex-col gap-2 px-2'>
                            {(() => {
                                const checklistTask = (conversation as any).activeTask;
                                const checklistName = checklistTask?.name
                                    ?? checklistTask?.label
                                    ?? checklistTask?.taskName
                                    ?? checklistTask?.taskDefinitionName
                                    ?? '';
                                return checklistName ? (
                                    <div className='text-left text-xs text-muted-foreground'>
                                        {checklistName}
                                    </div>
                                ) : null;
                            })()}
                            <ChecklistRunner
                                instance={checklistInstance}
                                onChange={handleChecklistChange}
                            />
                            <div className='mt-0.5 flex items-center justify-between gap-2'>
                                <TooltipHost content={t('chatBotPage.deferTask')}>
                                    <Button
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-checklist-defer"
                                        aria-label={t('chatBotPage.deferTask')}
                                        disabled={pendingRequest || isUploading}
                                        onClick={() => submitInput('Zurücklegen')}
                                    >
                                        <Undo2 className="h-4 w-4" />
                                    </Button>
                                </TooltipHost>
                                <TooltipHost
                                    content={
                                        checklistComplete
                                            ? t('chatBotPage.completeTask')
                                            : t('checklist.notCompleteHint', {
                                                defaultValue: 'Fill all required (*) fields to enable completion.',
                                            })
                                    }
                                >
                                    <Button
                                        type="button"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-checklist-complete"
                                        aria-label={t('chatBotPage.completeTask')}
                                        disabled={pendingRequest || isUploading || !checklistComplete}
                                        onClick={() => submitInput('')}
                                    >
                                        <Send className="h-4 w-4" />
                                    </Button>
                                </TooltipHost>
                                <TooltipHost content={t('chatBotPage.showProcessHistory')}>
                                    <Button
                                        type="button"
                                        variant="outline"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-process-history"
                                        aria-label={t('chatBotPage.showProcessHistory')}
                                        disabled={pendingRequest || !processInstanceId}
                                        onClick={() => setProcessHistoryOpen(true)}
                                    >
                                        <History className="h-4 w-4" />
                                    </Button>
                                </TooltipHost>
                            </div>
                        </div>
                    ) : isChecklistTask && !checklistLoadFailed ? (
                        <div className='flex grow items-center gap-5'>
                            <>
                                <Loader2 className="h-4 w-4 shrink-0 animate-spin text-primary" />
                                <span className='text-muted-foreground'>
                                    {t('checklist.loading', { defaultValue: 'Loading checklist…' })}
                                </span>
                            </>
                        </div>
                    ) : (
                        <>
                            {isChecklistTask && checklistLoadFailed && (
                                <div className='mb-1.5 flex items-center gap-5'>
                                    <span className='text-muted-foreground'>
                                        {t('checklist.loadFailed', {
                                            defaultValue: 'Checklist is unavailable right now.',
                                        })}
                                    </span>
                                    <Button
                                        type="button"
                                        size="sm"
                                        className="gap-2"
                                        data-testid="chat-checklist-retry"
                                        onClick={retryChecklistLoad}
                                    >
                                        {t('checklist.retryLoad', { defaultValue: 'Retry' })}
                                    </Button>
                                </div>
                            )}
                            {properties.readOnly ? (
                                // Say why there is no input, instead of showing a dead field.
                                <div className="w-full py-1 text-sm text-muted-foreground">
                                    {properties.readOnlyHint ??
                                        t('chatBotPage.readOnly', {
                                            defaultValue:
                                                'Nur Ansicht — Sie haben in dieser Konversation keine offene Aufgabe.',
                                        })}
                                </div>
                            ) : (
                            // Mitwachsendes Feld (zwei bis acht Zeilen); Enter,
                            // Umschalt+Enter und ⭡/⭣ bleiben bei `onKeyDown`.
                            <>
                            <ToolMentionMenu
                                candidates={toolMentions.candidates}
                                highlight={toolMentions.highlight}
                                onChoose={toolMentions.choose}
                                onHighlight={toolMentions.setHighlight}
                            />
                            <ToolMentionChips tools={toolMentions.mentioned} onRemove={toolMentions.remove} />
                            <ChatPromptField
                                ref={textField}
                                data-testid="chat-input"
                                className={`px-1 pt-0.5 text-[15px] leading-6 text-[var(--oa-fg)] placeholder:text-[var(--oa-fg-4)] ${!showSuggestions && properties.showSuggestions && !(inputValue && inputValue.trim().length > 0) && !(conversation as any)?.activeTask ? 'pr-[150px]' : 'pr-1'}`}
                                minRows={2}
                                maxRows={8}
                                placeholder={pendingRequest ? '' : ((conversation as any)?.activeTask ? ((conversation as any).activeTask.userPrompt ? t('chatBotPage.enterResponseToPrompt', { userPrompt: (conversation as any).activeTask.userPrompt }) : t('chatBotPage.enterCommentsToTask', { taskName: ((conversation as any).activeTask.name ?? (conversation as any).activeTask.label ?? (conversation as any).activeTask.taskName ?? (conversation as any).activeTask.taskDefinitionName ?? '') || '' })) : t('chatBotPage.askBrand'))}
                                value={inputValue}
                                disabled={pendingRequest || !!properties.readOnly}
                                onFocus={() => setInputFocussed(true)}
                                onBlur={() => setInputFocussed(false)}
                                onValueChange={setInputValue}
                                onKeyDown={onKeyDown}
                                onSelect={toolMentions.syncCaret}
                                onClick={toolMentions.syncCaret}
                                aria-expanded={toolMentions.open}
                            />
                            </>
                            )}
                        </>
                    )}
                    {/* Aktionszeile im Zuschnitt von beuis `PromptInput`: links
                        das Beiwerk (Werkzeug, Anhänge, Data Pool), rechts das
                        Diktat und der eine runde Knopf, der zwischen Senden und
                        Anhalten wechselt. Ein Aufbau für alle Breiten — die
                        früheren zwei Parallelblöcke (Desktop/mobil) sind
                        zusammengeführt. */}
                    {!isSliderTask && !isTextInputTask && !isConfirmationTask && !isSelectTask && !isFormTask && !checklistReady && (
                    <div className='mt-1 flex min-h-8 items-center gap-1'>
                        {/* Im Prozessmodus geht die Antwort am Werkzeug-Routing
                            der AI vorbei — dort steht die Wahl nicht. */}
                        {!conversationHasActiveTask &&
                            isSystemAdminUser(authentication) &&
                            (properties.customerToolsLoading || (properties.customerTools?.length ?? 0) > 0) && (
                            <ToolSelector
                                tools={properties.customerTools ?? []}
                                selectedToolId={properties.selectedToolId ?? ''}
                                onToolChange={properties.onToolChange ?? (() => {})}
                                disabled={pendingRequest}
                                loading={properties.customerToolsLoading}
                            />
                        )}
                        {/* Der Umschalter „Real-Insight Modus" ist auf diesem Branch entfernt: Es
                            gibt nichts umzuschalten, jeder Zug geht durch die Schleife. Ein Knopf,
                            der immer denselben Zustand zeigt, behauptet eine Wahl, die es nicht
                            gibt — und genau die hat mehrfach in die Irre geführt. */}
                        {/* Nur Ansicht: keine Wege, etwas beizulegen. Wer hier
                            nichts beantworten kann, bekommt auch kein Angebot
                            dazu. */}
                        {properties.readOnly ? null : (
                            <>
                                <TooltipHost content={conversationHasActiveTask ? t('chatExchange.dragFilesToAddToProcess') : t('chatExchange.uploadFiles')}>
                                    <MotionButton
                                        type='button'
                                        variant='ghost'
                                        size='icon'
                                        data-testid='chat-upload-files'
                                        aria-label={t('chatExchange.uploadFiles')}
                                        className={composerIconClass}
                                        style={conversationHasActiveTask ? { color: processAccent } : undefined}
                                        onClick={() => fileInputRef.current?.click()}
                                    >
                                        <Paperclip className='h-4 w-4' aria-hidden />
                                    </MotionButton>
                                </TooltipHost>
                                <TooltipHost content={t('chatExchange.pickFromStorage')}>
                                    <MotionButton
                                        type='button'
                                        variant='ghost'
                                        size='icon'
                                        data-testid='chat-pick-from-storage'
                                        aria-label={t('chatExchange.pickFromStorage')}
                                        className={composerIconClass}
                                        style={conversationHasActiveTask ? { color: processAccent } : undefined}
                                        onClick={() => setStoragePickerOpen(true)}
                                    >
                                        <Folder className='h-4 w-4' aria-hidden />
                                    </MotionButton>
                                </TooltipHost>
                            </>
                        )}
                        {conversation?._id && (
                            <TooltipHost content={t('chatExchange.dataPoolContent')}>
                                <MotionButton
                                    type='button'
                                    variant='ghost'
                                    size='icon'
                                    data-testid='chat-data-pool'
                                    aria-label={t('chatExchange.dataPoolContent')}
                                    className={composerIconClass}
                                    style={conversationHasActiveTask ? { color: processAccent } : undefined}
                                    onClick={handleOpenDataPoolDialog}
                                >
                                    <Database className='h-4 w-4' aria-hidden />
                                </MotionButton>
                            </TooltipHost>
                        )}
                        <div className='ml-auto flex items-center gap-1'>
                        {(() => {
                            // Ein abgebrochener Lauf, der auf die Wiederaufnahme
                            // wartet, zeigt hier nichts: die Wiederaufnahme
                            // steckt in der Nachricht selbst.
                            if (manualReconnectAvailable && !pendingRequest) return null;

                            const stopRun = async () => {
                                // Stop belongs to the conversation on screen; a run of
                                // another conversation keeps going.
                                const stoppedConversationId = conversationRef.current?._id ?? null;
                                try {
                                    // Abort the current request
                                    const stoppedRun = getChatRun(runsRef.current, stoppedConversationId);
                                    if (stoppedRun?.abortController) {
                                        stoppedRun.abortCause = USER_ABORT_REASON;
                                        stoppedRun.abortController.abort(USER_ABORT_REASON);
                                        stoppedRun.abortController = null;
                                    }

                                    // Reset pending state immediately
                                    setRunPending(stoppedConversationId, false);
                                    setManualReconnectAvailable(stoppedConversationId, false);

                                    // Persist the interruption to the server
                                    if (conversationRef.current && conversationRef.current._id) {
                                        try {
                                            const updatedConversation = await userAPI.interruptConversation(
                                                authentication.customer,
                                                conversationRef.current._id
                                            );

                                            // Update the conversation with the server response
                                            applyIncomingConversation(updatedConversation);
                                        } catch (serverError) {
                                            console.error('Failed to persist conversation interruption:', serverError);
                                            // Fallback: Add cancellation message locally
                                            const newConversation = cloneConversation(conversationRef.current);
                                            newConversation.messages.push(new Message({
                                                type: MessageType.botMessage,
                                                content: t('chatMessages.requestCancelled'),
                                                confirmation: false,
                                                resources: []
                                            }));
                                            setConversation(newConversation);
                                        }
                                    } else {
                                        // Fallback: Add cancellation message locally if no conversation ID
                                        const newConversation = cloneConversation(conversationRef.current);
                                        newConversation.messages.push(new Message({
                                            type: MessageType.botMessage,
                                            content: t('chatMessages.requestCancelled'),
                                            confirmation: false,
                                            resources: []
                                        }));
                                        setConversation(newConversation);
                                    }

                                    // Auto-scroll disabled
                                } catch (error) {
                                    console.error('Error during abort operation:', error);
                                    // Ensure pending state is reset even if there's an error
                                    setRunPending(stoppedConversationId, false);
                                    setManualReconnectAvailable(stoppedConversationId, false);
                                }
                            };

                            // Die noch ladende Checkliste hat ihren eigenen
                            // Absender — kein Freitext, also auch kein Diktat.
                            const checklistSendMode = !pendingRequest && isChecklistTask && !checklistLoadFailed;
                            const checklistSendBlocked = !checklistReady || isUploading || !checklistComplete || taskAction !== 'complete';
                            const hasInput = !!inputValue && inputValue.trim().length > 0;
                            const sendBlocked = sendBlockedByUpload || !hasInput;
                            const swapTransition = reduceMotion ? { duration: 0 } : SPRING_SWAP;

                            return (
                                <>
                                    {!pendingRequest && !checklistSendMode && (
                                        transcribing ? (
                                            <MotionButton
                                                type='button'
                                                variant='ghost'
                                                size='icon'
                                                data-testid='chat-stop-recording'
                                                aria-label='Stop Recording'
                                                className={`${composerIconClass} text-destructive hover:text-destructive`}
                                                onClick={() => setTranscribing(false)}
                                            >
                                                <CircleStop className='pulsing h-4 w-4' aria-hidden />
                                            </MotionButton>
                                        ) : (
                                            <MotionButton
                                                type='button'
                                                variant='ghost'
                                                size='icon'
                                                data-testid='chat-record'
                                                aria-label='Start Recording'
                                                className={composerIconClass}
                                                style={conversationHasActiveTask ? { color: processAccent } : undefined}
                                                disabled={isUploading}
                                                onClick={() => !isUploading && setTranscribing(true)}
                                            >
                                                <Mic className='h-4 w-4' aria-hidden />
                                            </MotionButton>
                                        )
                                    )}
                                    {checklistSendMode ? (
                                        <MotionButton
                                            type='button'
                                            size='icon'
                                            data-testid='chat-checklist-send'
                                            aria-label='Send'
                                            disabled={checklistSendBlocked}
                                            onClick={() => {
                                                if (checklistSendBlocked) return;
                                                submitInput('');
                                            }}
                                            className='h-9 w-9 shrink-0 rounded-full text-white'
                                            style={{ backgroundColor: processAccent }}
                                            title={
                                                checklistReady
                                                    ? taskAction !== 'complete'
                                                        ? t('chatBotPage.completeTask')
                                                        : checklistComplete
                                                        ? undefined
                                                        : t('checklist.notCompleteHint', {
                                                            defaultValue: 'Fill all required (*) fields to enable completion.',
                                                        })
                                                    : checklistLoadFailed
                                                        ? t('checklist.loadFailedHint', {
                                                            defaultValue: 'Checklist could not be loaded. Retry to continue.',
                                                        })
                                                        : t('checklist.loadingHint', {
                                                            defaultValue: 'Checklist is still loading.',
                                                        })
                                            }
                                        >
                                            <ArrowUp className='h-4 w-4' aria-hidden />
                                        </MotionButton>
                                    ) : (
                                        // Ein Knopf, zwei Aufgaben: der Pfeil weicht
                                        // dem Quadrat, sobald der Lauf beginnt, und
                                        // die Fläche wechselt auf den Warnton.
                                        <MotionButton
                                            type='button'
                                            size='icon'
                                            data-testid={pendingRequest ? 'chat-stop' : 'chat-send'}
                                            aria-label={pendingRequest ? 'Stop Request' : 'Send'}
                                            disabled={pendingRequest ? false : sendBlocked}
                                            onClick={pendingRequest
                                                ? () => { void stopRun(); }
                                                : () => { if (!sendBlocked) submitTaskInput(inputValue); }}
                                            className={`h-9 w-9 shrink-0 rounded-full ${pendingRequest
                                                ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90'
                                                : 'bg-primary text-primary-foreground hover:bg-primary/90'}`}
                                            style={!pendingRequest && conversationHasActiveTask ? { backgroundColor: processAccent } : undefined}
                                        >
                                            <AnimatePresence initial={false} mode='popLayout'>
                                                <motion.span
                                                    key={pendingRequest ? 'stop' : 'send'}
                                                    initial={reduceMotion ? { opacity: 1 } : { opacity: 0, y: 3, scale: 0.8 }}
                                                    animate={{ opacity: 1, y: 0, scale: 1 }}
                                                    exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: -3, scale: 0.8 }}
                                                    transition={swapTransition}
                                                    className='grid place-items-center'
                                                >
                                                    {pendingRequest
                                                        ? <Square className='h-3 w-3 fill-current' aria-hidden />
                                                        : <ArrowUp className='h-4 w-4' aria-hidden />}
                                                </motion.span>
                                            </AnimatePresence>
                                        </MotionButton>
                                    )}
                                </>
                            );
                        })()}
                        </div>
                    </div>
                    )}
                </div>
            </div>
            </div>
                    </>
                );
            })()}
            <div className="mt-4 px-0 pb-2 pt-1 text-center text-[11px] text-muted-foreground">
                {t('chatBotPage.aiDisclaimer')}
            </div>

            {/* Data Pool Dialog */}
            {dataPoolDialogOpen && (
            <Dialog
                open
                onOpenChange={(open) => { if (!open) setDataPoolDialogOpen(false); }}
            >
              <DialogContent
                data-testid="chat-data-pool-dialog"
                className="max-w-none"
                style={{ maxWidth: 1800, minWidth: 1600 }}
              >
                <DialogHeader>
                    <DialogTitle>{t('chatExchange.dataPool')}</DialogTitle>
                </DialogHeader>
                <div className="p-4">
                    {/* Refresh controls */}
                    <div className="mb-4 flex items-center justify-between">
                        <div className="text-xs text-muted-foreground">
                            {t('chatExchange.dataPoolNextLoad', { seconds: dataPoolRefreshCountdown })}
                        </div>
                        <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            className="gap-2"
                            data-testid="chat-data-pool-refresh"
                            onClick={handleRefreshDataPool}
                            disabled={dataPoolLoading}
                        >
                            <RefreshCw className="h-4 w-4" />
                            {t('chatExchange.dataPoolRefreshNow')}
                        </Button>
                    </div>

                    <div className="max-h-[600px] overflow-auto" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' } as React.CSSProperties}>
                        {dataPoolLoading ? (
                            <div className="p-10 text-center">
                                {t('global.loading')}
                            </div>
                        ) : dataPoolData.length === 0 ? (
                            <div className="p-10 text-center text-muted-foreground">
                                {t('chatExchange.noDataPoolItems')}
                            </div>
                        ) : (
                        <DataTable
                            columns={[
                                {
                                    id: 'name',
                                    accessorFn: (row: any) => row.name || '',
                                    enableSorting: true,
                                    size: 200,
                                    header: ({ column }: any) => (
                                        <SortableHeader column={column}>{t('chatExchange.dataPoolName')}</SortableHeader>
                                    ),
                                    cell: ({ getValue }: any) => <span className="whitespace-normal break-words">{String(getValue() ?? '')}</span>,
                                },
                                {
                                    id: 'description',
                                    accessorFn: (row: any) => row.description || '',
                                    enableSorting: true,
                                    size: 350,
                                    header: ({ column }: any) => (
                                        <SortableHeader column={column}>{t('chatExchange.dataPoolDescription')}</SortableHeader>
                                    ),
                                    cell: ({ row }: any) => {
                                        const desc = row.original.description || '';
                                        if (!desc) return <span></span>;

                                        return (
                                            <DataPoolCopyableCell
                                                text={desc}
                                                label={t('chatExchange.dataPoolDescription')}
                                                monospace={false}
                                            />
                                        );
                                    },
                                },
                                {
                                    id: 'schema',
                                    accessorFn: (row: any) => {
                                        if (row.schema) {
                                            return typeof row.schema === 'string'
                                                ? row.schema
                                                : JSON.stringify(row.schema);
                                        }
                                        return '';
                                    },
                                    enableSorting: false,
                                    size: 350,
                                    header: () => <>{t('chatExchange.dataPoolSchema')}</>,
                                    cell: ({ row }: any) => {
                                        if (!row.original.schema) return <span></span>;

                                        return (
                                            <DataPoolCopyableCell
                                                text={
                                                    typeof row.original.schema === 'string'
                                                        ? row.original.schema
                                                        : JSON.stringify(row.original.schema, null, 2)
                                                }
                                                label={t('chatExchange.dataPoolSchema')}
                                                monospace={true}
                                            />
                                        );
                                    },
                                },
                                {
                                    id: 'data',
                                    accessorFn: (row: any) => {
                                        if (!row.data) return '';
                                        if (typeof row.data === 'string') {
                                            return row.data;
                                        }
                                        return JSON.stringify(row.data);
                                    },
                                    enableSorting: false,
                                    size: 350,
                                    header: () => <>{t('chatExchange.dataPoolData')}</>,
                                    cell: ({ row }: any) => {
                                        if (!row.original.data) return <span></span>;

                                        const isString = typeof row.original.data === 'string';
                                        return (
                                            <DataPoolCopyableCell
                                                text={isString ? row.original.data : JSON.stringify(row.original.data, null, 2)}
                                                label={t('chatExchange.dataPoolData')}
                                                monospace={!isString}
                                            />
                                        );
                                    },
                                },
                                {
                                    id: 'source',
                                    accessorFn: (row: any) => row.source || '',
                                    enableSorting: true,
                                    size: 100,
                                    header: ({ column }: any) => (
                                        <SortableHeader column={column}>{t('chatExchange.dataPoolSource')}</SortableHeader>
                                    ),
                                    cell: ({ getValue }: any) => <span>{String(getValue() ?? '')}</span>,
                                },
                                {
                                    id: 'node',
                                    accessorFn: (row: any) => row.node || '',
                                    enableSorting: true,
                                    size: 150,
                                    header: ({ column }: any) => (
                                        <SortableHeader column={column}>{t('chatExchange.dataPoolNode')}</SortableHeader>
                                    ),
                                    cell: ({ getValue }: any) => <span>{String(getValue() ?? '')}</span>,
                                },
                            ] as ColumnDef<any, any>[]}
                            data={dataPoolData}
                            pageSize={10}
                            emptyMessage={t('chatExchange.noDataPoolItems')}
                        />
                        )}
                    </div>
                </div>
                <DialogFooter>
                    <Button type="button" data-testid="chat-data-pool-close" onClick={() => setDataPoolDialogOpen(false)}>
                        {t('global.close')}
                    </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
            )}
            {documentMarkdownDialog && (
            <Dialog
                open
                onOpenChange={(open) => { if (!open) setDocumentMarkdownDialog(null); }}
            >
              <DialogContent
                data-testid="chat-document-markdown-dialog"
                className="max-w-none"
                style={{ maxWidth: 800, minWidth: 500 }}
              >
                <DialogHeader>
                    <DialogTitle>
                        {t('chatExchange.documentMarkdownTitle', { filename: documentMarkdownDialog.doc?.filename || '' })}
                    </DialogTitle>
                </DialogHeader>
                <div className="markdown max-h-[70vh] overflow-auto p-4">
                    <Markdown
                        rehypePlugins={[rehypeRaw] as any}
                        remarkPlugins={[remarkGfm]}
                    >
                        {collapseRunawayCharRuns((documentMarkdownDialog.doc?.markdown || documentMarkdownDialog.doc?.content || '') as string)}
                    </Markdown>
                </div>
                <DialogFooter>
                    <Button type="button" data-testid="chat-document-markdown-close" onClick={() => setDocumentMarkdownDialog(null)}>
                        {t('global.close')}
                    </Button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
            )}
            <ProcessHistoryModal
                processInstanceId={processHistoryOpen ? processInstanceId : null}
                onDismiss={() => setProcessHistoryOpen(false)}
            />
        </div>
        </>
    );
};

// Replaces the chat input when the active UserTask declares a bot
// uxElement (`cli-bot`, `browser-bot`, or legacy `client-bot`). Submits
// the task to the locally-installed browser-bot extension; falls back to
// inline error messages when the extension is not available.
interface ClientBotInvokeButtonProps {
    activeTask: any;
    authentication: any;
    conversationId?: string;
    customer?: string;
    hasActiveRun?: boolean;
    onRunStarted?: (runId: string) => void;
    onRunError?: (error: string) => void;
}

const ClientBotInvokeButton: React.FC<ClientBotInvokeButtonProps> = ({
    activeTask,
    authentication,
    conversationId,
    customer,
    hasActiveRun = false,
    onRunStarted,
    onRunError,
}) => {
    const { t } = useTranslation();
    const [pending, setPending] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const botPrompt = activeTask?.triAttrs?.botPrompt ?? activeTask?.botPrompt ?? '';

    const handleClick = async () => {
        if (pending || hasActiveRun) return;
        setPending(true);
        setError(null);

        // Best-effort fetch of the conversation's data pool for processVariables.
        let processVariables: Record<string, unknown> = {};
        if (customer && conversationId) {
            try {
                const res = await authenticatedFetch(
                    `${configuration.serverUrl}/${customer}/conversations/${conversationId}/data-pool`,
                    { method: 'GET', headers: { 'Content-Type': 'application/json' } },
                );
                if (res.ok) {
                    const data = await res.json();
                    const items = Array.isArray(data) ? data : (Array.isArray(data?.items) ? data.items : []);
                    for (const item of items) {
                        if (item && typeof item.name === 'string') {
                            processVariables[item.name] = item.data;
                        }
                    }
                }
            } catch {
                // best-effort — submit with empty processVariables on failure
            }
        }

        try {
            const result = await submitClientBotTask({
                activeTask,
                authentication: { id: authentication?.id, customer: authentication?.customer },
                processVariables,
            });
            if (result.ok && result.runId) {
                // Mark the run active before re-enabling the button to avoid a
                // click window where a second run can be started.
                onRunStarted?.(result.runId);
            } else {
                const msg = result.error ?? 'Unknown error';
                setError(msg);
                onRunError?.(msg);
            }
        } catch (err: any) {
            const msg = err?.message ?? 'Unknown error';
            setError(msg);
            onRunError?.(msg);
        } finally {
            setPending(false);
        }
    };

    return (
        <div className="flex grow flex-col gap-1.5">
            {botPrompt && (
                <div className="text-xs italic text-muted-foreground">
                    {botPrompt}
                </div>
            )}
            <Button
                type="button"
                size="sm"
                className="gap-2 self-start"
                data-testid="chat-call-bot"
                onClick={handleClick}
                disabled={pending || hasActiveRun}
            >
                <Rocket className="h-4 w-4" />
                {t('chatBotPage.callBot')}
            </Button>
            {error && (
                <Alert variant="destructive" className="flex items-start gap-3">
                    <XCircle className="h-4 w-4" />
                    <AlertDescription className="flex-1">
                        {t('chatBotPage.botCallFailed', { error })}
                    </AlertDescription>
                </Alert>
            )}
        </div>
    );
};

